export const dcat = `@prefix adms: <http://www.w3.org/ns/adms#> .
@prefix bibo: <http://purl.org/ontology/bibo/> .
@prefix dcat: <http://www.w3.org/ns/dcat#> .
@prefix dcterms: <http://purl.org/dc/terms/> .
@prefix dctype: <http://purl.org/dc/dcmitype/> .
@prefix foaf: <http://xmlns.com/foaf/0.1/> .
@prefix org: <http://www.w3.org/ns/org#> .
@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix prov: <http://www.w3.org/ns/prov#> .
@prefix pav: <http://purl.org/pav/> .
@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix sdo: <http://schema.org/> .
@prefix skos: <http://www.w3.org/2004/02/skos/core#> .
@prefix vann: <http://purl.org/vocab/vann/> .
@prefix vcard: <http://www.w3.org/2006/vcard/ns#> .
@prefix xhv: <http://www.w3.org/1999/xhtml/vocab#> .
@prefix xsd: <http://www.w3.org/2001/XMLSchema#> .

<http://www.w3.org/ns/dcat>
  a owl:Ontology ;
  adms:versionNotes "Esta es una copia del vocabulario DCAT 3 disponible en https://www.w3.org/ns/dcat.ttl"@es ;
  adms:versionNotes "This is an updated copy of the DCAT 3 vocabulary, taken from https://www.w3.org/ns/dcat.ttl"@en ;
  adms:versionNotes "Dette er en opdateret kopi af DCAT 3 som er tilgænglig på https://www.w3.org/ns/dcat.ttl"@da ;
  adms:versionNotes "Questa è una copia aggiornata del vocabolario DCAT 3 disponibile in https://www.w3.org/ns/dcat.ttl"@it ;
  adms:versionNotes "Toto je aktualizovaná kopie slovníku DCAT 3, převzatá z https://www.w3.org/ns/dcat.ttl"@cs ;
  bibo:editor [
      a foaf:Person ;
      foaf:homepage <https://w3id.org/people/ralbertoni/> ;
      foaf:name "Riccardo Albertoni" ;
      rdfs:seeAlso <https://orcid.org/0000-0001-5648-2713> ;
    ] ;
  bibo:editor [
      a foaf:Person ;
      foaf:name "David Browning" ;
    ] ;
  bibo:editor [
      a foaf:Person ;
      foaf:name "Simon J D Cox" ;
      foaf:workInfoHomepage <http://people.csiro.au/Simon-Cox> ;
      org:memberOf [
          foaf:homepage <https://www.csiro.au> ;
          foaf:name "Commonwealth Scientific and Industrial Research Organisation" ;
        ] ;
      rdfs:seeAlso <https://orcid.org/0000-0002-3884-3420> ;
    ] ;
  bibo:editor [
      a foaf:Person ;
      foaf:homepage <https://agbeltran.github.io> ;
      foaf:name "Alejandra Gonzalez-Beltran" ;
      org:memberOf [
          foaf:homepage <http://stfc.ac.uk> ;
          foaf:name "Science and Technology Facilities Council, UK" ;
        ] ;
      rdfs:seeAlso <https://orcid.org/0000-0003-3499-8262> ;
    ] ;
  bibo:editor [
      a foaf:Person ;
      foaf:name "Andrea Perego" ;
      rdfs:seeAlso <https://orcid.org/0000-0001-9300-2694> ;
    ] ;
  bibo:editor [
      a foaf:Person ;
      foaf:name "Peter Winstanley" ;
    ] ;
  bibo:translator [
      a foaf:Person ;
      foaf:homepage <http://www.asahi-net.or.jp/~ax2s-kmtn/> ;
      foaf:name "Shuji Kamitsuna" ;
    ] ;
  bibo:translator [
      a foaf:Person ;
      foaf:homepage <https://jakub.klímek.com/> ;
      foaf:name "Jakub Klímek" ;
      rdfs:seeAlso <https://jakub.klímek.com/#me> ;
    ] ;
  bibo:translator [
      a foaf:Person ;
      foaf:name "Fadi Maali" ;
      org:memberOf [
          foaf:homepage <http://www.deri.ie/> ;
          foaf:name "DERI, NUI Galway" ;
        ] ;
    ] ;
  bibo:translator [
      a foaf:Person ;
      foaf:name "Anna Odgaard Ingram" ;
    ] ;
  bibo:translator [
      a foaf:Person ;
      foaf:name "Vassilios Peristeras" ;
      org:memberOf [
          foaf:homepage <http://ec.europa.eu/dgs/informatics/> ;
          foaf:name "European Commission, DG DIGIT" ;
        ] ;
    ] ;
  dcat:hasCurrentVersion <http://www.w3.org/ns/dcat3> ;
  dcat:hasVersion <http://www.w3.org/ns/dcat2014> ;
  dcat:hasVersion <http://www.w3.org/ns/dcat2> ;
  dcat:hasVersion <http://www.w3.org/ns/dcat3> ;
  dcat:previousVersion <http://www.w3.org/ns/dcat2> ;
  dcat:version "3" ;
  dcterms:contributor [
      a foaf:Person ;
      foaf:homepage <http://makxdekkers.com/> ;
      foaf:name "Makx Dekkers" ;
      rdfs:seeAlso <http://makxdekkers.com/makxdekkers.rdf#me> ;
    ] ;
  dcterms:created "2020-12-17"^^xsd:date ;
  dcterms:creator <https://www.w3.org/groups/wg/dx> ;
  dcterms:description "DCAT es un vocabulario RDF diseñado para facilitar la interoperabilidad entre catálogos de datos publicados en la Web. Utilizando DCAT para describir datos disponibles en catálogos se aumenta la posibilidad de que sean descubiertos y se permite que las aplicaciones consuman fácilmente los metadatos de varios catálogos."@es ;
  dcterms:description "DCAT est un vocabulaire développé pour faciliter l'interopérabilité entre les jeux de données publiées sur le Web. En utilisant DCAT pour décrire les jeux de données dans les catalogues de données, les fournisseurs de données facilitent leur découverte et permettent que les applications consomment facilement les métadonnées de plusieurs catalogues. Il permet de plus la publication décentralisée des catalogues et facilite la recherche fédérée des données entre plusieurs sites. Les métadonnées DCAT aggrégées peuvent servir comme un manifeste pour faciliter la préservation digitale des ressources. DCAT est définie à l'adresse http://www.w3.org/TR/vocab-dcat/. Toute différence entre ce document normatif et le présent vocabulaire est une erreur dans le vocabulaire."@fr ;
  dcterms:description "DCAT is an RDF vocabulary designed to facilitate interoperability between data catalogs published on the Web. By using DCAT to describe datasets in data catalogs, publishers increase discoverability and enable applications easily to consume metadata from multiple catalogs. It further enables decentralized publishing of catalogs and facilitates federated dataset search across sites. Aggregated DCAT metadata can serve as a manifest file to facilitate digital preservation. DCAT is defined at http://www.w3.org/TR/vocab-dcat/. Any variance between that normative document and this schema is an error in this schema."@en ;
  dcterms:description "DCAT je RDF slovník navržený pro zprostředkování interoperability mezi datovými katalogy publikovanými na Webu. Poskytovatelé dat používáním slovníku DCAT pro popis datových sad v datových katalozích zvyšují jejich dohledatelnost a umožňují aplikacím konzumovat metadata z více katalogů. Dále je umožňena decentralizovaná publikace katalogů a federované dotazování na datové sady napříč katalogy. Agregovaná DCAT metadata mohou také sloužit jako průvodka umožňující digitální uchování informace. DCAT je definován na http://www.w3.org/TR/vocab-dcat/. Jakýkoliv nesoulad mezi odkazovaným dokumentem a tímto schématem je chybou v tomto schématu."@cs ;
  dcterms:description "DCAT è un vocabolario RDF progettato per facilitare l'interoperabilità tra i cataloghi di dati pubblicati nel Web. Utilizzando DCAT per descrivere i dataset nei cataloghi di dati, i fornitori migliorano la capacità di individuazione dei dati e abilitano le  applicazioni al consumo di dati provenienti da cataloghi differenti. DCAT permette di decentralizzare la pubblicazione di cataloghi e facilita la ricerca federata dei dataset. L'aggregazione dei metadati federati può fungere da file manifesto per facilitare la conservazione digitale. DCAT è definito all'indirizzo http://www.w3.org/TR/vocab-dcat/. Qualsiasi scostamento tra tale definizione normativa e questo schema è da considerarsi un errore di questo schema."@it ;
  dcterms:description "DCATは、ウェブ上で公開されたデータ・カタログ間の相互運用性の促進を目的とするRDFの語彙です。このドキュメントでは、その利用のために、スキーマを定義し、例を提供します。データ・カタログ内のデータセットを記述するためにDCATを用いると、公開者が、発見可能性を増加させ、アプリケーションが複数のカタログのメタデータを容易に利用できるようになります。さらに、カタログの分散公開を可能にし、複数のサイトにまたがるデータセットの統合検索を促進します。集約されたDCATメタデータは、ディジタル保存を促進するためのマニフェスト・ファイルとして使用できます。"@ja ;
  dcterms:description "Το DCAT είναι ένα RDF λεξιλόγιο που σχεδιάσθηκε για να κάνει εφικτή τη διαλειτουργικότητα μεταξύ καταλόγων δεδομένων στον Παγκόσμιο Ιστό. Χρησιμοποιώντας το DCAT για την περιγραφή συνόλων δεδομένων, οι εκδότες αυτών αυξάνουν την ανακαλυψιμότητα και επιτρέπουν στις εφαρμογές την εύκολη κατανάλωση μεταδεδομένων από πολλαπλούς καταλόγους. Επιπλέον, δίνει τη δυνατότητα για αποκεντρωμένη έκδοση και διάθεση καταλόγων και επιτρέπει δυνατότητες ενοποιημένης αναζήτησης μεταξύ διαφορετικών πηγών. Συγκεντρωτικά μεταδεδομένα που έχουν περιγραφεί με το DCAT μπορούν να χρησιμοποιηθούν σαν ένα δηλωτικό αρχείο (manifest file) ώστε να διευκολύνουν την ψηφιακή συντήρηση."@el ;
  dcterms:description "هي أنطولوجية تسهل تبادل البيانات بين مختلف الفهارس على الوب. استخدام هذه الأنطولوجية يساعد على اكتشاف قوائم  البيانات المنشورة على الوب و يمكن التطبيقات المختلفة من الاستفادة أتوماتيكيا من البيانات المتاحة من مختلف الفهارس."@ar ;
  dcterms:description "DCAT er et RDF-vokabular som har til formål at understøtte interoperabilitet mellem datakataloger udgivet på nettet. Ved at anvende DCAT til at beskrive datasæt i datakataloger, kan udgivere øge findbarhed og gøre det gøre det lettere for applikationer at anvende metadata fra forskellige kataloger. Derudover understøttes decentraliseret udstilling af kataloger og fødererede datasætsøgninger på tværs af websider. Aggregerede DCAT-metadata kan fungere som fortegnelsesfiler der kan understøtte digital bevaring. DCAT er defineret på http://www.w3.org/TR/vocab-dcat/. Enhver forskel mellem det normative dokument og dette schema er en fejl i dette schema."@da ;
# TO BE ADDED BEFORE PUBLICATION IN W3C SPACE
#  dcterms:issued ""^^xsd:date ;
  dcterms:license <https://creativecommons.org/licenses/by/4.0/> ;
  dcterms:modified "2020-11-30"^^xsd:date ;
  dcterms:modified "2021-03-09"^^xsd:date ;
  dcterms:modified "2021-04-08"^^xsd:date ;
  dcterms:modified "2021-06-23"^^xsd:date ;
  dcterms:modified "2021-09-27"^^xsd:date ;
  dcterms:modified "2022-03-22"^^xsd:date ;
  dcterms:modified "2022-05-23"^^xsd:date ;
  dcterms:modified "2023-01-05"^^xsd:date ;
  dcterms:publisher [
      a org:Organization;
      foaf:homepage <https://www.w3.org/>;
      foaf:name "World Wide Web Consortium (W3C)";
      rdfs:seeAlso <https://www.wikidata.org/entity/Q37033>;
  ] ;
  dcterms:title "El vocabulario de catálogo de datos"@es ;
  dcterms:title "Il vocabolario del catalogo dei dati"@it ;
  dcterms:title "Le vocabulaire des catalogues de données"@fr ;
  dcterms:title "Slovník pro datové katalogy"@cs ;
  dcterms:title "The data catalog vocabulary"@en ;
  dcterms:title "Το λεξιλόγιο των καταλόγων δεδομένων"@el ;
  dcterms:title "أنطولوجية فهارس قوائم البيانات"@ar ;
  dcterms:title "データ・カタログ語彙（DCAT）"@ja ;
  dcterms:title "Datakatalogvokabular"@da ;
  foaf:depiction <https://www.w3.org/TR/vocab-dcat-3/images/dcat-all-attributes.svg> ;
  owl:backwardCompatibleWith <http://www.w3.org/ns/dcat2> ;
  owl:backwardCompatibleWith <http://www.w3.org/ns/dcat2014> ;
  owl:imports dcterms: ;
  owl:imports <http://www.w3.org/2004/02/skos/core> ;
  owl:imports <http://www.w3.org/ns/prov-o#> ;
  owl:priorVersion <http://www.w3.org/ns/dcat2> ;
  owl:versionInfo "3" ;
  owl:versionIRI <http://www.w3.org/ns/dcat3> ;
  rdfs:comment "DCAT es un vocabulario RDF diseñado para facilitar la interoperabilidad entre catálogos de datos publicados en la Web. Utilizando DCAT para describir datos disponibles en catálogos se aumenta la posibilidad de que sean descubiertos y se permite que las aplicaciones consuman fácilmente los metadatos de varios catálogos."@es ;
  rdfs:comment "DCAT est un vocabulaire développé pour faciliter l'interopérabilité entre les jeux de données publiées sur le Web. En utilisant DCAT pour décrire les jeux de données dans les catalogues de données, les fournisseurs de données facilitent leur découverte et permettent que les applications consomment facilement les métadonnées de plusieurs catalogues. Il permet de plus la publication décentralisée des catalogues et facilite la recherche fédérée des données entre plusieurs sites. Les métadonnées DCAT aggrégées peuvent servir comme un manifeste pour faciliter la préservation digitale des ressources. DCAT est définie à l'adresse http://www.w3.org/TR/vocab-dcat/. Toute différence entre ce document normatif et le présent vocabulaire est une erreur dans le vocabulaire."@fr ;
  rdfs:comment "DCAT is an RDF vocabulary designed to facilitate interoperability between data catalogs published on the Web. By using DCAT to describe datasets in data catalogs, publishers increase discoverability and enable applications easily to consume metadata from multiple catalogs. It further enables decentralized publishing of catalogs and facilitates federated dataset search across sites. Aggregated DCAT metadata can serve as a manifest file to facilitate digital preservation. DCAT is defined at http://www.w3.org/TR/vocab-dcat/. Any variance between that normative document and this schema is an error in this schema."@en ;
  rdfs:comment "DCAT je RDF slovník navržený pro zprostředkování interoperability mezi datovými katalogy publikovanými na Webu. Poskytovatelé dat používáním slovníku DCAT pro popis datových sad v datových katalozích zvyšují jejich dohledatelnost a umožňují aplikacím konzumovat metadata z více katalogů. Dále je umožňena decentralizovaná publikace katalogů a federované dotazování na datové sady napříč katalogy. Agregovaná DCAT metadata mohou také sloužit jako průvodka umožňující digitální uchování informace. DCAT je definován na http://www.w3.org/TR/vocab-dcat/. Jakýkoliv nesoulad mezi odkazovaným dokumentem a tímto schématem je chybou v tomto schématu."@cs ;
  rdfs:comment "DCAT è un vocabolario RDF progettato per facilitare l'interoperabilità tra i cataloghi di dati pubblicati nel Web. Utilizzando DCAT per descrivere i dataset nei cataloghi di dati, i fornitori migliorano la capacità di individuazione dei dati e abilitano le  applicazioni al consumo di dati provenienti da cataloghi differenti. DCAT permette di decentralizzare la pubblicazione di cataloghi e facilita la ricerca federata dei dataset. L'aggregazione dei metadati federati può fungere da file manifesto per facilitare la conservazione digitale. DCAT è definito all'indirizzo http://www.w3.org/TR/vocab-dcat/. Qualsiasi scostamento tra tale definizione normativa e questo schema è da considerarsi un errore di questo schema."@it ;
  rdfs:comment "DCATは、ウェブ上で公開されたデータ・カタログ間の相互運用性の促進を目的とするRDFの語彙です。このドキュメントでは、その利用のために、スキーマを定義し、例を提供します。データ・カタログ内のデータセットを記述するためにDCATを用いると、公開者が、発見可能性を増加させ、アプリケーションが複数のカタログのメタデータを容易に利用できるようになります。さらに、カタログの分散公開を可能にし、複数のサイトにまたがるデータセットの統合検索を促進します。集約されたDCATメタデータは、ディジタル保存を促進するためのマニフェスト・ファイルとして使用できます。"@ja ;
  rdfs:comment "Το DCAT είναι ένα RDF λεξιλόγιο που σχεδιάσθηκε για να κάνει εφικτή τη διαλειτουργικότητα μεταξύ καταλόγων δεδομένων στον Παγκόσμιο Ιστό. Χρησιμοποιώντας το DCAT για την περιγραφή συνόλων δεδομένων, οι εκδότες αυτών αυξάνουν την ανακαλυψιμότητα και επιτρέπουν στις εφαρμογές την εύκολη κατανάλωση μεταδεδομένων από πολλαπλούς καταλόγους. Επιπλέον, δίνει τη δυνατότητα για αποκεντρωμένη έκδοση και διάθεση καταλόγων και επιτρέπει δυνατότητες ενοποιημένης αναζήτησης μεταξύ διαφορετικών πηγών. Συγκεντρωτικά μεταδεδομένα που έχουν περιγραφεί με το DCAT μπορούν να χρησιμοποιηθούν σαν ένα δηλωτικό αρχείο (manifest file) ώστε να διευκολύνουν την ψηφιακή συντήρηση."@el ;
  rdfs:comment "هي أنطولوجية تسهل تبادل البيانات بين مختلف الفهارس على الوب. استخدام هذه الأنطولوجية يساعد على اكتشاف قوائم  البيانات المنشورة على الوب و يمكن التطبيقات المختلفة من الاستفادة أتوماتيكيا من البيانات المتاحة من مختلف الفهارس."@ar ;
  rdfs:comment "DCAT er et RDF-vokabular som har til formål at understøtte interoperabilitet mellem datakataloger udgivet på nettet. Ved at anvende DCAT til at beskrive datasæt i datakataloger, kan udgivere øge findbarhed og gøre det gøre det lettere for applikationer at anvende metadata fra forskellige kataloger. Derudover understøttes decentraliseret udstilling af kataloger og fødererede datasætsøgninger på tværs af websider. Aggregerede DCAT-metadata kan fungere som fortegnelsesfiler der kan understøtte digital bevaring. DCAT er defineret på http://www.w3.org/TR/vocab-dcat/. Enhver forskel mellem det normative dokument og dette schema er en fejl i dette schema."@da ;
  rdfs:label "El vocabulario de catálogo de datos"@es ;
  rdfs:label "Il vocabolario del catalogo dei dati"@it ;
  rdfs:label "Le vocabulaire des jeux de données"@fr ;
  rdfs:label "Slovník pro datové katalogy"@cs ;
  rdfs:label "The data catalog vocabulary"@en ;
  rdfs:label "Το λεξιλόγιο των καταλόγων δεδομένων"@el ;
  rdfs:label "أنطولوجية فهارس قوائم البيانات"@ar ;
  rdfs:label "データ・カタログ語彙（DCAT）"@ja ;
  rdfs:label "Datakatalogvokabular"@da ;
  skos:editorialNote "English language definitions updated in this revision in line with ED. Multilingual text unevenly updated."@en ;
  vann:preferredNamespacePrefix "dcat" ;
  vann:preferredNamespaceUri "http://www.w3.org/ns/dcat#" ;
.
dcat:Catalog
  a rdfs:Class ;
  a owl:Class ;
  rdfs:comment "A curated collection of metadata about resources (e.g., datasets and data services in the context of a data catalog)."@en ;
  rdfs:comment "Una colección curada de metadatos sobre recursos (por ejemplo, conjuntos de datos y servicios de datos en el contexto de un catálogo de datos)."@es ;
  rdfs:comment "Una raccolta curata di metadati sulle risorse (ad es. sui dataset e relativi servizi nel contesto di cataloghi di dati)."@it ;
  rdfs:comment "Une collection élaborée de métadonnées sur les jeux de données"@fr ;
  rdfs:comment "Řízená kolekce metadat o datových sadách a datových službách"@cs ;
  rdfs:comment "Μια επιμελημένη συλλογή μεταδεδομένων περί συνόλων δεδομένων"@el ;
  rdfs:comment "مجموعة من توصيفات قوائم البيانات"@ar ;
  rdfs:comment "データ・カタログは、データセットに関するキュレートされたメタデータの集合です。"@ja ;
  rdfs:comment "En udvalgt og arrangeret samling af metadata om ressourcer (fx datasæt og datatjenester i kontekst af et datakatalog). "@da ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "Catalog"@en ;
  rdfs:label "Catalogo"@it ;
  rdfs:label "Catalogue"@fr ;
  rdfs:label "Catálogo"@es ;
  rdfs:label "Katalog"@cs ;
  rdfs:label "Κατάλογος"@el ;
  rdfs:label "فهرس قوائم البيانات"@ar ;
  rdfs:label "カタログ"@ja ;
  rdfs:label "Katalog"@da ;
  rdfs:subClassOf dcat:Dataset ;
  skos:definition "A curated collection of metadata about resources."@en ;
  skos:definition "Una colección curada de metadatos sobre recursos."@es ;
  skos:definition "Una raccolta curata di metadati sulle risorse."@it ;
  skos:definition "Une collection élaborée de métadonnées sur les jeux de données."@fr ;
  skos:definition "Řízená kolekce metadat o datových sadách a datových službách."@cs ;
  skos:definition "Μια επιμελημένη συλλογή μεταδεδομένων περί συνόλων δεδομένων."@el ;
  skos:definition "مجموعة من توصيفات قوائم البيانات"@ar ;
  skos:definition "データ・カタログは、データセットに関するキュレートされたメタデータの集合です。"@ja ;
  skos:definition "En samling af metadata om ressourcer."@da ;
  skos:editorialNote "Multilingual text not completelly updated. Translations for skos:scopeNote and definitions to doublecheck."@en ;
  skos:scopeNote "A web-based data catalog is typically represented as a single instance of this class."@en ;
  skos:scopeNote "Normalmente, un catalogo di dati nel web viene rappresentato come una singola istanza di questa classe."@it ;
  skos:scopeNote "Normalmente, un catálogo de datos disponible en la web se representa como una única instancia de esta clase."@es ;
  skos:scopeNote "Webový datový katalog je typicky reprezentován jako jedna instance této třídy."@cs ;
  skos:scopeNote "Συνήθως, ένας κατάλογος δεδομένων στον Παγκόσμιο Ιστό αναπαρίσταται ως ένα στιγμιότυπο αυτής της κλάσης."@el ;
  skos:scopeNote "通常、ウェブ・ベースのデータ・カタログは、このクラスの1つのインスタンスとして表わされます。"@ja ;
  skos:scopeNote "Et webbaseret datakatalog repræsenteres typisk ved en enkelt instans af denne klasse."@da ;
  skos:scopeNote "Datasets and data services are examples of resources in the context of a data catalog."@en ;
.
dcat:CatalogRecord
  a rdfs:Class ;
  a owl:Class ;
  rdfs:comment "1つのデータセットを記述したデータ・カタログ内のレコード。"@ja ;
  rdfs:comment "A record in a data catalog, describing the registration of a single dataset or data service."@en ;
  rdfs:comment "Un record in un catalogo di dati che descrive un singolo dataset o servizio di dati."@it ;
  rdfs:comment "Un registre du catalogue ou une entrée du catalogue, décrivant un seul jeu de données."@fr ;
  rdfs:comment "Un registro en un catálogo de datos que describe un solo conjunto de datos o un servicio de datos."@es ;
  rdfs:comment "Záznam v datovém katalogu popisující jednu datovou sadu či datovou službu."@cs ;
  rdfs:comment "Μία καταγραφή ενός καταλόγου, η οποία περιγράφει ένα συγκεκριμένο σύνολο δεδομένων."@el ;
  rdfs:comment "En post i et datakatalog der beskriver registreringen af et enkelt datasæt eller en datatjeneste."@da ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "Catalog Record"@en ;
  rdfs:label "Katalogizační záznam"@cs ;
  rdfs:label "Record di catalogo"@it ;
  rdfs:label "Registre du catalogue"@fr ;
  rdfs:label "Registro del catálogo"@es ;
  rdfs:label "Καταγραφή καταλόγου"@el ;
  rdfs:label "سجل"@ar ;
  rdfs:label "カタログ・レコード"@ja ;
  rdfs:label "Katalogpost"@da ;
  rdfs:subClassOf [
      a owl:Restriction ;
      owl:allValuesFrom dcat:Resource ;
      owl:onProperty foaf:primaryTopic ;
    ] ;
  rdfs:subClassOf [
      a owl:Restriction ;
      owl:cardinality "1"^^xsd:nonNegativeInteger ;
      owl:onProperty foaf:primaryTopic ;
    ] ;
  skos:definition "1つのデータセットを記述したデータ・カタログ内のレコード。"@ja ;
  skos:definition "A record in a data catalog, describing the registration of a single dataset or data service."@en ;
  skos:definition "Un record in un catalogo di dati che descrive un singolo dataset o servizio di dati."@it ;
  skos:definition "Un registre du catalogue ou une entrée du catalogue, décrivant un seul jeu de données."@fr ;
  skos:definition "Un registro en un catálogo de datos que describe un solo conjunto de datos o un servicio de datos."@es ;
  skos:definition "Záznam v datovém katalogu popisující jednu datovou sadu či datovou službu."@cs ;
  skos:definition "Μία καταγραφή ενός καταλόγου, η οποία περιγράφει ένα συγκεκριμένο σύνολο δεδομένων."@el ;
  skos:definition "En post i et datakatalog der beskriver registreringen af et enkelt datasæt eller en datatjeneste."@da ;
  skos:editorialNote "English definition updated in this revision. Multilingual text not yet updated except the Spanish one and the Czech one and Italian one."@en ;
  skos:scopeNote "C'est une classe facultative et tous les catalogues ne l'utiliseront pas. Cette classe existe pour les catalogues	ayant une distinction entre les métadonnées sur le jeu de données et les métadonnées sur une entrée du jeu de données dans le catalogue."@fr ;
  skos:scopeNote "Esta clase es opcional y no todos los catálogos la utilizarán. Esta clase existe para catálogos que hacen una distinción entre los metadatos acerca de un conjunto de datos o un servicio de datos y los metadatos acerca de una entrada en ese conjunto de datos en el catálogo. Por ejemplo, la propiedad sobre la fecha de la publicación de los datos refleja la fecha en que la información fue originalmente publicada, mientras que la fecha de publicación del registro del catálogo es la fecha en que los datos se agregaron al mismo. En caso en que ambas fechas fueran diferentes, o en que sólo la fecha de publicación del registro del catálogo estuviera disponible, sólo debe especificarse en el registro del catálogo. Tengan en cuenta que la ontología PROV de W3C permite describir otra información sobre la proveniencia de los datos, como por ejemplo detalles del proceso y de los agentes involucrados en algún cambio específico a los datos."@es ;
  skos:scopeNote "Questa classe è opzionale e non tutti i cataloghi la utilizzeranno. Esiste per cataloghi in cui si opera una distinzione tra i metadati relativi al dataset ed i metadati relativi alla gestione del dataset nel catalogo. Ad esempio, la  proprietà per indicare la data di pubblicazione del dataset rifletterà la data in cui l'informazione è stata originariamente messa a disposizione dalla casa editrice, mentre la data di pubblicazione per il record nel catalogo rifletterà la data in cui il dataset è stato aggiunto al catalogo. Nei casi dove solo quest'ultima sia nota, si utilizzerà esclusivamente la data di  pubblicazione relativa al record del catalogo. Si noti che l'Ontologia W3C PROV permette di descrivere ulteriori informazioni sulla provenienza, quali i dettagli del processo, la procedura e l'agente coinvolto in una particolare modifica di un dataset."@it ;
  skos:scopeNote "Tato třída je volitelná a ne všechny katalogy ji využijí. Existuje pro katalogy, ve kterých se rozlišují metadata datové sady či datové služby a metadata o záznamu o datové sadě či datové službě v katalogu. Například datum publikace datové sady odráží datum, kdy byla datová sada původně zveřejněna poskytovatelem dat, zatímco datum publikace katalogizačního záznamu je datum zanesení datové sady do katalogu. V případech kdy se obě data liší, nebo je známo jen to druhé, by mělo být specifikováno jen datum publikace katalogizačního záznamu. Všimněte si, že ontologie W3C PROV umožňuje popsat další informace o původu jako například podrobnosti o procesu konkrétní změny datové sady a jeho účastnících."@cs ;
  skos:scopeNote "This class is optional and not all catalogs will use it. It exists for catalogs where a distinction is made between metadata about a dataset or data service and metadata about the entry for the dataset or data service in the catalog. For example, the publication date property of the dataset reflects the date when the information was originally made available by the publishing agency, while the publication date of the catalog record is the date when the dataset was added to the catalog. In cases where both dates differ, or where only the latter is known, the publication date should only be specified for the catalog record. Notice that the W3C PROV Ontology allows describing further provenance information such as the details of the process and the agent involved in a particular change to a dataset."@en ;
  skos:scopeNote "Αυτή η κλάση είναι προαιρετική και δεν χρησιμοποιείται από όλους τους καταλόγους. Υπάρχει για τις περιπτώσεις καταλόγων όπου γίνεται διαχωρισμός μεταξύ των μεταδεδομένων για το σύνολο των δεδομένων και των μεταδεδομένων για την καταγραφή του συνόλου δεδομένων εντός του καταλόγου. Για παράδειγμα, η ιδιότητα της ημερομηνίας δημοσίευσης του συνόλου δεδομένων δείχνει την ημερομηνία κατά την οποία οι πληροφορίες έγιναν διαθέσιμες από τον φορέα δημοσίευσης, ενώ η ημερομηνία δημοσίευσης της καταγραφής του καταλόγου δείχνει την ημερομηνία που το σύνολο δεδομένων προστέθηκε στον κατάλογο. Σε περιπτώσεις που οι δύο ημερομηνίες διαφέρουν, ή που μόνο η τελευταία είναι γνωστή, η ημερομηνία δημοσίευσης θα πρέπει να δίνεται για την καταγραφή του καταλόγου. Να σημειωθεί πως η οντολογία W3C PROV επιτρέπει την περιγραφή επιπλέον πληροφοριών ιστορικού όπως λεπτομέρειες για τη διαδικασία και τον δράστη που εμπλέκονται σε μία συγκεκριμένη αλλαγή εντός του συνόλου δεδομένων."@el ;
  skos:scopeNote "このクラスはオプションで、すべてのカタログがそれを用いるとは限りません。これは、データセットに関するメタデータとカタログ内のデータセットのエントリーに関するメタデータとで区別が行われるカタログのために存在しています。例えば、データセットの公開日プロパティーは、公開機関が情報を最初に利用可能とした日付を示しますが、カタログ・レコードの公開日は、データセットがカタログに追加された日付です。両方の日付が異っていたり、後者だけが分かっている場合は、カタログ・レコードに対してのみ公開日を指定すべきです。W3CのPROVオントロジー[prov-o]を用いれば、データセットに対する特定の変更に関連するプロセスやエージェントの詳細などの、さらに詳しい来歴情報の記述が可能となることに注意してください。"@ja ;
  skos:scopeNote "Denne klasse er valgfri og ikke alle kataloger vil anvende denne klasse. Den kan anvendes i de kataloger hvor der skelnes mellem metadata om datasættet eller datatjenesten og metadata om selve posten til registreringen af datasættet eller datatjenesten i kataloget. Udgivelsesdatoen for datasættet afspejler for eksempel den dato hvor informationerne oprindeligt blev gjort tilgængelige af udgiveren, hvorimod udgivelsesdatoen for katalogposten er den dato hvor datasættet blev føjet til kataloget. I de tilfælde hvor de to datoer er forskellige eller hvor blot sidstnævnte er kendt, bør udgivelsesdatoen kun angives for katalogposten. Bemærk at W3Cs PROV ontologi gør til muligt at tilføje yderligere proveniensoplysninger eksempelvis om processen eller aktøren involveret i en given ændring af datasættet."@da;
.
dcat:DataService
  a rdfs:Class ;
  a owl:Class ;
  rdfs:comment "A site or end-point providing operations related to the discovery of, access to, or processing functions on, data or related resources."@en ;
  rdfs:comment "Umístění či přístupový bod poskytující operace související s hledáním, přistupem k, či výkonem funkcí na datech či souvisejících zdrojích."@cs ;
  rdfs:comment "Un sitio o end-point que provee operaciones relacionadas a funciones de descubrimiento, acceso, o procesamiento de datos o recursos relacionados."@es ;
  rdfs:comment "Un sito o end-point che fornisce operazioni relative alla scoperta, all'accesso o all'elaborazione di funzioni su dati o risorse correlate."@it ;
  rdfs:comment "Et websted eller endpoint der udstiller operationer relateret til opdagelse af, adgang til eller behandlende funktioner på data eller relaterede ressourcer."@da ;
  rdfs:label "Data service"@en ;
  rdfs:label "Servizio di dati"@it ;
  rdfs:label "Servicio de datos"@es ;
  rdfs:label "Datatjeneste"@da ;
  rdfs:subClassOf dctype:Service ;
  rdfs:subClassOf dcat:Resource ;
  skos:altLabel "Dataservice"@da ;
  skos:changeNote "New class added in DCAT 2."@en ;
  skos:changeNote "Nová třída přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva clase añadida en DCAT 2."@es ;
  skos:changeNote "Nuova classe aggiunta in DCAT 2."@it ;
  skos:changeNote "Ny klasse tilføjet i DCAT 2."@da ;
  skos:definition "A site or end-point providing operations related to the discovery of, access to, or processing functions on, data or related resources."@en ;
  skos:definition "Umístění či přístupový bod poskytující operace související s hledáním, přistupem k, či výkonem funkcí na datech či souvisejících zdrojích."@cs ;
  skos:definition "Un sitio o end-point que provee operaciones relacionadas a funciones de descubrimiento, acceso, o procesamiento de datos o recursos relacionados."@es ;
  skos:definition "Un sito o end-point che fornisce operazioni relative alla scoperta, all'accesso o all'elaborazione di funzioni su dati o risorse correlate."@it ;
  skos:definition "Et site eller endpoint der udstiller operationer relateret til opdagelse af, adgang til eller behandlende funktioner på data eller relaterede ressourcer."@da ;
  skos:scopeNote "Druh služby může být indikován vlastností dcterms:type. Její hodnota může být z řízeného slovníku, kterým je například slovník typů prostorových datových služeb INSPIRE."@cs ;
  skos:scopeNote "El tipo de servicio puede indicarse usando la propiedad dcterms:type. Su valor puede provenir de un vocabulario controlado, como por ejemplo el vocabulario de servicios de datos espaciales de INSPIRE."@es ;
  skos:scopeNote "If a dcat:DataService is bound to one or more specified Datasets, they are indicated by the dcat:servesDataset property."@en ;
  skos:scopeNote "Il tipo di servizio può essere indicato usando la proprietà dcterms:type. Il suo valore può essere preso da un vocabolario controllato come il vocabolario dei tipi di servizi per dati spaziali di INSPIRE."@it ;
  skos:scopeNote "Pokud je dcat:DataService navázána na jednu či více Datových sad, jsou tyto indikovány vlstností dcat:servesDataset."@cs ;
  skos:scopeNote "Se un dcat:DataService è associato a uno o più Dataset specificati, questi sono indicati dalla proprietà dcat:serveDataset."@it ;
  skos:scopeNote "Si un dcat:DataService está asociado con uno o más conjuntos de datos especificados, dichos conjuntos de datos pueden indicarse con la propiedad dcat:servesDataset."@es ;
  skos:scopeNote "The kind of service can be indicated using the dcterms:type property. Its value may be taken from a controlled vocabulary such as the INSPIRE spatial data service type vocabulary."@en ;
  skos:scopeNote "Datatjenestetypen kan indikeres ved hjælp af egenskaben dcterms:type. Værdien kan tages fra kontrollerede udfaldsrum såsom INSPIRE spatial data service vocabulary."@da ;
  skos:scopeNote "Hvis en dcat:DataService er bundet til en eller flere specifikke datasæt kan dette indikeres ved hjælp af egenskaben dcat:servesDataset. "@da ;
.
dcat:Dataset
  a rdfs:Class ;
  a owl:Class ;
  rdfs:comment "1つのエージェントによって公開またはキュレートされ、1つ以上の形式でアクセスまたはダウンロードできるデータの集合。"@ja ;
  rdfs:comment "A collection of data, published or curated by a single source, and available for access or download in one or more representations."@en ;
  rdfs:comment "Kolekce dat poskytovaná či řízená jedním zdrojem, která je k dispozici pro přístup či stažení v jednom či více formátech."@cs ;
  rdfs:comment "Raccolta di dati, pubblicati o curati da un'unica fonte, disponibili per l'accesso o il download in uno o più formati."@it ;
  rdfs:comment "Una colección de datos, publicados o conservados por una única fuente, y disponibles para ser accedidos o descargados en uno o más formatos."@es ;
  rdfs:comment "Une collection de données, publiée ou élaborée par une seule source, et disponible pour accès ou téléchargement dans un ou plusieurs formats."@fr ;
  rdfs:comment "Μία συλλογή από δεδομένα, δημοσιευμένη ή επιμελημένη από μία και μόνο πηγή, διαθέσιμη δε προς πρόσβαση ή μεταφόρτωση σε μία ή περισσότερες μορφές."@el ;
  rdfs:comment "قائمة بيانات منشورة أو مجموعة من قبل مصدر ما و متاح الوصول إليها أو تحميلها"@ar ;
  rdfs:comment "En samling af data, udgivet eller udvalgt og arrangeret af en enkelt kilde og som er til råde for adgang til eller download af i en eller flere repræsentationer."@da ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "Conjunto de datos"@es ;
  rdfs:label "Dataset"@en ;
  rdfs:label "Dataset"@it ;
  rdfs:label "Datová sada"@cs ;
  rdfs:label "Jeu de données"@fr ;
  rdfs:label "Σύνολο Δεδομένων"@el ;
  rdfs:label "قائمة بيانات"@ar ;
  rdfs:label "データセット"@ja ;
  rdfs:label "Datasæt"@da ;
  rdfs:subClassOf dcat:Resource ;
  skos:altLabel "Datasamling"@da ;
  skos:editorialNote "2020-03-16 A new scopenote added and need to be translated"@en ;
  skos:changeNote "2018-02 - odstraněno tvrzení o podtřídě dctype:Dataset, jelikož rozsah dcat:Dataset zahrnuje několik dalších typů ze slovníku dctype."@cs ;
  skos:changeNote "2018-02 - se eliminó el axioma de subclase con dctype:Dataset porque el alcance de dcat:Dataset incluye muchos otros tipos del vocabulario dctype."@es ;
  skos:changeNote "2018-02 - subclass of dctype:Dataset removed because scope of dcat:Dataset includes several other types from the dctype vocabulary."@en ;
  skos:changeNote "2018-02 - sottoclasse di dctype:Dataset rimosso perché l'ambito di dcat:Dataset include diversi altri tipi dal vocabolario dctype."@it ;
  skos:changeNote "2018-02 - subklasse af dctype:Dataset fjernet da scope af dcat:Dataset omfatter flere forskellige typer fra dctype-vokabularet."@da ;
  skos:definition "1つのエージェントによって公開またはキュレートされ、1つ以上の形式でアクセスまたはダウンロードできるデータの集合。"@ja ;
  skos:definition "A collection of data, published or curated by a single source, and available for access or download in one or more representations."@en ;
  skos:definition "Kolekce dat poskytovaná či řízená jedním zdrojem, která je k dispozici pro přístup či stažení v jednom či více formátech."@cs ;
  skos:definition "Raccolta di dati, pubblicati o curati da un'unica fonte, disponibili per l'accesso o il download in uno o più formati."@it ;
  skos:definition "Una colección de datos, publicados o conservados por una única fuente, y disponibles para ser accedidos o descargados en uno o más formatos."@es ;
  skos:definition "Une collection de données, publiée ou élaborée par une seule source, et disponible pour accès ou téléchargement dans un ou plusieurs formats."@fr ;
  skos:definition "Μία συλλογή από δεδομένα, δημοσιευμένη ή επιμελημένη από μία και μόνο πηγή, διαθέσιμη δε προς πρόσβαση ή μεταφόρτωση σε μία ή περισσότερες μορφές."@el ;
  skos:definition "قائمة بيانات منشورة أو مجموعة من قبل مصدر ما و متاح الوصول إليها أو تحميلها"@ar ;
  skos:definition "En samling a data, udgivet eller udvalgt og arrangeret af en enkelt kilde og som der er adgang til i en eller flere repræsentationer."@da ;
  skos:scopeNote "Cette classe représente le jeu de données publié par le fournisseur de données. Dans les cas où une distinction est nécessaire entre le jeu de donénes et son entrée dans le catalogue, la classe registre de données peut être utilisée pour ce dernier."@fr ;
  skos:scopeNote "Esta clase representa el conjunto de datos publicados. En los casos donde es necesario distinguir entre el conjunto de datos y su entrada en el catálogo de datos, se debe utilizar la clase 'registro del catálogo'."@es ;
  skos:scopeNote "Questa classe rappresenta il dataset come pubblicato dall’editore. Nel caso in cui sia necessario operare  una distinzione fra i metadati originali del dataset e il record dei metadati ad esso associato nel catalogo (ad esempio, per distinguere la data di modifica del dataset da quella del dataset nel catalogo) si può impiegare la classe catalog record."@it ;
  skos:scopeNote "Tato třída reprezentuje datovou sadu tak, jak je publikována poskytovatelem dat. V případě potřeby rozlišení datové sady a jejího katalogizačního záznamu (jelikož metadata jako datum modifikace se mohou lišit) pro něj může být použita třída 'katalogizační záznam'."@cs ;
  skos:scopeNote "This class describes the conceptual dataset. One or more representations might be available, with differing schematic layouts and formats or serializations."@en ;
  skos:scopeNote "Questa classe descrive il dataset dal punto di vista concettuale. Possono essere disponibili una o più rappresentazioni, con diversi layout e formati schematici o serializzazioni."@it ;
  skos:scopeNote "This class represents the actual dataset as published by the dataset provider. In cases where a distinction between the actual dataset and its entry in the catalog is necessary (because metadata such as modification date and maintainer might differ), the catalog record class can be used for the latter."@en ;
  skos:scopeNote "Η κλάση αυτή αναπαριστά το σύνολο δεδομένων αυτό καθ'εαυτό, όπως έχει δημοσιευθεί από τον εκδότη. Σε περιπτώσεις όπου είναι απαραίτητος ο διαχωρισμός μεταξύ του συνόλου δεδομένων και της καταγραφής αυτού στον κατάλογο (γιατί μεταδεδομένα όπως η ημερομηνία αλλαγής και ο συντηρητής μπορεί να διαφέρουν) η κλάση της καταγραφής καταλόγου μπορεί να χρησιμοποιηθεί για το τελευταίο."@el ;
  skos:scopeNote "このクラスは、データセットの公開者が公開する実際のデータセットを表わします。カタログ内の実際のデータセットとそのエントリーとの区別が必要な場合（修正日と維持者などのメタデータが異なるかもしれないので）は、後者にcatalog recordというクラスを使用できます。"@ja ;
  skos:scopeNote "The notion of dataset in DCAT is broad and inclusive, with the intention of accommodating resource types arising from all communities. Data comes in many forms including numbers, text, pixels, imagery, sound and other multi-media, and potentially other types, any of which might be collected into a dataset."@en ;
  skos:scopeNote "Denne klasse repræsenterer det konkrete datasæt som det udgives af datasætleverandøren. I de tilfælde hvor det er nødvendigt at skelne mellem det konkrete datasæt og dets registrering i kataloget (fordi metadata såsom ændringsdato og vedligeholder er forskellige), så kan klassen katalogpost anvendes. "@da ;
  skos:scopeNote "Denne klasse beskriver det konceptuelle datasæt. En eller flere repræsentationer kan være tilgængelige med forskellige skematiske opsætninger, formater eller serialiseringer."@da ;
.
dcat:DatasetSeries
  a rdfs:Class ;
  a owl:Class ;
  rdfs:comment "A collection of datasets that are published separately, but share some characteristics that group them."@en ;
  rdfs:comment "Una collezione di dataset che sono pubblicati separatamente, ma che condividono caratteristiche che li rendono parte di uno stesso gruppo."@it ;
  rdfs:comment "Una colección de conjuntos de datos publicados por separado, pero que comparten características que los agrupan."@es ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  rdfs:label "Dataset series"@en ;
  rdfs:label "Serie de conjuntos de datos"@es ;
  rdfs:label "Serie di dataset"@it ;
  rdfs:subClassOf dcat:Dataset ;
  skos:editorialNote "2022-05-08 Added to ttl file with annotations in English, Spanish and Italian, except notes that are in other languages too."@en ;
  skos:changeNote "New class added in DCAT 3."@en ;
  skos:changeNote "Nueva clase agregada en DCAT 3."@es ;
  skos:changeNote "Nová třída přidaná ve verzi DCAT 3"@cs ;
  skos:changeNote "Nuova classe aggiunta in DCAT 3"@it ;
  skos:changeNote "Ny klasse tilføjet i DCAT 3"@da ;
  skos:definition "A collection of datasets that are published separately, but share some common characteristics that groups them."@en ;
  skos:definition "Una collezione di dataset che sono pubblicati separatamente, ma che condividono caratteristiche che li rendono parte di uno stesso gruppo."@it ;
  skos:definition "Una colección de conjuntos de datos publicados por separado, pero que comparten características comunes que los agrupan."@es ;
  skos:scopeNote "Common scenarios for dataset series include: time series composed of periodically released subsets; map-series composed of items of the same type or theme but with differing spatial footprints."@en ;
  skos:scopeNote "Algunos escenarios comunes para series de conjuntos de datos son: series temporales compuestas de subconjuntos de datos publicados periódicamente; series de mapas compuestos de elementos del mismo tipo o tema pero con distintas huellas espaciales."@es ;
  skos:scopeNote "Scenari tipici per l'uso di serie di dataset: serie temporali costituite di dataset pubblicati regolarmente; serie di mappe costituite da elementi dello stesso tipo o tematica ma relative a differenti aree geografiche."@it ;
  skos:scopeNote "Dataset series can be also soft-typed via property dcterms:type as in the approach used in [GeoDCAT-AP], and adopted in [DCAT-AP-IT] and [GeoDCAT-AP-IT])."@en ;
  skos:scopeNote "También puede asignarse un tipo a las series de datos usando la propiedad dcterms:type como se hace en [GeoDCAT-AP], y adoptado en [DCAT-AP-IT] y [GeoDCAT-AP-IT])."@es ;
  skos:scopeNote "Le serie di dati possono anche essere denotate come tali usando la proprietà dcterms:type, secondo l'approccio usato in [GeoDCAT-AP], e adottato in [DCAT-AP-IT] e [GeoDCAT-AP-IT])."@it ;
.
dcat:Distribution
  a rdfs:Class ;
  a owl:Class ;
  rdfs:comment "A specific representation of a dataset. A dataset might be available in multiple serializations that may differ in various ways, including natural language, media-type or format, schematic organization, temporal and spatial resolution, level of detail or profiles (which might specify any or all of the above)."@en ;
  rdfs:comment "Konkrétní reprezentace datové sady. Datová sada může být dostupná v různých serializacích, které se mohou navzájem lišit různými způsoby, mimo jiné přirozeným jazykem, media-typem či formátem, schematickou organizací, časovým a prostorovým rozlišením, úrovní detailu či profily (které mohou specifikovat některé či všechny tyto rozdíly)."@cs ;
  rdfs:comment "Rappresenta una forma disponibile e specifica del dataset. Ciascun dataset può essere disponibile in forme differenti, che possono rappresentare formati diversi o diversi punti di accesso per un dataset. Esempi di distribuzioni sono un file CSV scaricabile, una API o un RSS feed."@it ;
  rdfs:comment "Représente une forme spécifique d'un jeu de données. Caque jeu de données peut être disponible sous différentes formes, celles-ci pouvant représenter différents formats du jeu de données ou différents endpoint. Des exemples de distribution sont des fichirs CSV, des API ou des flux RSS."@fr ;
  rdfs:comment "Una representación específica de los datos. Cada conjunto de datos puede estar disponible en formas diferentes, las cuáles pueden variar en distintas formas, incluyendo el idioma, 'media-type' o formato, organización esquemática, resolución temporal y espacial, nivel de detalle o perfiles (que pueden especificar cualquiera o todas las diferencias anteriores)."@es ;
  rdfs:comment "Αναπαριστά μία συγκεκριμένη διαθέσιμη μορφή ενός συνόλου δεδομένων. Κάθε σύνολο δεδομενων μπορεί να είναι διαθέσιμο σε διαφορετικές μορφές, οι μορφές αυτές μπορεί να αναπαριστούν διαφορετικές μορφές αρχείων ή διαφορετικά σημεία διάθεσης. Παραδείγματα διανομών συμπεριλαμβάνουν ένα μεταφορτώσιμο αρχείο μορφής CSV, ένα API ή ένα RSS feed."@el ;
  rdfs:comment "شكل محدد لقائمة البيانات يمكن الوصول إليه. قائمة بيانات ما يمكن أن تكون متاحه باشكال و أنواع متعددة.  ملف يمكن تحميله أو واجهة برمجية يمكن من خلالها الوصول إلى البيانات هي أمثلة على ذلك."@ar ;
  rdfs:comment "データセットの特定の利用可能な形式を表わします。各データセットは、異なる形式で利用できることがあり、これらの形式は、データセットの異なる形式や、異なるエンドポイントを表わす可能性があります。配信の例には、ダウンロード可能なCSVファイル、API、RSSフィードが含まれます。"@ja ;
  rdfs:comment "En specifik repræsentation af et datasæt. Et datasæt kan være tilgængelig i mange serialiseringer der kan variere på forskellige vis, herunder sprog, medietype eller format, systemorganisering, tidslig- og geografisk opløsning, detaljeringsniveau eller profiler (der kan specificere en eller flere af ovenstående)."@da ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "Distribuce"@cs ;
  rdfs:label "Distribución"@es ;
  rdfs:label "Distribution"@en ;
  rdfs:label "Distribution"@fr ;
  rdfs:label "Distribuzione"@it ;
  rdfs:label "Διανομή"@el ;
  rdfs:label "التوزيع"@ar ;
  rdfs:label "配信"@ja ;
  rdfs:label "Distribution"@da ;
  skos:altLabel "Datadistribution"@da ;
  skos:altLabel "Datarepræsentation"@da ;
  skos:altLabel "Datamanifestation"@da ;
  skos:altLabel "Dataudstilling"@da ;
  skos:definition "A specific representation of a dataset. A dataset might be available in multiple serializations that may differ in various ways, including natural language, media-type or format, schematic organization, temporal and spatial resolution, level of detail or profiles (which might specify any or all of the above)."@en ;
  skos:definition "Konkrétní reprezentace datové sady. Datová sada může být dostupná v různých serializacích, které se mohou navzájem lišit různými způsoby, mimo jiné přirozeným jazykem, media-typem či formátem, schematickou organizací, časovým a prostorovým rozlišením, úrovní detailu či profily (které mohou specifikovat některé či všechny tyto rozdíly)."@cs ;
  skos:definition "Rappresenta una forma disponibile e specifica del dataset. Ciascun dataset può essere disponibile in forme differenti, che possono rappresentare formati diversi o diversi punti di accesso per un dataset. Esempi di distribuzioni sono un file CSV scaricabile, una API o un RSS feed."@it ;
  skos:definition "Représente une forme spécifique d'un jeu de données. Caque jeu de données peut être disponible sous différentes formes, celles-ci pouvant représenter différents formats du jeu de données ou différents endpoint. Des exemples de distribution sont des fichirs CSV, des API ou des flux RSS."@fr ;
  skos:definition "Una representación específica de los datos. Cada conjunto de datos puede estar disponible en formas diferentes, las cuáles pueden variar en distintas formas, incluyendo el idioma, 'media-type' o formato, organización esquemática, resolución temporal y espacial, nivel de detalle o perfiles (que pueden especificar cualquiera o todas las diferencias anteriores)."@es ;
  skos:definition "Αναπαριστά μία συγκεκριμένη διαθέσιμη μορφή ενός συνόλου δεδομένων. Κάθε σύνολο δεδομενων μπορεί να είναι διαθέσιμο σε διαφορετικές μορφές, οι μορφές αυτές μπορεί να αναπαριστούν διαφορετικές μορφές αρχείων ή διαφορετικά σημεία διάθεσης. Παραδείγματα διανομών συμπεριλαμβάνουν ένα μεταφορτώσιμο αρχείο μορφής CSV, ένα API ή ένα RSS feed."@el ;
  skos:definition "شكل محدد لقائمة البيانات يمكن الوصول إليه. قائمة بيانات ما يمكن أن تكون متاحه باشكال و أنواع متعددة.  ملف يمكن تحميله أو واجهة برمجية يمكن من خلالها الوصول إلى البيانات هي أمثلة على ذلك."@ar ;
  skos:definition "データセットの特定の利用可能な形式を表わします。各データセットは、異なる形式で利用できることがあり、これらの形式は、データセットの異なる形式や、異なるエンドポイントを表わす可能性があります。配信の例には、ダウンロード可能なCSVファイル、API、RSSフィードが含まれます。"@ja ;
  skos:definition "En specifik repræsentation af et datasæt. Et datasæt kan være tilgængelig i mange serialiseringer der kan variere på forskellige vis, herunder sprog, medietype eller format, systemorganisering, tidslig- og geografisk opløsning, detaljeringsniveau eller profiler (der kan specificere en eller flere af ovenstående)."@da ;
  skos:scopeNote "Ceci représente une disponibilité générale du jeu de données, et implique qu'il n'existe pas d'information sur la méthode d'accès réelle des données, par exple, si c'est un lien de téléchargement direct ou à travers une page Web."@fr ;
  skos:scopeNote "Esta clase representa una disponibilidad general de un conjunto de datos, e implica que no existe información acerca del método de acceso real a los datos, i.e., si es un enlace de descarga directa o a través de una página Web."@es ;
  skos:scopeNote "Questa classe rappresenta una disponibilità generale di un dataset e non implica alcuna informazione sul metodo di accesso effettivo ai dati, ad esempio se si tratta di un accesso a download diretto, API, o attraverso una pagina Web. L'utilizzo della proprietà dcat:downloadURL indica distribuzioni direttamente scaricabili."@it ;
  skos:scopeNote "This represents a general availability of a dataset it implies no information about the actual access method of the data, i.e. whether by direct download, API, or through a Web page. The use of dcat:downloadURL property indicates directly downloadable distributions."@en ;
  skos:scopeNote "Toto popisuje obecnou dostupnost datové sady. Neimplikuje žádnou informaci o skutečné metodě přístupu k datům, tj. zda jsou přímo ke stažení, skrze API či přes webovou stránku. Použití vlastnosti dcat:downloadURL indikuje přímo stažitelné distribuce."@cs ;
  skos:scopeNote "Αυτό αναπαριστά μία γενική διαθεσιμότητα ενός συνόλου δεδομένων και δεν υπονοεί τίποτα περί του πραγματικού τρόπου πρόσβασης στα δεδομένα, αν είναι άμεσα μεταφορτώσιμα, μέσω API ή μέσω μίας ιστοσελίδας. Η χρήση της ιδιότητας dcat:downloadURL δείχνει μόνο άμεσα μεταφορτώσιμες διανομές."@el ;
  skos:scopeNote "これは、データセットの一般的な利用可能性を表わし、データの実際のアクセス方式に関する情報（つまり、直接ダウンロードなのか、APIなのか、ウェブページを介したものなのか）を意味しません。dcat:downloadURLプロパティーの使用は、直接ダウンロード可能な配信を意味します。"@ja ;
  skos:scopeNote "Denne klasse repræsenterer datasættets overordnede tilgængelighed og giver ikke oplysninger om hvilken metode der kan anvendes til at få adgang til data, dvs. om adgang til datasættet realiseres ved direkte download, API eller via et websted. Anvendelsen af egenskaben dcat:downloadURL indikerer at distributionen kan downloades direkte."@da ;
.
dcat:Relationship
  a owl:Class ;
  a rdfs:Class ;
  rdfs:comment "An association class for attaching additional information to a relationship between DCAT Resources."@en ;
  rdfs:comment "Asociační třída pro připojení dodatečných informací ke vztahu mezi zdroji DCAT."@cs ;
  rdfs:comment "Una clase de asociación para adjuntar información adicional a una relación entre recursos DCAT."@es ;
  rdfs:comment "Una classe di associazione per il collegamento di informazioni aggiuntive a una relazione tra le risorse DCAT."@it ;
  rdfs:comment "En associationsklasse til brug for tilknytning af yderligere information til en relation mellem DCAT-ressourcer."@da ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "Relación"@es ;
  rdfs:label "Relationship"@en ;
  rdfs:label "Relazione"@it ;
  rdfs:label "Vztah"@cs ;
  rdfs:label "Relation"@da ;
  skos:changeNote "New class added in DCAT 2"@en ;
  skos:changeNote "Nová třída přidaná ve verzi DCAT 2"@cs ;
  skos:changeNote "Nueva clase añadida en DCAT 2"@es ;
  skos:changeNote "Nuova classe aggiunta in DCAT 2"@it ;
  skos:changeNote "Ny klasse i DCAT 2"@da ;
  skos:definition "An association class for attaching additional information to a relationship between DCAT Resources."@en ;
  skos:definition "Asociační třída pro připojení dodatečných informací ke vztahu mezi zdroji DCAT."@cs ;
  skos:definition "Una clase de asociación para adjuntar información adicional a una relación entre recursos DCAT."@es ;
  skos:definition "Una classe di associazione per il collegamento di informazioni aggiuntive a una relazione tra le risorse DCAT."@it ;
  skos:definition "En associationsklasse til brug for tilknytning af yderligere information til en relation mellem DCAT-ressourcer."@da ;
  skos:scopeNote "Používá se pro charakterizaci vztahu mezi datovými sadami a případně i jinými zdroji, kde druh vztahu je sice znám, ale není přiměřeně charakterizován standardními vlastnostmi slovníku Dublin Core (dcterms:hasPart, dcterms:isPartOf, dcterms:conformsTo, dcterms:isFormatOf, dcterms:hasFormat, dcterms:isVersionOf, dcterms:hasVersion, dcterms:replaces, dcterms:isReplacedBy, dcterms:references, dcterms:isReferencedBy, dcterms:requires, dcterms:isRequiredBy) či vlastnostmi slovníku PROV-O (prov:wasDerivedFrom, prov:wasInfluencedBy, prov:wasQuotedFrom, prov:wasRevisionOf, prov:hadPrimarySource, prov:alternateOf, prov:specializationOf)."@cs ;
  skos:scopeNote "Se usa para caracterizar la relación entre conjuntos de datos, y potencialmente otros recursos, donde la naturaleza de la relación se conoce pero no está caracterizada adecuadamente con propiedades del estándar 'Dublin Core' (dcterms:hasPart, dcterms:isPartOf, dcterms:conformsTo, dcterms:isFormatOf, dcterms:hasFormat, dcterms:isVersionOf, dcterms:hasVersion, dcterms:replaces, dcterms:isReplacedBy, dcterms:references, dcterms:isReferencedBy, dcterms:requires, dcterms:isRequiredBy) or PROV-O properties (prov:wasDerivedFrom, prov:wasInfluencedBy, prov:wasQuotedFrom, prov:wasRevisionOf, prov:hadPrimarySource, prov:alternateOf, prov:specializationOf)."@es ;
  skos:scopeNote "Use to characterize a relationship between datasets, and potentially other resources, where the nature of the relationship is known but is not adequately characterized by the standard Dublin Core properties (dcterms:hasPart, dcterms:isPartOf, dcterms:conformsTo, dcterms:isFormatOf, dcterms:hasFormat, dcterms:isVersionOf, dcterms:hasVersion, dcterms:replaces, dcterms:isReplacedBy, dcterms:references, dcterms:isReferencedBy, dcterms:requires, dcterms:isRequiredBy) or PROV-O properties (prov:wasDerivedFrom, prov:wasInfluencedBy, prov:wasQuotedFrom, prov:wasRevisionOf, prov:hadPrimarySource, prov:alternateOf, prov:specializationOf)."@en ;
  skos:scopeNote "Viene utilizzato per caratterizzare la relazione tra insiemi di dati, e potenzialmente altri tipi di risorse, nei casi in cui la natura della relazione è nota ma non adeguatamente caratterizzata dalle proprietà dello standard 'Dublin Core' (dcterms:hasPart, dcterms:isPartOf, dcterms:conformsTo, dcterms:isFormatOf, dcterms:hasFormat, dcterms:isVersionOf, dcterms:hasVersion, dcterms:replaces, dcterms:isReplacedBy, dcterms:references, dcterms:isReferencedBy, dcterms:require, dcterms:isRequiredBy) o dalle propietà fornite da PROV-O  (prov:wasDerivedFrom, prov:wasInfluencedBy, prov:wasQuotedFrom, prov:wasRevisionOf, prov: hadPrimarySource, prov:alternateOf, prov:specializationOf)."@it ;
  skos:scopeNote "Anvendes til at karakterisere en relation mellem datasæt, og potentielt andre ressourcer, hvor relationen er kendt men ikke tilstrækkeligt beskrevet af de standardiserede egenskaber i Dublin Core (dcterms:hasPart, dcterms:isPartOf, dcterms:conformsTo, dcterms:isFormatOf, dcterms:hasFormat, dcterms:isVersionOf, dcterms:hasVersion, dcterms:replaces, dcterms:isReplacedBy, dcterms:references, dcterms:isReferencedBy, dcterms:requires, dcterms:isRequiredBy) eller PROV-O-egenskaber (prov:wasDerivedFrom, prov:wasInfluencedBy, prov:wasQuotedFrom, prov:wasRevisionOf, prov:hadPrimarySource, prov:alternateOf, prov:specializationOf)."@da ;
.
dcat:Resource
  a owl:Class ;
  a rdfs:Class ;
  rdfs:comment "Recurso publicado o curado por un agente único."@es ;
  rdfs:comment "Resource published or curated by a single agent."@en ;
  rdfs:comment "Risorsa pubblicata o curata da un singolo agente."@it ;
  rdfs:comment "Zdroj publikovaný či řízený jediným činitelem."@cs ;
  rdfs:comment "Ressource udgivet eller udvalgt og arrangeret af en enkelt aktør."@da ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "Catalogued resource"@en ;
  rdfs:label "Katalogizovaný zdroj"@cs ;
  rdfs:label "Recurso catalogado"@es ;
  rdfs:label "Risorsa catalogata"@it ;
  rdfs:label "Katalogiseret ressource"@da ;
  skos:editorialNote "2020-08-23 Scopenote updated  and needs to be translated"@en ;
  skos:changeNote "New class added in DCAT 2"@en ;
  skos:changeNote "Nová třída přidaná ve verzi DCAT 2"@cs ;
  skos:changeNote "Nueva clase agregada en DCAT 2"@es ;
  skos:changeNote "Nuova classe aggiunta in DCAT 2"@it ;
  skos:changeNote "Ny klasse i DCAT 2"@da ;
  skos:definition "Recurso publicado o curado por un agente único."@es ;
  skos:definition "Resource published or curated by a single agent."@en ;
  skos:definition "Risorsa pubblicata o curata da un singolo agente."@it ;
  skos:definition "Zdroj publikovaný či řízený jediným činitelem."@cs ;
  skos:definition "Ressource udgivet eller udvalgt og arrangeret af en enkelt aktør."@da ;
  skos:scopeNote "La clase de todos los recursos catalogados, la superclase de dcat:Dataset, dcat:DataService, dcat:Catalog y cualquier otro miembro de un dcat:Catalog. Esta clase tiene propiedades comunes a todos los recursos catalogados, incluyendo conjuntos de datos y servicios de datos. Se recomienda fuertemente que se use una clase más específica. Cuando se describe un recurso que no es un dcat:Dataset o dcat:DataService, se recomienda crear una sub-clase apropiada de dcat:Resource, o usar dcat:Resource con la propiedad dcterms:type to indicar el tipo específico."@es ;
  skos:scopeNote "La classe di tutte le risorse catalogate, la Superclasse di dcat:Dataset, dcat:DataService, dcat:Catalog e qualsiasi altro membro di dcat:Catalog. Questa classe porta proprietà comuni a tutte le risorse catalogate, inclusi set di dati e servizi dati. Si raccomanda vivamente di utilizzare una sottoclasse più specifica. Quando si descrive una risorsa che non è un dcat:Dataset o dcat:DataService, si raccomanda di creare una sottoclasse di dcat:Resource appropriata, o utilizzare dcat:Resource con la proprietà dcterms:type per indicare il tipo specifico."@it ;
  skos:scopeNote "The class of all catalogued resources, the Superclass of dcat:Dataset, dcat:DataService, dcat:Catalog and any other member of a dcat:Catalog. This class carries properties common to all catalogued resources, including datasets and data services. The instances of this class SHOULD be included in a catalog. The instances of this class SHOULD be included in a catalog. It is strongly recommended to use a more specific sub-class. When describing a resource which is not a dcat:Dataset or dcat:DataService, it is recommended to create a suitable sub-class of dcat:Resource, or use dcat:Resource with the dcterms:type property to indicate the specific type."@en ;
  skos:scopeNote "Třída všech katalogizovaných zdrojů, nadtřída dcat:Dataset, dcat:DataService, dcat:Catalog a všech ostatních členů dcat:Catalog. Tato třída nese vlastnosti společné všem katalogizovaným zdrojům včetně datových sad a datových služeb. Je silně doporučeno používat specifičtější podtřídy, pokud je to možné. Při popisu zdroje, který není ani dcat:Dataset, ani dcat:DataService se doporučuje vytvořit odpovídající podtřídu dcat:Resrouce a nebo použít dcat:Resource s vlastností dcterms:type pro určení konkrétního typu."@cs ;
  skos:scopeNote "dcat:Resource es un punto de extensión que permite la definición de cualquier tipo de catálogo. Se pueden definir subclases adicionales en perfil de DCAT o una aplicación para catálogos de otro tipo de recursos."@es ;
  skos:scopeNote "dcat:Resource is an extension point that enables the definition of any kind of catalog. Additional subclasses may be defined in a DCAT profile or application for catalogs of other kinds of resources."@en ;
  skos:scopeNote "dcat:Resource je bod pro rozšíření umožňující definici různých druhů katalogů. Další podtřídy lze definovat v profilech DCAT či aplikacích pro katalogy zdrojů jiných druhů."@cs ;
  skos:scopeNote "dcat:Resource è un punto di estensione che consente la definizione di qualsiasi tipo di catalogo. Sottoclassi aggiuntive possono essere definite in un profilo DCAT o in un'applicazione per cataloghi di altri tipi di risorse."@it ;
  skos:scopeNote "Klassen for alle katalogiserede ressourcer, den overordnede klasse for dcat:Dataset, dcat:DataService, dcat:Catalog og enhvert medlem af et dcat:Catalog. Denne klasse bærer egenskaber der gælder alle katalogiserede ressourcer, herunder dataset og datatjenester. Det anbefales kraftigt at mere specifikke subklasser oprettes. Når der beskrives ressourcer der ikke er dcat:Dataset eller dcat:DataService, anbefales det at oprette passende subklasser af dcat:Resource eller at dcat:Resource anvendes sammen med egenskaben dcterms:type til opmærkning med en specifik typeangivelse."@da ;
  skos:scopeNote "dcat:Resource er et udvidelsespunkt der tillader oprettelsen af enhver type af kataloger. Yderligere subklasser kan defineres i en DCAT-profil eller i en applikation til kataloger med andre typer af ressourcer."@da ;
.
dcat:Role
  a owl:Class ;
  a rdfs:Class ;
  rdfs:comment "A role is the function of a resource or agent with respect to another resource, in the context of resource attribution or resource relationships."@en ;
  rdfs:comment "Role je funkce zdroje či agenta ve vztahu k jinému zdroji, v kontextu přiřazení zdrojů či vztahů mezi zdroji."@cs ;
  rdfs:comment "Un rol es la función de un recurso o agente con respecto a otro recuros, en el contexto de atribución del recurso o de las relaciones entre recursos."@es ;
  rdfs:comment "Un ruolo è la funzione di una risorsa o di un agente rispetto ad un'altra risorsa, nel contesto dell'attribuzione delle risorse o delle relazioni tra risorse."@it ;
  rdfs:comment "En rolle er den funktion en ressource eller aktør har i forhold til en anden ressource, i forbindelse med ressourcekreditering eller ressourcerelationer."@da ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "Rol"@es ;
  rdfs:label "Role"@cs ;
  rdfs:label "Role"@en ;
  rdfs:label "Ruolo"@it ;
  rdfs:label "Rolle"@da ;
  rdfs:seeAlso dcat:hadRole ;
  rdfs:subClassOf skos:Concept ;
  skos:changeNote "New class added in DCAT 2"@en ;
  skos:changeNote "Nueva clase agregada en DCAT 2"@es ;
  skos:changeNote "Nová třída přidaná ve verzi DCAT 2"@cs ;
  skos:changeNote "Nuova classe aggiunta in DCAT 2"@it ;
  skos:changeNote "Ny klasse tilføjet i DCAT 2"@da ;
  skos:definition "A role is the function of a resource or agent with respect to another resource, in the context of resource attribution or resource relationships."@en ;
  skos:definition "Role je funkce zdroje či agenta ve vztahu k jinému zdroji, v kontextu přiřazení zdrojů či vztahů mezi zdroji."@cs ;
  skos:definition "Un rol es la función de un recurso o agente con respecto a otro recuros, en el contexto de atribución del recurso o de las relaciones entre recursos."@es ;
  skos:definition "Un ruolo è la funzione di una risorsa o di un agente rispetto ad un'altra risorsa, nel contesto dell'attribuzione delle risorse o delle relazioni tra risorse."@it ;
  skos:definition "En rolle er den funktion en ressource eller aktør har i forhold til en anden ressource, i forbindelse med ressourcekreditering eller ressourcerelationer."@da ;
  skos:editorialNote "Incluída en DCAT para complementar prov:Role (cuyo uso está limitado a roles en el contexto de una actividad, ya que es el rango es prov:hadRole)."@es ;
  skos:editorialNote "Introdotta in DCAT per completare prov:Role (il cui uso è limitato ai ruoli nel contesto di un'attività, in conseguenza alla definizione del codominio di prov:hadRole)."@it ;
  skos:editorialNote "Introduced into DCAT to complement prov:Role (whose use is limited to roles in the context of an activity, as the range of prov:hadRole)."@en ;
  skos:editorialNote "Přidáno do DCAT pro doplnění třídy prov:Role (jejíž užití je omezeno na role v kontextu aktivit, jakožto obor hodnot vlastnosti prov:hadRole)."@cs ;
  skos:editorialNote "Introduceret i DCAT for at supplere prov:Role (hvis anvendelse er begrænset til roller i forbindelse med en aktivitet, som er rækkevidde for prov:hadRole)."@da ;
  skos:scopeNote "Použito v kvalifikovaném přiřazení pro specifikaci role Agenta ve vztahu k Entitě. Je doporučeno množinu hodnot spravovat jako řízený slovník rolí agentů, jako například http://registry.it.csiro.au/def/isotc211/CI_RoleCode."@cs ;
  skos:scopeNote "Použito v kvalifikovaném vztahu pro specifikaci role Entity ve vztahu k jiné Entitě. Je doporučeno množinu hodnot spravovat jako řízený slovník rolí entit, jako například ISO 19115 DS_AssociationTypeCode http://registry.it.csiro.au/def/isotc211/DS_AssociationTypeCode, IANA Registry of Link Relations https://www.iana.org/assignments/link-relation, DataCite metadata schema, či MARC relators https://id.loc.gov/vocabulary/relators."@cs ;
  skos:scopeNote "Se usa en una atribución cualificada para especificar el rol de un Agente con respecto a una Entidad. Se recomienda que los valores se administren como un vocabulario controlado de roles de agente, como por ejemplo http://registry.it.csiro.au/def/isotc211/CI_RoleCode."@es ;
  skos:scopeNote "Se usa en una relación cualificada para especificar el rol de una Entidad con respecto a otra Entidad. Se recomienda que los valores se administren como los valores de un vocabulario controlado de roles de entidad como por ejemplo: ISO 19115 DS_AssociationTypeCode http://registry.it.csiro.au/def/isotc211/DS_AssociationTypeCode; IANA Registry of Link Relations https://www.iana.org/assignments/link-relation; el esquema de metadatos de DataCite; MARC relators https://id.loc.gov/vocabulary/relators."@es ;
  skos:scopeNote "Used in a qualified-attribution to specify the role of an Agent with respect to an Entity. It is recommended that the values be managed as a controlled vocabulary of agent roles, such as http://registry.it.csiro.au/def/isotc211/CI_RoleCode."@en ;
  skos:scopeNote "Used in a qualified-relation to specify the role of an Entity with respect to another Entity. It is recommended that the values be managed as a controlled vocabulary of entity roles such as: ISO 19115 DS_AssociationTypeCode http://registry.it.csiro.au/def/isotc211/DS_AssociationTypeCode; IANA Registry of Link Relations https://www.iana.org/assignments/link-relation;  DataCite metadata schema;  MARC relators https://id.loc.gov/vocabulary/relators."@en ;
  skos:scopeNote "Utilizzato in un'attribuzione qualificata per specificare il ruolo di un agente rispetto a un'entità. Si consiglia di attribuire i valori considerando un vocabolario controllato dei ruoli dell'agente, ad esempio http://registry.it.csiro.au/def/isotc211/CI_RoleCode."@it ;
  skos:scopeNote "Utilizzato in una relazione qualificata per specificare il ruolo di un'entità rispetto a un'altra entità. Si raccomanda che il valore sia preso da un vocabolario controllato di ruoli di entità come ISO 19115 DS_AssociationTypeCode http://registry.it.csiro.au/def/isotc211/DS_AssociationTypeCode, IANA Registry of Link Relations https://www.iana.org/assignments/link-relation, DataCite metadata schema, o MARC relators https://id.loc.gov/vocabulary/relators."@it ;
  skos:scopeNote "Anvendes i forbindelse med kvalificerede krediteringer til at angive aktørens rolle i forhold til en entitet. Det anbefales at værdierne styres som et kontrolleret udfaldsrum med aktørroller, såsom http://registry.it.csiro.au/def/isotc211/CI_RoleCode."@da ;
  skos:scopeNote "Anvendes i forbindelse med kvalificerede relationer til at specificere en entitets rolle i forhold til en anden entitet. Det anbefales at værdierne styres med et kontrolleret udfaldsrum for for entitetsroller såsom: ISO 19115 DS_AssociationTypeCode http://registry.it.csiro.au/def/isotc211/DS_AssociationTypeCode; IANA Registry of Link Relations https://www.iana.org/assignments/link-relation;  DataCite metadata schema;  MARC relators https://id.loc.gov/vocabulary/relators."@da ;
.

dcat:accessService
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A site or end-point that gives access to the distribution of the dataset."@en ;
  rdfs:comment "Umístění či přístupový bod zpřístupňující distribuci datové sady."@cs ;
  rdfs:comment "Un sitio o end-point que da acceso a la distribución de un conjunto de datos."@es ;
  rdfs:comment "Un sito o end-point che dà accesso alla distribuzione del set di dati."@it ;
  rdfs:comment "Et websted eller endpoint der giver adgang til en repræsentation af datasættet."@da ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "data access service"@en ;
  rdfs:label "servicio de acceso de datos"@es ;
  rdfs:label "servizio di accesso ai dati"@it ;
  rdfs:label "služba pro přístup k datům"@cs ;
  rdfs:label "dataadgangstjeneste"@da ;
  rdfs:range dcat:DataService ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 2."@da ;
  skos:definition "A site or end-point that gives access to the distribution of the dataset."@en ;
  skos:definition "Umístění či přístupový bod zpřístupňující distribuci datové sady."@cs ;
  skos:definition "Un sitio o end-point que da acceso a la distribución de un conjunto de datos."@es ;
  skos:definition "Un sito o end-point che dà accesso alla distribuzione del set di dati."@it ;
  skos:definition "Et websted eller endpoint der giver adgang til en repræsentation af datasættet."@da ;
.
dcat:accessURL
  a rdf:Property ;
  a owl:ObjectProperty ;
  owl:propertyChainAxiom (
      dcat:accessService
      dcat:endpointURL
    ) ;
  rdfs:comment "A URL of a resource that gives access to a distribution of the dataset. E.g. landing page, feed, SPARQL endpoint. Use for all cases except a simple download link, in which case downloadURL is preferred."@en ;
  rdfs:comment "Ceci peut être tout type d'URL qui donne accès à une distribution du jeu de données. Par exemple, un lien à une page HTML contenant un lien au jeu de données, un Flux RSS, un point d'accès SPARQL. Utilisez le lorsque votre catalogue ne contient pas d'information sur quoi il est ou quand ce n'est pas téléchargeable."@fr ;
  rdfs:comment "Puede ser cualquier tipo de URL que de acceso a una distribución del conjunto de datos, e.g., página de destino, descarga, URL feed, punto de acceso SPARQL. Esta propriedad se debe usar cuando su catálogo de datos no tiene información sobre donde está o cuando no se puede descargar."@es ;
  rdfs:comment "URL zdroje, přes které je přístupná distribuce datové sady. Příkladem může být vstupní stránka, RSS kanál či SPARQL endpoint. Použijte ve všech případech kromě URL souboru ke stažení, pro které je lepší použít dcat:downloadURL."@cs ;
  rdfs:comment "Un URL di una risorsa che consente di accedere a una distribuzione del set di dati. Per esempio, pagina di destinazione, feed, endpoint SPARQL. Da utilizzare per tutti i casi, tranne  quando  si tratta di un semplice link per il download nel qual caso è preferito downloadURL."@it ;
  rdfs:comment "Μπορεί να είναι οποιουδήποτε είδους URL που δίνει πρόσβαση στη διανομή ενός συνόλου δεδομένων. Π.χ. ιστοσελίδα αρχικής πρόσβασης, μεταφόρτωση, feed URL, σημείο διάθεσης SPARQL. Να χρησιμοποιείται όταν ο κατάλογος δεν περιέχει πληροφορίες εαν πρόκειται ή όχι για μεταφορτώσιμο αρχείο."@el ;
  rdfs:comment "أي رابط يتيح الوصول إلى البيانات. إذا كان الرابط هو ربط مباشر لملف يمكن تحميله استخدم الخاصية downloadURL"@ar ;
  rdfs:comment "データセットの配信にアクセス権を与えるランディング・ページ、フィード、SPARQLエンドポイント、その他の種類の資源。"@ja ;
  rdfs:comment "En URL for en ressource som giver adgang til en repræsentation af datsættet. Fx destinationsside, feed, SPARQL-endpoint. Anvendes i alle sammenhænge undtagen til angivelse af et simpelt download link hvor anvendelse af egenskaben downloadURL foretrækkes."@da ;
  rdfs:domain dcat:Distribution ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "URL d'accès"@fr ;
  rdfs:label "URL de acceso"@es ;
  rdfs:label "URL πρόσβασης"@el ;
  rdfs:label "access address"@en ;
  rdfs:label "indirizzo di accesso"@it ;
  rdfs:label "přístupová adresa"@cs ;
  rdfs:label "رابط وصول"@ar ;
  rdfs:label "アクセスURL"@ja ;
  rdfs:label "adgangsadresse"@da ;
  rdfs:range rdfs:Resource ;
  skos:altLabel "adgangsURL"@da ;
  skos:definition "A URL of a resource that gives access to a distribution of the dataset. E.g. landing page, feed, SPARQL endpoint. Use for all cases except a simple download link, in which case downloadURL is preferred."@en ;
  skos:definition "Ceci peut être tout type d'URL qui donne accès à une distribution du jeu de données. Par exemple, un lien à une page HTML contenant un lien au jeu de données, un Flux RSS, un point d'accès SPARQL. Utilisez le lorsque votre catalogue ne contient pas d'information sur quoi il est ou quand ce n'est pas téléchargeable."@fr ;
  skos:definition "Puede ser cualquier tipo de URL que de acceso a una distribución del conjunto de datos, e.g., página de destino, descarga, URL feed, punto de acceso SPARQL. Esta propriedad se debe usar cuando su catálogo de datos no tiene información sobre donde está o cuando no se puede descargar."@es ;
  skos:definition "URL zdroje, přes které je přístupná distribuce datové sady. Příkladem může být vstupní stránka, RSS kanál či SPARQL endpoint. Použijte ve všech případech kromě URL souboru ke stažení, pro které je lepší použít dcat:downloadURL."@cs ;
  skos:definition "Un URL di una risorsa che consente di accedere a una distribuzione del set di dati. Per esempio, pagina di destinazione, feed, endpoint SPARQL. Da utilizzare per tutti i casi, tranne  quando  si tratta di un semplice link per il download nel qual caso è preferito downloadURL."@it ;
  skos:definition "Μπορεί να είναι οποιουδήποτε είδους URL που δίνει πρόσβαση στη διανομή ενός συνόλου δεδομένων. Π.χ. ιστοσελίδα αρχικής πρόσβασης, μεταφόρτωση, feed URL, σημείο διάθεσης SPARQL. Να χρησιμοποιείται όταν ο κατάλογος δεν περιέχει πληροφορίες εαν πρόκειται ή όχι για μεταφορτώσιμο αρχείο."@el ;
  skos:definition "أي رابط يتيح الوصول إلى البيانات. إذا كان الرابط هو ربط مباشر لملف يمكن تحميله استخدم الخاصية downloadURL"@ar ;
  skos:definition "データセットの配信にアクセス権を与えるランディング・ページ、フィード、SPARQLエンドポイント、その他の種類の資源。"@ja ;
  skos:definition "En URL for en ressource som giver adgang til en repræsentation af datsættet. Fx destinationsside, feed, SPARQL-endpoint. Anvendes i alle sammenhænge undtagen til angivelse af et simpelt download link hvor anvendelse af egenskaben downloadURL foretrækkes."@da ;
  skos:editorialNote "Status: English Definition text modified by DCAT revision team, updated Italian and Czech translation provided, translations for other languages pending."@en ;
  skos:editorialNote "rdfs:label, rdfs:comment and skos:scopeNote have been modified. Non-english versions except for Italian must be updated."@en ;
  skos:scopeNote "El rango es una URL. Si la distribución es accesible solamente través de una página de destino (es decir, si no se conoce una URL de descarga directa), entonces el enlance a la página de destino debe ser duplicado como accessURL en la distribución."@es ;
  skos:scopeNote "If the distribution(s) are accessible only through a landing page (i.e. direct download URLs are not known), then the landing page link should be duplicated as accessURL on a distribution."@en ;
  skos:scopeNote "La valeur est une URL. Si la distribution est accessible seulement au travers d'une page d'atterrissage (c-à-dire on n'ignore une URL de téléchargement direct), alors le lien à la page d'atterrissage doit être dupliqué comee accessURL sur la distribution."@fr ;
  skos:scopeNote "Pokud jsou distribuce přístupné pouze přes vstupní stránku (tj. URL pro přímé stažení nejsou známa), pak by URL přístupové stránky mělo být duplikováno ve vlastnosti distribuce accessURL."@cs ;
  skos:scopeNote "Se le distribuzioni sono accessibili solo attraverso una pagina web (ad esempio, gli URL per il download diretto non sono noti), allora il link della pagina web deve essere duplicato come accessURL sulla distribuzione."@it ;
  skos:scopeNote "Η τιμή είναι ένα URL. Αν η/οι διανομή/ές είναι προσβάσιμη/ες μόνο μέσω μίας ιστοσελίδας αρχικής πρόσβασης (δηλαδή αν δεν υπάρχουν γνωστές διευθύνσεις άμεσης μεταφόρτωσης), τότε ο σύνδεσμος της ιστοσελίδας αρχικής πρόσβασης πρέπει να αναπαραχθεί ως accessURL σε μία διανομή."@el ;
  skos:scopeNote "確実にダウンロードでない場合や、ダウンロードかどうかが不明である場合は、downloadURLではなく、accessURLを用いてください。ランディング・ページを通じてしか配信にアクセスできない場合（つまり、直接的なダウンロードURLが不明）は、配信におけるaccessURLとしてランディング・ページのリンクをコピーすべきです（SHOULD）。"@ja ;
  skos:scopeNote "Hvis en eller flere distributioner kun er tilgængelige via en destinationsside (dvs. en URL til direkte download er ikke kendt), så bør destinationssidelinket gentages som adgangsadresse for distributionen."@da ;
.
dcat:bbox
  a rdf:Property ;
  a owl:DatatypeProperty ;
  rdfs:domain dcterms:Location ;
  rdfs:comment "El cuadro delimitador geográfico para un recurso."@es ;
  rdfs:comment "Ohraničení geografické oblasti zdroje."@cs ;
  rdfs:comment "The geographic bounding box of a spatial thing [SDW-BP]."@en ;
  rdfs:comment "Il riquadro di delimitazione geografica di una risorsa."@it ;
  rdfs:comment "Den geografiske omskrevne firkant af en ressource."@da ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "bounding box"@en ;
  rdfs:label "quadro di delimitazione"@it ;
  rdfs:label "cuadro delimitador"@es ;
  rdfs:label "ohraničení oblasti"@cs ;
  rdfs:label "bounding box"@da ;
  rdfs:range rdfs:Literal ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Propiedad nueva agregada en DCAT 2."@es ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 2."@da ;
  skos:definition "El cuadro delimitador geográfico para un recurso."@es ;
  skos:definition "Ohraničení geografické oblasti zdroje."@cs ;
  skos:definition "The geographic bounding box of a spatial thing [SDW-BP]."@en ;
  skos:definition "Il riquadro di delimitazione geografica di una risorsa."@it ;
  skos:definition "Den geografiske omskrevne firkant af en ressource."@da ;
  skos:editorialNote "English language definitions and comments updated in this revision in line with ED. Multilingual text unevenly updated."@en ;
  skos:scopeNote "El rango de esta propiedad es intencionalmente genérico con el propósito de permitir distintas codificaciones geométricas. Por ejemplo, la geometría puede ser codificada como WKT (geosparql:wktLiteral [GeoSPARQL]) o [GML] (geosparql:asGML [GeoSPARQL])."@es ;
  skos:scopeNote "Obor hodnot této vlastnosti je úmyslně obecný, aby umožnil různé kódování geometrií. Geometrie by kupříkladu mohla být kódována jako WKT (geosparql:wktLiteral [GeoSPARQL]) či [GML] (geosparql:asGML [GeoSPARQL])."@cs ;
  skos:scopeNote "The range of this property (rdfs:Literal) is intentionally generic, with the purpose of allowing different geometry literal encodings. E.g., the geometry could be encoded as a WKT literal (geosparql:wktLiteral [GeoSPARQL])."@en ;
  skos:scopeNote "Il range di questa proprietà (rdfs:Literal) è volutamente generica, con lo scopo di consentire diverse codifiche geometriche letterali. Ad esempio, la geometria potrebbe essere codificata con un letterale WKT (geosparql:wktLiteral [GeoSPARQL]) o [GML] (geosparql:asGML [GeoSPARQL])."@it ;
  skos:scopeNote "Rækkevidden for denne egenskab er bevidst generisk defineret med det formål at tillade forskellige kodninger af geometrier. Geometrien kan eksempelvis repræsenteres som WKT (geosparql:asWKT [GeoSPARQL]) eller [GML] (geosparql:asGML [GeoSPARQL])."@da ;
.
dcat:byteSize
  a rdf:Property ;
  a owl:DatatypeProperty ;
  rdfs:comment "El tamaño de una distribución en bytes."@es ;
  rdfs:comment "La dimensione di una distribuzione in byte."@it ;
  rdfs:comment "La taille de la distribution en octects"@fr ;
  rdfs:comment "The size of a distribution in bytes."@en ;
  rdfs:comment "Velikost distribuce v bajtech."@cs ;
  rdfs:comment "Το μέγεθος μιας διανομής σε bytes."@el ;
  rdfs:comment "الحجم بالبايتات "@ar ;
  rdfs:comment "バイトによる配信のサイズ。"@ja ;
  rdfs:comment "Størrelsen af en distributionen angivet i bytes."@da ;
  rdfs:domain dcat:Distribution ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "byte size"@en ;
  rdfs:label "dimensione in byte"@it ;
  rdfs:label "taille en octects"@fr ;
  rdfs:label "tamaño en bytes"@es ;
  rdfs:label "velikost v bajtech"@cs ;
  rdfs:label "μέγεθος σε bytes"@el ;
  rdfs:label "الحجم بالبايت"@ar ;
  rdfs:label "バイト・サイズ"@ja ;
  rdfs:label "bytestørrelse"@da ;
  rdfs:range rdfs:Literal ;
  skos:definition "El tamaño de una distribución en bytes."@es ;
  skos:definition "La dimensione di una distribuzione in byte."@it ;
  skos:definition "La taille de la distribution en octects."@fr ;
  skos:definition "The size of a distribution in bytes."@en ;
  skos:definition "Velikost distribuce v bajtech."@cs ;
  skos:definition "Το μέγεθος μιας διανομής σε bytes."@el ;
  skos:definition "الحجم بالبايتات "@ar ;
  skos:definition "バイトによる配信のサイズ。"@ja ;
  skos:definition "Størrelsen af en distribution angivet i bytes."@da ;
  skos:scopeNote "El tamaño en bytes puede ser aproximado cuando se desconoce el tamaño exacto. El valor literal de dcat:byteSize debe tener tipo 'xsd:decimal'."@es ;
  skos:scopeNote "La dimensione in byte può essere approssimata quando non si conosce la dimensione precisa. Il valore di dcat:byteSize dovrebbe essere espresso come un xsd:decimal."@it ;
  skos:scopeNote "La taille en octects peut être approximative lorsque l'on ignore la taille réelle. La valeur littérale de dcat:byteSize doit être de type xsd:decimal."@fr ;
  skos:scopeNote "The size in bytes can be approximated when the precise size is not known. The literal value of dcat:byteSize should by typed as xsd:decimal."@en ;
  skos:scopeNote "Velikost v bajtech může být přibližná, pokud její přesná hodnota není známa. Literál s hodnotou dcat:byteSize by měl mít datový typ xsd:decimal."@cs ;
  skos:scopeNote "Το μέγεθος σε bytes μπορεί να προσεγγιστεί όταν η ακριβής τιμή δεν είναι γνωστή. Η τιμή της dcat:byteSize θα πρέπει να δίνεται με τύπο δεδομένων xsd:decimal."@el ;
  skos:scopeNote "الحجم يمكن أن يكون تقريبي إذا كان الحجم الدقيق غير معروف"@ar ;
  skos:scopeNote "正確なサイズが不明である場合、サイズは、バイトによる近似値を示すことができます。"@ja ;
  skos:scopeNote "Bytestørrelsen kan approximeres hvis den præcise størrelse ikke er kendt. Værdien af dcat:byteSize bør angives som xsd:decimal."@da ;
.
dcat:catalog
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A catalog that is listed in the catalog."@en ;
  rdfs:comment "Katalog, jehož obsah je v kontextu tohoto katalogu zajímavý."@cs ;
  rdfs:comment "Un catalogo i cui contenuti sono di interesse nel contesto di questo catalogo."@it ;
  rdfs:comment "Un catálogo cuyo contenido es de interés en el contexto del catálogo que está siendo descripto."@es ;
  rdfs:comment "Et katalog hvis indhold er relevant i forhold til det aktuelle katalog."@da ;
  rdfs:domain dcat:Catalog ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "catalog"@en ;
  rdfs:label "catalogo"@it ;
  rdfs:label "catálogo"@es ;
  rdfs:label "katalog"@cs ;
  rdfs:label "katalog"@da ;
  rdfs:range dcat:Catalog ;
  rdfs:subPropertyOf dcat:resource ;
  skos:altLabel "har delkatalog"@da ;
  skos:altLabel "has catalog"@en;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:definition "A catalog that is listed in the catalog."@en ;
  skos:definition "Katalog, jehož obsah je v kontextu tohoto katalogu zajímavý."@cs ;
  skos:definition "Un catalogo i cui contenuti sono di interesse nel contesto di questo catalogo."@it ;
  skos:definition "Un catálogo cuyo contenido es de interés en el contexto del catálogo que está siendo descripto."@es ;
  skos:definition "Et katalog hvis indhold er relevant i forhold til det aktuelle katalog."@da ;
  skos:editorialNote "Status: English Definition text modified by DCAT 3 revision team, translations pending."@en ;
.
dcat:centroid
  a rdf:Property ;
  a owl:DatatypeProperty ;
  rdfs:comment "El centro geográfico (centroide) de un recurso."@es ;
  rdfs:comment "Geografický střed (centroid) zdroje."@cs ;
  rdfs:comment "The geographic center (centroid) of a spatial thing [SDW-BP]."@en ;
  rdfs:comment "Il centro geografico (centroide) di una risorsa."@it ;
  rdfs:comment "Det geometrisk tyngdepunkt (centroid) for en ressource."@da ;
  rdfs:domain dcterms:Location ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "centroid"@cs ;
  rdfs:label "centroid"@en ;
  rdfs:label "centroide"@it ;
  rdfs:label "centroide"@es ;
  rdfs:label "geometrisk tyngdepunkt"@da ;
  rdfs:range rdfs:Literal ;
  skos:altLabel "centroide"@da ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@es ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 2."@da ;
  skos:definition "El centro geográfico (centroide) de un recurso."@es ;
  skos:definition "Geografický střed (centroid) zdroje."@cs ;
  skos:definition "The geographic center (centroid) of a spatial thing [SDW-BP]."@en ;
  skos:definition "Il centro geografico (centroide) di una risorsa."@it ;
  skos:definition "Det geometrisk tyngdepunkt (centroid) for en ressource."@da ;
  skos:editorialNote "English language definitions and comments updated in this revision in line with ED. Multilingual text unevenly updated."@en ;
  skos:scopeNote "El rango de esta propiedad es intencionalmente genérico con el objetivo de permitir distintas codificaciones geométricas. Por ejemplo, la geometría puede codificarse como WKT (geosparql:wktLiteral [GeoSPARQL]) o [GML] (geosparql:asGML [GeoSPARQL])."@es ;
  skos:scopeNote "Obor hodnot této vlastnosti je úmyslně obecný, aby umožnil různé kódování geometrií. Geometrie by kupříkladu mohla být kódována jako WKT (geosparql:wktLiteral [GeoSPARQL]) či [GML] (geosparql:asGML [GeoSPARQL])."@cs ;
  skos:scopeNote "The range of this property (rdfs:Literal) is intentionally generic, with the purpose of allowing different geometry literal encodings. E.g., the geometry could be encoded as a WKT literal (geosparql:wktLiteral [GeoSPARQL])."@en ;
  skos:scopeNote "Il range di questa proprietà (rdfs:Literal) è volutamente generica, con lo scopo di consentire diverse codifiche geometriche letterali. Ad esempio, la geometria potrebbe essere codificata con un letterale WKT (geosparql:wktLiteral [GeoSPARQL]) o [GML] (geosparql:asGML [GeoSPARQL])."@it ;
  skos:scopeNote "Rækkevidden for denne egenskab er bevidst generisk definere med det formål at tillade forskellige geokodninger. Geometrien kan eksempelvis repræsenteres som WKT (geosparql:asWKT [GeoSPARQL]) eller [GML] (geosparql:asGML [GeoSPARQL])."@da ;
.
dcat:compressFormat
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "El formato de la distribución en el que los datos están en forma comprimida, e.g. para reducir el tamaño del archivo a bajar."@es ;
  rdfs:comment "Formát komprese souboru, ve kterém jsou data poskytována v komprimované podobě, např. ke snížení velikosti souboru ke stažení."@cs ;
  rdfs:comment "Il formato di compressione della distribuzione nel quale i dati sono in forma compressa, ad es. per ridurre le dimensioni del file da scaricare."@it ;
  rdfs:comment "The compression format of the distribution in which the data is contained in a compressed form, e.g. to reduce the size of the downloadable file."@en ;
  rdfs:comment "Kompressionsformatet for distributionen som indeholder data i et komprimeret format, fx for at reducere størrelsen af downloadfilen."@da ;
  rdfs:domain dcat:Distribution ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "compression format"@en ;
  rdfs:label "formato de compresión"@es ;
  rdfs:label "formato di compressione"@it ;
  rdfs:label "formát komprese"@cs ;
  rdfs:label "kompressionsformat"@da ;
  rdfs:range dcterms:MediaType ;
  rdfs:subPropertyOf dcterms:format ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 2."@da ;
  skos:definition "El formato de la distribución en el que los datos están en forma comprimida, e.g. para reducir el tamaño del archivo a bajar."@es ;
  skos:definition "Formát komprese souboru, ve kterém jsou data poskytována v komprimované podobě, např. ke snížení velikosti souboru ke stažení."@cs ;
  skos:definition "Il formato di compressione della distribuzione nel quale i dati sono in forma compressa, ad es. per ridurre le dimensioni del file da scaricare."@it ;
  skos:definition "The compression format of the distribution in which the data is contained in a compressed form, e.g. to reduce the size of the downloadable file."@en ;
  skos:definition "Kompressionsformatet for distributionen som indeholder data i et komprimeret format, fx for at reducere størrelsen af downloadfilen."@da ;
  skos:scopeNote "Esta propiedad se debe usar cuando los archivos de la distribución están comprimidos, por ejemplo en un archivo ZIP. El formato DEBERÍA expresarse usando un 'media type', tales como los definidos en el registro IANA de 'media types' https://www.iana.org/assignments/media-types/, si está disponibles."@es ;
  skos:scopeNote "Questa proprietà deve essere utilizzata quando i file nella distribuzione sono compressi, ad es. in un file ZIP. Il formato DOVREBBE essere espresso usando un tipo di media come definito dal registro dei tipi di media IANA https://www.iana.org/assignments/media-types/, se disponibile."@it ;
  skos:scopeNote "Tato vlastnost se použije, když jsou soubory v distribuci komprimovány, např. v ZIP souboru. Formát BY MĚL být vyjádřen pomocí typu média definovaného v registru IANA https://www.iana.org/assignments/media-types/, pokud existuje."@cs ;
  skos:scopeNote "This property is to be used when the files in the distribution are compressed, e.g. in a ZIP file. The format SHOULD be expressed using a media type as defined by IANA media types registry https://www.iana.org/assignments/media-types/, if available."@en ;
  skos:scopeNote "Denne egenskab kan anvendes når filerne i en distribution er blevet komprimeret, fx i en ZIP-fil. Formatet BØR udtrykkes ved en medietype som defineret i 'IANA media types registry', hvis der optræder en relevant medietype dér: https://www.iana.org/assignments/media-types/."@da ;
.
dcat:contactPoint
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "Información relevante de contacto para el recurso catalogado. Se recomienda el uso de vCard."@es ;
  rdfs:comment "Informazioni di contatto rilevanti per la risorsa catalogata. Si raccomanda l'uso di vCard."@it ;
  rdfs:comment "Relevant contact information for the catalogued resource. Use of vCard is recommended."@en ;
  rdfs:comment "Relevantní kontaktní informace pro katalogizovaný zdroj. Doporučuje se použít slovník VCard."@cs ;
  rdfs:comment "Relie un jeu de données à une information de contact utile en utilisant VCard."@fr ;
  rdfs:comment "Συνδέει ένα σύνολο δεδομένων με ένα σχετικό σημείο επικοινωνίας, μέσω VCard."@el ;
  rdfs:comment "تربط قائمة البيانات بعنوان اتصال موصف  باستخدام VCard"@ar ;
  rdfs:comment "データセットを、VCardを用いて提供されている適切な連絡先情報にリンクします。"@ja ;
  rdfs:comment "Relevante kontaktoplysninger for den katalogiserede ressource. Anvendelse af vCard anbefales."@da ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "Punto de contacto"@es ;
  rdfs:label "contact point"@en ;
  rdfs:label "kontaktní bod"@cs ;
  rdfs:label "point de contact"@fr ;
  rdfs:label "punto di contatto"@it ;
  rdfs:label "σημείο επικοινωνίας"@el ;
  rdfs:label "عنوان اتصال"@ar ;
  rdfs:label "窓口"@ja ;
  rdfs:label "kontaktpunkt"@da ;
  rdfs:range vcard:Kind ;
  skos:definition "Información relevante de contacto para el recurso catalogado. Se recomienda el uso de vCard."@es ;
  skos:definition "Informazioni di contatto rilevanti per la risorsa catalogata. Si raccomanda l'uso di vCard."@it ;
  skos:definition "Relevant contact information for the catalogued resource. Use of vCard is recommended."@en ;
  skos:definition "Relevantní kontaktní informace pro katalogizovaný zdroj. Doporučuje se použít slovník VCard."@cs ;
  skos:definition "Relie un jeu de données à une information de contact utile en utilisant VCard."@fr ;
  skos:definition "Συνδέει ένα σύνολο δεδομένων με ένα σχετικό σημείο επικοινωνίας, μέσω VCard."@el ;
  skos:definition "تربط قائمة البيانات بعنوان اتصال موصف  باستخدام VCard"@ar ;
  skos:definition "データセットを、VCardを用いて提供されている適切な連絡先情報にリンクします。"@ja ;
  skos:definition "Relevante kontaktoplysninger for den katalogiserede ressource. Anvendelse af vCard anbefales."@da ;
  skos:editorialNote "Status: English Definition text modified by DCAT revision team, Italian, Spanish and Czech translations provided, other translations pending."@en ;
.
dcat:dataset
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A dataset that is listed in the catalog."@en ;
  rdfs:comment "Kolekce dat, která je katalogizována v katalogu."@cs ;
  rdfs:comment "Relie un catalogue à un jeu de données faisant partie de ce catalogue."@fr ;
  rdfs:comment "Un conjunto de datos que se lista en el catálogo."@es ;
  rdfs:comment "Una raccolta di dati che è elencata nel catalogo."@it ;
  rdfs:comment "Συνδέει έναν κατάλογο με ένα σύνολο δεδομένων το οποίο ανήκει στον εν λόγω κατάλογο."@el ;
  rdfs:comment "تربط الفهرس بقائمة بيانات ضمنه"@ar ;
  rdfs:comment "カタログの一部であるデータセット。"@ja ;
  rdfs:comment "En samling af data som er opført i kataloget."@da ;
  rdfs:domain dcat:Catalog ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "conjunto de datos"@es ;
  rdfs:label "dataset"@en ;
  rdfs:label "dataset"@it ;
  rdfs:label "datová sada"@cs ;
  rdfs:label "jeu de données"@fr ;
  rdfs:label "σύνολο δεδομένων"@el ;
  rdfs:label "قائمة بيانات"@ar ;
  rdfs:label "データセット"@ja ;
  rdfs:label "datasæt"@da ;
  rdfs:range dcat:Dataset ;
  rdfs:subPropertyOf dcat:resource ;
  skos:altLabel "har datasæt"@da ;
  skos:altLabel "datasamling"@da ;
  skos:altLabel "has dataset"@en;
  skos:definition "A dataset that is listed in the catalog."@en ;
  skos:definition "Kolekce dat, která je katalogizována v katalogu."@cs ;
  skos:definition "Relie un catalogue à un jeu de données faisant partie de ce catalogue."@fr ;
  skos:definition "Un conjunto de datos que se lista en el catálogo."@es ;
  skos:definition "Una raccolta di dati che è elencata nel catalogo."@it ;
  skos:definition "Συνδέει έναν κατάλογο με ένα σύνολο δεδομένων το οποίο ανήκει στον εν λόγω κατάλογο."@el ;
  skos:definition "تربط الفهرس بقائمة بيانات ضمنه"@ar ;
  skos:definition "カタログの一部であるデータセット。"@ja ;
  skos:definition "En samling af data som er opført i kataloget."@da ;
  skos:editorialNote "Status: English Definition text modified by DCAT 3 revision team, translations pending."@en ;
.
dcat:distribution
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "An available distribution of the dataset."@en ;
  rdfs:comment "Connecte un jeu de données à des distributions disponibles."@fr ;
  rdfs:comment "Dostupná distribuce datové sady."@cs ;
  rdfs:comment "Una distribución disponible del conjunto de datos."@es ;
  rdfs:comment "Una distribuzione disponibile per il set di dati."@it ;
  rdfs:comment "Συνδέει ένα σύνολο δεδομένων με μία από τις διαθέσιμες διανομές του."@el ;
  rdfs:comment "تربط قائمة البيانات بطريقة أو بشكل يسمح  الوصول الى البيانات"@ar ;
  rdfs:comment "データセットを、その利用可能な配信に接続します。"@ja ;
  rdfs:comment "En tilgængelig repræsentation af datasættet."@da ;
  rdfs:domain dcat:Dataset ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "distribuce"@cs ;
  rdfs:label "distribución"@es ;
  rdfs:label "distribution"@en ;
  rdfs:label "distribution"@fr ;
  rdfs:label "distribuzione"@it ;
  rdfs:label "distribution"@da ;
  skos:altLabel "har distribution"@da ;
  skos:altLabel "has distribution"@en ;
  rdfs:label "διανομή"@el ;
  rdfs:label "توزيع"@ar ;
  rdfs:label "データセット配信"@ja ;
  rdfs:range dcat:Distribution ;
  rdfs:subPropertyOf dcterms:relation ;
  skos:definition "An available distribution of the dataset."@en ;
  skos:definition "Connecte un jeu de données à des distributions disponibles."@fr ;
  skos:definition "Dostupná distribuce datové sady."@cs ;
  skos:definition "Una distribución disponible del conjunto de datos."@es ;
  skos:definition "Una distribuzione disponibile per il set di dati."@it ;
  skos:definition "Συνδέει ένα σύνολο δεδομένων με μία από τις διαθέσιμες διανομές του."@el ;
  skos:definition "تربط قائمة البيانات بطريقة أو بشكل يسمح  الوصول الى البيانات"@ar ;
  skos:definition "データセットを、その利用可能な配信に接続します。"@ja ;
  skos:definition "En tilgængelig repræsentation af datasættet."@da ;
  skos:editorialNote "Status: English Definition text modified by DCAT revision team, translations pending (except for Italian, Spanish and Czech)."@en ;
.

dcat:downloadURL
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "Ceci est un lien direct à un fichier téléchargeable en un format donnée. Exple fichier CSV ou RDF. Le format est décrit par les propriétés de distribution dcterms:format et/ou dcat:mediaType."@fr ;
  rdfs:comment "La URL de un archivo descargable en el formato dato. Por ejemplo, archivo CSV o archivo RDF. El formato se describe con las propiedades de la distribución dcterms:format y/o dcat:mediaType."@es ;
  rdfs:comment "Questo è un link diretto al file scaricabile in un dato formato. E.g. un file CSV o un file RDF. Il formato è descritto dal dcterms:format e/o dal dcat:mediaType della distribuzione."@it ;
  rdfs:comment "The URL of the downloadable file in a given format. E.g. CSV file or RDF file. The format is indicated by the distribution's dcterms:format and/or dcat:mediaType."@en ;
  rdfs:comment "URL souboru ke stažení v daném formátu, například CSV nebo RDF soubor. Formát je popsán vlastností distribuce dcterms:format a/nebo dcat:mediaType."@cs ;
  rdfs:comment "dcat:downloadURLはdcat:accessURLの特定の形式です。しかし、DCATプロファイルが非ダウンロード・ロケーションに対してのみaccessURLを用いる場合には、より強い分離を課すことを望む可能性があるため、この含意を強化しないように、DCATは、dcat:downloadURLをdcat:accessURLのサブプロパティーであると定義しません。"@ja ;
  rdfs:comment "Είναι ένας σύνδεσμος άμεσης μεταφόρτωσης ενός αρχείου σε μια δεδομένη μορφή. Π.χ. ένα αρχείο CSV ή RDF. Η μορφη αρχείου περιγράφεται από τις ιδιότητες dcterms:format ή/και dcat:mediaType της διανομής."@el ;
  rdfs:comment "رابط مباشر لملف يمكن تحميله. نوع الملف يتم توصيفه باستخدام الخاصية dcterms:format dcat:mediaType "@ar ;
  rdfs:comment "URL til fil der kan downloades i et bestemt format. Fx en CSV-fil eller en RDF-fil. Formatet for distributionen angives ved hjælp af egenskaberne dcterms:format og/eller dcat:mediaType."@da ;
  rdfs:domain dcat:Distribution ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "URL de descarga"@es ;
  rdfs:label "URL de téléchargement"@fr ;
  rdfs:label "URL di scarico"@it ;
  rdfs:label "URL souboru ke stažení"@cs ;
  rdfs:label "URL μεταφόρτωσης"@el ;
  rdfs:label "download URL"@en ;
  rdfs:label "رابط تحميل"@ar ;
  rdfs:label "ダウンロードURL"@ja ;
  rdfs:label "downloadURL"@da ;
  rdfs:range rdfs:Resource ;
  skos:definition "Ceci est un lien direct à un fichier téléchargeable en un format donnée. Exple fichier CSV ou RDF. Le format est décrit par les propriétés de distribution dcterms:format et/ou dcat:mediaType."@fr ;
  skos:definition "La URL de un archivo descargable en el formato dato. Por ejemplo, archivo CSV o archivo RDF. El formato se describe con las propiedades de la distribución dcterms:format y/o dcat:mediaType."@es ;
  skos:definition "Questo è un link diretto al file scaricabile in un dato formato. E.g. un file CSV o un file RDF. Il formato è descritto dal dcterms:format e/o dal dcat:mediaType della distribuzione."@it ;
  skos:definition "The URL of the downloadable file in a given format. E.g. CSV file or RDF file. The format is indicated by the distribution's dcterms:format and/or dcat:mediaType."@en ;
  skos:definition "URL souboru ke stažení v daném formátu, například CSV nebo RDF soubor. Formát je popsán vlastností distribuce dcterms:format a/nebo dcat:mediaType."@cs ;
  skos:definition "dcat:downloadURLはdcat:accessURLの特定の形式です。しかし、DCATプロファイルが非ダウンロード・ロケーションに対してのみaccessURLを用いる場合には、より強い分離を課すことを望む可能性があるため、この含意を強化しないように、DCATは、dcat:downloadURLをdcat:accessURLのサブプロパティーであると定義しません。"@ja ;
  skos:definition "Είναι ένας σύνδεσμος άμεσης μεταφόρτωσης ενός αρχείου σε μια δεδομένη μορφή. Π.χ. ένα αρχείο CSV ή RDF. Η μορφη αρχείου περιγράφεται από τις ιδιότητες dcterms:format ή/και dcat:mediaType της διανομής."@el ;
  skos:definition "URL til fil der kan downloades i et bestemt format. Fx en CSV-fil eller en RDF-fil. Formatet for distributionen angives ved hjælp af egenskaberne dcterms:format og/eller dcat:mediaType."@da ;
  skos:definition "رابط مباشر لملف يمكن تحميله. نوع الملف يتم توصيفه باستخدام الخاصية dcterms:format dcat:mediaType "@ar ;
  skos:editorialNote "Status: English  Definition text modified by DCAT revision team, Italian, Spanish and Czech translation updated, other translations pending."@en ;
  skos:editorialNote "rdfs:label, rdfs:comment and/or skos:scopeNote have been modified. Non-english versions must be updated."@en ;
  skos:scopeNote "El valor es una URL."@es ;
  skos:scopeNote "La valeur est une URL."@fr ;
  skos:scopeNote "dcat:downloadURL BY MĚLA být použita pro adresu, ze které je distribuce přímo přístupná, typicky skrze požadavek HTTP Get."@cs ;
  skos:scopeNote "dcat:downloadURL DOVREBBE essere utilizzato per l'indirizzo a cui questa distribuzione è disponibile direttamente, in genere attraverso una richiesta Get HTTP."@it ;
  skos:scopeNote "dcat:downloadURL SHOULD be used for the address at which this distribution is available directly, typically through a HTTP Get request."@en ;
  skos:scopeNote "Η τιμή είναι ένα URL."@el ;
  skos:scopeNote "dcat:downloadURL BØR anvendes til angivelse af den adresse hvor distributionen er tilgængelig direkte, typisk gennem et HTTP Get request."@da ;
.
dcat:endDate
  a rdf:Property ;
  a owl:DatatypeProperty ;
  rdfs:comment "El fin del período."@es ;
  rdfs:comment "Konec doby trvání."@cs ;
  rdfs:comment "The end of the period."@en ;
  rdfs:comment "La fine del periodo."@it ;
  rdfs:comment "Slutningen på perioden."@da ;
  rdfs:domain dcterms:PeriodOfTime ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "datum konce"@cs ;
  rdfs:label "end date"@en ;
  rdfs:label "data di fine"@it ;
  rdfs:label "fecha final"@es ;
  rdfs:label "slutdato"@da ;
  rdfs:range rdfs:Literal ;
  skos:altLabel "sluttidspunkt"@da ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@es ;
  skos:changeNote "Ny egenskab i DCAT 2."@da ;
  skos:definition "El fin del período."@es ;
  skos:definition "Konec doby trvání."@cs ;
  skos:definition "The end of the period."@en ;
  skos:definition "La fine del periodo."@it ;
  skos:definition "Slutningen på perioden."@da ;
  skos:scopeNote "El rango de esta propiedad es intencionalmente genérico con el propósito de permitir distintos niveles de precisión temporal para especificar el fin del período. Por ejemplo, puede expresarse como una fecha (xsd:date), una fecha y un tiempo (xsd:dateTime), o un año (xsd:gYear)."@es ;
  skos:scopeNote "Obor hodnot této vlastnosti je úmyslně obecný, aby umožnil různé úrovně časového rozlišení pro specifikaci konce doby trvání. Ten může být kupříkladu vyjádřen datumem (xsd:date), datumem a časem (xsd:dateTime) či rokem (xsd:gYear)."@cs ;
  skos:scopeNote "The range of this property is intentionally generic, with the purpose of allowing different level of temporal precision for specifying the end of a period. E.g., it can be expressed with a date (xsd:date), a date and time (xsd:dateTime), or a year (xsd:gYear)."@en ;
  skos:scopeNote "La range di questa proprietà è volutamente generico, con lo scopo di consentire diversi livelli di precisione temporale per specificare la fine di un periodo. Ad esempio, può essere espresso con una data (xsd:date), una data e un'ora (xsd:dateTime), o un anno (xsd:gYear)."@it ;
  skos:scopeNote "Rækkeviden for denne egenskab er bevidst generisk defineret med det formål at tillade forskellige niveauer af tidslig præcision ifm. angivelse af slutdatoen for en periode. Den kan eksempelvis udtrykkes som en dato (xsd:date), en dato og et tidspunkt (xsd:dateTime), eller et årstal (xsd:gYear)."@da ;
.
dcat:endpointDescription
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A description of the service end-point, including its operations, parameters etc."@en ;
  rdfs:comment "Popis přístupového bodu služby včetně operací, parametrů apod."@cs ;
  rdfs:comment "Una descripción del end-point del servicio, incluyendo sus operaciones, parámetros, etc."@es ;
  rdfs:comment "Una descrizione dell'endpoint del servizio, incluse le sue operazioni, parametri, ecc."@it ;
  rdfs:comment "En beskrivelse af det pågældende tjenesteendpoint, inklusiv dets operationer, parametre etc."@da ;
  rdfs:domain dcat:DataService ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "descripción del end-point del servicio"@es ;
  rdfs:label "description of service end-point"@en ;
  rdfs:label "descrizione dell'endpoint del servizio"@it ;
  rdfs:label "popis přístupového bodu služby"@cs ;
  rdfs:label "endpointbeskrivelse"@da ;
  skos:changeNote "New property in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@en ;
  skos:changeNote "Nuova proprietà in DCAT 2."@it ;
  skos:changeNote "Ny egenskab i DCAT 2."@da ;
  skos:definition "A description of the service end-point, including its operations, parameters etc."@en ;
  skos:definition "Popis přístupového bodu služby včetně operací, parametrů apod."@cs ;
  skos:definition "Una descripción del end-point del servicio, incluyendo sus operaciones, parámetros, etc.."@es ;
  skos:definition "Una descrizione dell'endpoint del servizio, incluse le sue operazioni, parametri, ecc."@it ;
  skos:definition "En beskrivelse af det pågældende tjenesteendpoint, inklusiv dets operationer, parametre etc."@da ;
  skos:scopeNote "An endpoint description may be expressed in a machine-readable form, such as an OpenAPI (Swagger) description, an OGC GetCapabilities response, a SPARQL Service Description, an OpenSearch or WSDL document, a Hydra API description, else in text or some other informal mode if a formal representation is not possible."@en ;
  skos:scopeNote "La descripción del endpoint brinda detalles específicos de la instancia del endpoint, mientras que dcterms:conformsTo se usa para indicar el estándar general o especificación que implementa el endpoint."@es ;
  skos:scopeNote "La descrizione dell'endpoint fornisce dettagli specifici dell'istanza dell'endpoint reale, mentre dcterms:conformsTo viene utilizzato per indicare lo standard o le specifiche implementate dall'endpoint."@it ;
  skos:scopeNote "Popis přístupového bodu dává specifické detaily jeho konkrétní instance, zatímco dcterms:conformsTo indikuje obecný standard či specifikaci kterou přístupový bod implementuje."@cs ;
  skos:scopeNote "Popis přístupového bodu může být vyjádřen ve strojově čitelné formě, například jako popis OpenAPI (Swagger), odpověď služby OGC getCapabilities, pomocí slovníku SPARQL Service Description, jako OpenSearch či WSDL document, jako popis API dle slovníku Hydra, a nebo textově nebo jiným neformálním způsobem, pokud není možno použít formální reprezentaci."@cs ;
  skos:scopeNote "The endpoint description gives specific details of the actual endpoint instance, while dcterms:conformsTo is used to indicate the general standard or specification that the endpoint implements."@en ;
  skos:scopeNote "Una descripción del endpoint del servicio puede expresarse en un formato que la máquina puede interpretar, tal como una descripción basada en OpenAPI (Swagger), una respuesta OGC GetCapabilities, una descripción de un servicio SPARQL, un documento OpenSearch o WSDL, una descripción con la Hydra API, o en texto u otro modo informal si la representación formal no es posible."@es ;
  skos:scopeNote "Una descrizione dell'endpoint può essere espressa in un formato leggibile dalla macchina, come una descrizione OpenAPI (Swagger), una risposta GetCapabilities OGC, una descrizione del servizio SPARQL, un documento OpenSearch o WSDL, una descrizione API Hydra, o con del testo o qualche altra modalità informale se una rappresentazione formale non è possibile."@it ;
  skos:scopeNote "En beskrivelse af et endpoint kan udtrykkes i et maskinlæsbart format, såsom OpenAPI (Swagger)-beskrivelser, et OGC GetCapabilities svar, en SPARQL tjenestebeskrivelse, en OpenSearch- eller et WSDL-dokument, en Hydra-API-beskrivelse, eller i tekstformat eller i et andet uformelt format, hvis en formel repræsentation ikke er mulig."@da ;
  skos:scopeNote "Endpointbeskrivelsen giver specifikke oplysninger om den konkrete endpointinstans, mens dcterms:conformsTo anvendes til at indikere den overordnede standard eller specifikation som endpointet er i overensstemmelse med."@da ;
.
dcat:endpointURL
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "Kořenové umístění nebo hlavní přístupový bod služby (IRI přístupné přes Web)."@cs ;
  rdfs:comment "La locazione principale o l'endpoint primario del servizio (un IRI risolvibile via web)."@it ;
  rdfs:comment "La posición raíz o end-point principal del servicio (una IRI web)."@es ;
  rdfs:comment "The root location or primary endpoint of the service (a web-resolvable IRI)."@en ;
  rdfs:comment "Rodplaceringen eller det primære endpoint for en tjeneste (en web-resolverbar IRI)."@da ;
  rdfs:domain dcat:DataService ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "end-point del servicio"@es ;
  rdfs:label "end-point del servizio"@it ;
  rdfs:label "přístupový bod služby"@cs ;
  rdfs:label "service end-point"@en ;
  rdfs:label "tjenesteendpoint"@da ;
  rdfs:range rdfs:Resource ;
  skos:changeNote "New property in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@es ;
  skos:changeNote "Nuova proprietà in DCAT 2."@it ;
  skos:definition "Kořenové umístění nebo hlavní přístupový bod služby (IRI přístupné přes Web)."@cs ;
  skos:definition "La locazione principale o l'endpoint primario del servizio (un IRI risolvibile via web)."@it ;
  skos:definition "La posición raíz o end-point principal del servicio (una IRI web)."@es ;
  skos:definition "The root location or primary endpoint of the service (a web-resolvable IRI)."@en ;
  skos:definition "Rodplaceringen eller det primære endpoint for en tjeneste (en web-resolverbar IRI)."@da ;
.
dcat:first
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "The first resource in an ordered collection or series of resources, to which the current resource belongs."@en ;
  rdfs:comment "El primer recurso en una colección ordenada o serie de recursos, al que el recurso pertenece."@es ;
  rdfs:comment "La prima risorsa in una collezione ordinata o in una serie di risorse, di cui la risorsa fa parte."@it ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  rdfs:label "first"@en ;
  rdfs:label "primero"@es ;
  rdfs:label "primo"@it ;
  rdfs:subPropertyOf xhv:first ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nueva propiedad agregada in DCAT 3."@es ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 3."@da ;
  skos:definition "The first resource in an ordered collection or series of resources, to which the current resource belongs."@en ;
  skos:definition "El primer recurso en una colección ordenada o serie de recursos, al que el recurso pertenece."@es ;
  skos:definition "La prima risorsa in una collezione ordinata o in una serie di risorse, di cui la risorsa fa parte."@it ;
  skos:scopeNote "In DCAT this property is used for resources belonging to a dcat:DatasetSeries."@en ;
  skos:scopeNote "En DCAT esta propiedad se usa para recursos que pertenecen a una dcat:DatasetSeries."@es ;
  skos:scopeNote "In DCAT questa proprietà è usata per risorse che fanno parte di una dcat:DatasetSeries."@it ;
.
dcat:hasCurrentVersion
  a rdf:Property ;
  a owl:ObjectProperty ;
  owl:equivalentProperty pav:hasCurrentVersion ;
  rdfs:subPropertyOf pav:hasVersion ;
  rdfs:comment "This resource has a more specific, versioned resource with equivalent content [PAV]."@en ;
  rdfs:comment "Este recurso es más específico y versionado con contenido equivalente [PAV]."@es ;
  rdfs:comment "Per questa risorsa esiste una risorsa più specifica e versionata, ma con lo stesso contenuto."@it ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  rdfs:label "has current version"@en ;
  rdfs:label "tiene versión actual"@es ;
  rdfs:label "ha versione attuale"@it ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nueva propiedad agregada in DCAT 3."@es ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 3."@da ;
  skos:definition "This resource has a more specific, versioned resource with equivalent content [PAV]."@en ;
  skos:definition "Este recurso es más específico y versionado con contenido equivalente [PAV]."@es ;
  skos:definition "Per questa risorsa esiste una risorsa più specifica e versionata, ma con lo stesso contenuto."@it ;
  skos:scopeNote "This property is intended for relating a non-versioned or abstract resource to a single snapshot that can be used as a permalink to indicate the current version of the content [PAV]."@en ;
  skos:scopeNote "Esta propepiedad está destinada a relacionar un recurso no versionado o abstracto con una versión instantánea que puede usarse como un enlace permanente a la versión actual del recurso [PAV]."@es ;
  skos:scopeNote "Questa proprietà è usata per correlare una risorsa non versionata o astratta a un suo specifico snapshot che può essere usato come permalink per indicare la versione attuale del suo contenuto."@it ;
  skos:scopeNote "The notion of version used by this property is limited to versions resulting from revisions occurring to a resource as part of its life-cycle."@en ;
  skos:scopeNote "La noción de versión que se usa en esta propiedad está limitada a las versiones que resultan de revisiones de un recurso como parte de su ciclo de vida."@es ;
  skos:scopeNote "La nozione di versione usata da questa proprietà è limitata a versioni risultanti da revisioni a cui una risorsa è soggetta nel suo ciclo di vita."@it ;
.
dcat:hasVersion
  a rdf:Property ;
  a owl:ObjectProperty ;
  owl:equivalentProperty pav:hasVersion ;
  rdfs:comment "This resource has a more specific, versioned resource [PAV]."@en ;
  rdfs:comment "Este recurso tiene una versión específica."@es ;
  rdfs:comment "Per questa risorsa esiste una risorsa più specifica e versionata."@it ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  rdfs:label "has version"@en ;
  rdfs:label "tiene versión"@es ;
  rdfs:label "ha versione"@it ;
  rdfs:subPropertyOf dcterms:hasVersion ;
  rdfs:subPropertyOf prov:generalizationOf ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nueva propiedad agregada in DCAT 3."@es ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 3."@da ;
  skos:definition "This resource has a more specific, versioned resource [PAV]."@en ;
  skos:definition "Este recurso tiene una versión específica."@es ;
  skos:definition "Per questa risorsa esiste una risorsa più specifica e versionata."@it ;
  skos:scopeNote "This property is intended for relating a non-versioned or abstract resource to several versioned resources, e.g., snapshots [PAV]."@en ;
  skos:scopeNote "Esta propiedad se utiliza para relacionar un recurso abstracto o no versionado de un recurso con varias versiones del recuros; por ejemplo, versiones intastáneas."@es ;
  skos:scopeNote "Questa proprietà è usata per correlare una risorsa non versionata o astratta a differenti risorse versionate, ad es., i relativi snapshot."@it ;
  skos:scopeNote "The notion of version used by this property is limited to versions resulting from revisions occurring to a resource as part of its life-cycle. Therefore, its semantics is more specific than its super-property dcterms:hasVersion, which makes use of a broader notion of version, including editions and adaptations."@en ;
  skos:scopeNote "La noción de versión que se usa en esta propiedad está limitada a las versiones que resultan de revisiones de un recurso como parte de su ciclo de vida. Por lo tanto, su semántica es más específica que su super-propiedad dcterns:hasVersion, la cuál hace uso de la noción más amplia de versión, incluyendo ediciones y adaptaciones."@es ;
  skos:scopeNote "La nozione di versione usata da questa proprietà è limitata a versioni risultanti da revisioni a cui una risorsa è soggetta nel suo ciclo di vita. Quindi la sua semantica è più specifica di quella della sua super-proprietà dcterms:hasVersion, che utilizza una nozione di versione più ampia, e include, ad es., edizioni e adattamenti."@it ;
.
dcat:hadRole
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "Funkce entity či agenta ve vztahu k jiné entitě či zdroji."@cs ;
  rdfs:comment "La función de una entidad o agente con respecto a otra entidad o recurso."@es ;
  rdfs:comment "La funzione di un'entità o un agente rispetto ad un'altra entità o risorsa."@it ;
  rdfs:comment "The function of an entity or agent with respect to another entity or resource."@en ;
  rdfs:comment "Den funktion en entitet eller aktør har i forhold til en anden ressource."@da ;
  rdfs:domain [
      a owl:Class ;
      owl:unionOf (
          prov:Attribution
          dcat:Relationship
        ) ;
    ] ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "haRuolo"@it ;
  rdfs:label "hadRole"@en ;
  rdfs:label "sehraná role"@cs ;
  rdfs:label "tiene rol"@it ;
  rdfs:label "havde rolle"@da ;
  rdfs:range dcat:Role ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:definition "Funkce entity či agenta ve vztahu k jiné entitě či zdroji."@cs ;
  skos:definition "La función de una entidad o agente con respecto a otra entidad o recurso."@es ;
  skos:definition "La funzione di un'entità o un agente rispetto ad un'altra entità o risorsa."@it ;
  skos:definition "The function of an entity or agent with respect to another entity or resource."@en ;
  skos:definition "Den funktion en entitet eller aktør har i forhold til en anden ressource."@da ;
  skos:editorialNote "Agregada en DCAT para complementar prov:hadRole (cuyo uso está limitado a roles en el contexto de una actividad, con dominio prov:Association."@es ;
  skos:editorialNote "Introdotta in DCAT per completare prov:hadRole (il cui uso è limitato ai ruoli nel contesto di un'attività, con il dominio di prov:Association."@it ;
  skos:editorialNote "Introduced into DCAT to complement prov:hadRole (whose use is limited to roles in the context of an activity, with the domain of prov:Association."@en ;
  skos:editorialNote "Přidáno do DCAT pro doplnění vlastnosti prov:hadRole (jejíž užití je omezeno na role v kontextu aktivity, s definičním oborem prov:Association)."@cs ;
  skos:editorialNote "Introduceret i DCAT for at supplere prov:hadRole (hvis anvendelse er begrænset til roller i forbindelse med en aktivitet med domænet prov:Association)."@da ;
  skos:scopeNote "May be used in a qualified-attribution to specify the role of an Agent with respect to an Entity. It is recommended that the value be taken from a controlled vocabulary of agent roles, such as http://registry.it.csiro.au/def/isotc211/CI_RoleCode."@en ;
  skos:scopeNote "May be used in a qualified-relation to specify the role of an Entity with respect to another Entity.  It is recommended that the value be taken from a controlled vocabulary of entity roles such as: ISO 19115 DS_AssociationTypeCode http://registry.it.csiro.au/def/isotc211/DS_AssociationTypeCode; IANA Registry of Link Relations https://www.iana.org/assignments/link-relation; DataCite metadata schema; MARC relators https://id.loc.gov/vocabulary/relators."@en ;
  skos:scopeNote "Může být použito v kvalifikovaném přiřazení pro specifikaci role Agenta ve vztahu k Entitě. Je doporučeno hodnotu vybrat z řízeného slovníku rolí agentů, jako například http://registry.it.csiro.au/def/isotc211/CI_RoleCode."@cs ;
  skos:scopeNote "Může být použito v kvalifikovaném vztahu pro specifikaci role Entity ve vztahu k jiné Entitě. Je doporučeno použít hodnotu z řízeného slovníku rolí entit, jako například ISO 19115 DS_AssociationTypeCode http://registry.it.csiro.au/def/isotc211/DS_AssociationTypeCode, IANA Registry of Link Relations https://www.iana.org/assignments/link-relation, DataCite metadata schema, MARC relators https://id.loc.gov/vocabulary/relators."@cs ;
  skos:scopeNote "Puede usarse en una atribución cualificada para especificar el rol de un Agente con respecto a una Entidad. Se recomienda que el valor sea de un vocabulario controlado de roles de agentes, como por ejemplo http://registry.it.csiro.au/def/isotc211/CI_RoleCode."@es ;
  skos:scopeNote "Puede usarse en una atribución cualificada para especificar el rol de una Entidad con respecto a otra Entidad. Se recomienda que su valor se tome de un vocabulario controlado de roles de entidades como por ejemplo: ISO 19115 DS_AssociationTypeCode http://registry.it.csiro.au/def/isotc211/DS_AssociationTypeCode; IANA Registry of Link Relations https://www.iana.org/assignments/link-relation; esquema de metadatos de DataCite; MARC relators https://id.loc.gov/vocabulary/relators."@es ;
  skos:scopeNote "Può essere utilizzata in una relazione qualificata per specificare il ruolo di un'entità rispetto a un'altra entità. Si raccomanda che il valore sia preso da un vocabolario controllato di ruoli di entità come ISO 19115 DS_AssociationTypeCode http://registry.it.csiro.au/def/isotc211/DS_AssociationTypeCode, IANA Registry of Link Relations https://www.iana.org/assignments/link-relation, DataCite metadata schema, o MARC relators https://id.loc.gov/vocabulary/relators."@it ;
  skos:scopeNote "Può essere utilizzato in un'attribuzione qualificata per specificare il ruolo di un agente rispetto a un'entità. Si raccomanda che il valore sia preso da un vocabolario controllato di ruoli di agente, come ad esempio http://registry.it.csiro.au/def/isotc211/CI_RoleCode."@it ;
  skos:scopeNote "Kan vendes ved kvalificerede krediteringer til at angive en aktørs rolle i forhold en entitet. Det anbefales at værdierne styres som et kontrolleret udfaldsrum med aktørroller, såsom http://registry.it.csiro.au/def/isotc211/CI_RoleCode."@da ;
.
dcat:isDistributionOf owl:inverseOf dcat:distribution ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 3."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:scopeNote "This property MAY be used only in addition to its inverse, and it MUST NOT be used to replace it."@en ;
  skos:scopeNote "Esta propiedad inversa PUEDE usarse sólo en combinación con su inversa, y NO PUEDE utilizarse en su reemplazo."@es ;
  skos:scopeNote "Questa proprietà PUÒ essere usata solo insieme alla sua inversa, e NON DEVE essere usata per sostituirla."@it ;
.
dcat:isVersionOf owl:inverseOf dcat:hasVersion ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 3."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:scopeNote "This property MAY be used only in addition to its inverse, and it MUST NOT be used to replace it."@en ;
  skos:scopeNote "Esta propiedad inversa PUEDE usarse sólo en combinación con su inversa, y NO PUEDE utilizarse en su reemplazo."@es ;
  skos:scopeNote "Questa proprietà PUÒ essere usata solo insieme alla sua inversa, e NON DEVE essere usata per sostituirla."@it ;
.
dcat:inCatalog owl:inverseOf dcat:resource ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 3."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:scopeNote "This property MAY be used only in addition to its inverse, and it MUST NOT be used to replace it."@en ;
  skos:scopeNote "Esta propiedad inversa PUEDE usarse sólo en combinación con su inversa, y NO PUEDE utilizarse en su reemplazo."@es ;
  skos:scopeNote "Questa proprietà PUÒ essere usata solo insieme alla sua inversa, e NON DEVE essere usata per sostituirla."@it ;
.
dcat:inSeries
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A dataset series of which the dataset is part."@en ;
  rdfs:comment "Una serie de conjuntos de datos del cuál un conjunto de datos es parte."@es ;
  rdfs:comment "Una serie di dataset di cui questo dataset fa parte."@it ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  rdfs:label "in series"@en ;
  rdfs:label "en serie"@es ;
  rdfs:label "in serie"@it ;
  rdfs:subPropertyOf dcterms:isPartOf ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nueva propiedad agregada in DCAT 3."@es ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 3."@da ;
  skos:definition "A dataset series of which the dataset is part."@en ;
  skos:definition "Una serie de conjuntos de datos del cuál un conjunto de datos es parte."@es ;
  skos:definition "Una serie di dataset di cui questo dataset fa parte."@it ;
.
dcat:keyword
  a rdf:Property ;
  a owl:DatatypeProperty ;
  rdfs:comment "A keyword or tag describing a resource."@en ;
  rdfs:comment "Klíčové slovo nebo značka popisující zdroj."@cs ;
  rdfs:comment "Un mot-clé ou étiquette décrivant une ressource."@fr ;
  rdfs:comment "Una palabra clave o etiqueta que describe un recurso."@es ;
  rdfs:comment "Una parola chiave o un'etichetta per descrivere la risorsa."@it ;
  rdfs:comment "Μία λέξη-κλειδί ή μία ετικέτα που περιγράφει το σύνολο δεδομένων."@el ;
  rdfs:comment "كلمة  مفتاحيه توصف قائمة البيانات"@ar ;
  rdfs:comment "データセットを記述しているキーワードまたはタグ。"@ja ;
  rdfs:comment "Et nøgleord eller tag til beskrivelse af en ressource."@da ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "keyword"@en ;
  rdfs:label "klíčové slovo"@cs ;
  rdfs:label "mot-clés "@fr ;
  rdfs:label "palabra clave"@es ;
  rdfs:label "parola chiave"@it ;
  rdfs:label "λέξη-κλειδί"@el ;
  rdfs:label "كلمة  مفتاحية "@ar ;
  rdfs:label "キーワード/タグ"@ja ;
  rdfs:label "nøgleord"@da ;
  rdfs:range rdfs:Literal ;
  skos:definition "A keyword or tag describing a resource."@en ;
  skos:definition "Klíčové slovo nebo značka popisující zdroj."@cs ;
  skos:definition "Un mot-clé ou étiquette décrivant une ressource."@fr ;
  skos:definition "Una palabra clave o etiqueta que describe un recurso."@es ;
  skos:definition "Una parola chiave o un'etichetta per descrivere la risorsa."@it ;
  skos:definition "Μία λέξη-κλειδί ή μία ετικέτα που περιγράφει το σύνολο δεδομένων."@el ;
  skos:definition "كلمة  مفتاحيه توصف قائمة البيانات"@ar ;
  skos:definition "データセットを記述しているキーワードまたはタグ。"@ja ;
  skos:definition "Et nøgleord eller tag til beskrivelse af en ressource."@da ;
.
dcat:landingPage
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A Web page that can be navigated to in a Web browser to gain access to the catalog, a dataset, its distributions and/or additional information."@en ;
  rdfs:comment "Una pagina web che può essere navigata per ottenere l'accesso al catalogo, ad un dataset, alle distribuzioni del dataset e/o ad informazioni addizionali."@it ;
  rdfs:comment "Una página web que puede ser visitada en un explorador Web para tener acceso el catálogo, un conjunto de datos, sus distribuciones y/o información adicional."@es ;
  rdfs:comment "Une page Web accessible par un navigateur Web donnant accès au catalogue, un jeu de données, ses distributions et/ou des informations additionnelles."@fr ;
  rdfs:comment "Webová stránka, na kterou lze pro získání přístupu ke katalogu, datové sadě, jejím distribucím a/nebo dalším informacím přistoupit webovým prohlížečem."@cs ;
  rdfs:comment "Μία ιστοσελίδα πλοηγίσιμη μέσω ενός φυλλομετρητή (Web browser) που δίνει πρόσβαση στο σύνολο δεδομένων, τις διανομές αυτού ή/και επιπρόσθετες πληροφορίες."@el ;
  rdfs:comment "صفحة وب يمكن من خلالها الوصول الى قائمة البيانات أو إلى معلومات إضافية متعلقة بها "@ar ;
  rdfs:comment "データセット、その配信および（または）追加情報にアクセスするためにウエブ・ブラウザでナビゲートできるウェブページ。"@ja ;
  rdfs:comment "En webside som der kan navigeres til i en webbrowser for at få adgang til kataloget, et datasæt, dets distributioner og/eller yderligere information."@da ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "landing page"@en ;
  rdfs:label "page d'atterrissage"@fr ;
  rdfs:label "pagina di destinazione"@it ;
  rdfs:label "página de destino"@es ;
  rdfs:label "vstupní stránka"@cs ;
  rdfs:label "ιστοσελίδα αρχικής πρόσβασης"@el ;
  rdfs:label "صفحة وصول"@ar ;
  rdfs:label "ランディング・ページ"@ja ;
  rdfs:label "destinationsside"@da ;
  rdfs:range foaf:Document ;
  rdfs:subPropertyOf foaf:page ;
  skos:definition "A Web page that can be navigated to in a Web browser to gain access to the catalog, a dataset, its distributions and/or additional information."@en ;
  skos:definition "Una pagina web che può essere navigata per ottenere l'accesso al catalogo, ad un dataset, alle distribuzioni del dataset e/o ad informazioni addizionali."@it ;
  skos:definition "Una página web que puede ser visitada en un explorador Web para tener acceso el catálogo, un conjunto de datos, sus distribuciones y/o información adicional."@es ;
  skos:definition "Une page Web accessible par un navigateur Web donnant accès au catalogue, un jeu de données, ses distributions et/ou des informations additionnelles."@fr ;
  skos:definition "Webová stránka, na kterou lze pro získání přístupu ke katalogu, datové sadě, jejím distribucím a/nebo dalším informacím přistoupit webovým prohlížečem."@cs ;
  skos:definition "Μία ιστοσελίδα πλοηγίσιμη μέσω ενός φυλλομετρητή (Web browser) που δίνει πρόσβαση στο σύνολο δεδομένων, τις διανομές αυτού ή/και επιπρόσθετες πληροφορίες."@el ;
  skos:definition "صفحة وب يمكن من خلالها الوصول الى قائمة البيانات أو إلى معلومات إضافية متعلقة بها "@ar ;
  skos:definition "データセット、その配信および（または）追加情報にアクセスするためにウエブ・ブラウザでナビゲートできるウェブページ。"@ja ;
  skos:definition "En webside som en webbrowser kan navigeres til for at få adgang til kataloget, et datasæt, dets distritbutioner og/eller yderligere information."@da ;
  skos:scopeNote "If the distribution(s) are accessible only through a landing page (i.e. direct download URLs are not known), then the landing page link should be duplicated as accessURL on a distribution."@en ;
  skos:scopeNote "Pokud je distribuce dostupná pouze přes vstupní stránku, t.j. přímý URL odkaz ke stažení není znám, URL přístupové stránky by mělo být duplikováno ve vlastnosti distribuce accessURL."@cs ;
  skos:scopeNote "Se la distribuzione è accessibile solo attraverso una pagina di destinazione (cioè, un URL di download diretto non è noto), il link alla pagina di destinazione deve essere duplicato come accessURL sulla distribuzione."@it ;
  skos:scopeNote "Si la distribución es accesible solamente través de una página de aterrizaje (i.e., no se conoce una URL de descarga directa), entonces el enlance a la página de aterrizaje debe ser duplicado como accessURL sobre la distribución."@es ;
  skos:scopeNote "Si la distribution est seulement accessible à travers une page d'atterrissage (exple. pas de connaissance d'URLS de téléchargement direct ), alors le lien de la page d'atterrissage doit être dupliqué comme accessURL sur la distribution."@fr ;
  skos:scopeNote "Αν η/οι διανομή/ές είναι προσβάσιμη/ες μόνο μέσω μίας ιστοσελίδας αρχικής πρόσβασης (δηλαδή αν δεν υπάρχουν γνωστές διευθύνσεις άμεσης μεταφόρτωσης), τότε ο σύνδεσμος της ιστοσελίδας αρχικής πρόσβασης πρέπει να αναπαραχθεί ως accessURL σε μία διανομή."@el ;
  skos:scopeNote "ランディング・ページを通じてしか配信にアクセスできない場合（つまり、直接的なダウンロードURLが不明）には、配信におけるaccessURLとしてランディング・ページのリンクをコピーすべきです（SHOULD）。"@ja ;
  skos:scopeNote "Hvis en eller flere distributioner kun er tilgængelige via en destinationsside (dvs. en URL til direkte download er ikke kendt), så bør destinationssidelinket gentages som adgangsadresse for en distribution."@da ;
.
dcat:last
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "The last resource in an ordered collection or series of resources, to which the current resource belongs."@en ;
  rdfs:comment "El último recurso en una colección ordenada o serie de recursos, al que el recurso pertenece."@es ;
  rdfs:comment "L'ultima risorsa in una collezione ordinata o in una serie di risorse, di cui la risorsa fa parte."@it ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  rdfs:label "last"@en ;
  rdfs:label "último"@es ;
  rdfs:label "ultimo"@it ;
  rdfs:subPropertyOf xhv:last ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nueva propiedad agregada in DCAT 3."@es ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 3."@da ;
  skos:definition "The last resource in an ordered collection or series of resources, to which the current resource belongs."@en ;
  skos:definition "El último recurso en una colección ordenada o serie de recursos, al que el recurso pertenece."@es ;
  skos:definition "L'ultima risorsa in una collezione ordinata o in una serie di risorse, di cui la risorsa fa parte."@it ;
  skos:scopeNote "In DCAT this property is used for resources belonging to a dcat:DatasetSeries."@en ;
  skos:scopeNote "En DCAT esta propiedad se usa para recursos que pertenecen a una dcat:DatasetSeries."@es ;
  skos:scopeNote "In DCAT questa proprietà è usata per risorse che fanno parte di una dcat:DatasetSeries."@it ;
.
dcat:mediaType
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "Cette propriété doit être utilisée quand c'est définit le type de média de la distribution en IANA, sinon dcterms:format DOIT être utilisé avec différentes valeurs."@fr ;
  rdfs:comment "Esta propiedad debe ser usada cuando está definido el tipo de media de la distribución en IANA, de otra manera dcterms:format puede ser utilizado con diferentes valores"@es ;
  rdfs:comment "Il tipo di media della distribuzione come definito da IANA"@it ;
  rdfs:comment "The media type of the distribution as defined by IANA"@en ;
  rdfs:comment "Typ média distribuce definovaný v IANA."@cs ;
  rdfs:comment "Η ιδιότητα αυτή ΘΑ ΠΡΕΠΕΙ να χρησιμοποιείται όταν ο τύπος μέσου μίας διανομής είναι ορισμένος στο IANA, αλλιώς η ιδιότητα dcterms:format ΔΥΝΑΤΑΙ να χρησιμοποιηθεί με διαφορετικές τιμές."@el ;
  rdfs:comment "يجب استخدام هذه الخاصية إذا كان نوع الملف معرف ضمن IANA"@ar ;
  rdfs:comment "このプロパティーは、配信のメディア・タイプがIANAで定義されているときに使用すべきで（SHOULD）、そうでない場合には、dcterms:formatを様々な値と共に使用できます（MAY）。"@ja ;
  rdfs:comment "Medietypen for distributionen som den er defineret af IANA."@da ;
  rdfs:domain dcat:Distribution ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "media type"@en ;
  rdfs:label "tipo de media"@es ;
  rdfs:label "tipo di media"@it ;
  rdfs:label "typ média"@cs ;
  rdfs:label "type de média"@fr ;
  rdfs:label "τύπος μέσου"@el ;
  rdfs:label "نوع الميديا"@ar ;
  rdfs:label "メディア・タイプ"@ja ;
  rdfs:label "medietype"@da ;
  rdfs:range dcterms:MediaType ;
  rdfs:subPropertyOf dcterms:format ;
  skos:changeNote "Obor hodnot dcat:mediaType byl zúžen v této revizi DCAT."@cs ;
  skos:changeNote "The range of dcat:mediaType has been tightened as part of the revision of DCAT."@en ;
  skos:changeNote "Il range di dcat:mediaType è stato ristretto  come parte della revisione di DCAT."@it ;
  skos:definition "Cette propriété doit être utilisée quand c'est définit le type de média de la distribution en IANA, sinon dcterms:format DOIT être utilisé avec différentes valeurs."@fr ;
  skos:definition "Esta propiedad debe ser usada cuando está definido el tipo de media de la distribución en IANA, de otra manera dcterms:format puede ser utilizado con diferentes valores."@es ;
  skos:definition "Il tipo di media della distribuzione come definito da IANA."@it ;
  skos:definition "The media type of the distribution as defined by IANA."@en ;
  skos:definition "Typ média distribuce definovaný v IANA."@cs ;
  skos:definition "Η ιδιότητα αυτή ΘΑ ΠΡΕΠΕΙ να χρησιμοποιείται όταν ο τύπος μέσου μίας διανομής είναι ορισμένος στο IANA, αλλιώς η ιδιότητα dcterms:format ΔΥΝΑΤΑΙ να χρησιμοποιηθεί με διαφορετικές τιμές."@el ;
  skos:definition "يجب استخدام هذه الخاصية إذا كان نوع الملف معرف ضمن IANA"@ar ;
  skos:definition "このプロパティーは、配信のメディア・タイプがIANAで定義されているときに使用すべきで（SHOULD）、そうでない場合には、dcterms:formatを様々な値と共に使用できます（MAY）。"@ja ;
  skos:definition "Medietypen for distributionen som den er defineret af IANA."@da ;
  skos:editorialNote "Status: English Definition text modified by DCAT revision team, Italian and Czech translation provided, other translations pending. Note some inconsistency on def vs. usage."@en ;
  skos:scopeNote "Esta propiedad DEBERÍA usarse cuando el 'media type' de la distribución está definido en el registro IANA de 'media types' https://www.iana.org/assignments/media-types/, de lo contrario, dcterms:format PUEDE usarse con distintos valores."@es ;
  skos:scopeNote "Questa proprietà DEVE essere usata quando il tipo di media della distribuzione è definito nel registro dei tipi di media IANA https://www.iana.org/assignments/media-types/, altrimenti dcterms:format PUO 'essere usato con differenti valori."@it ;
  skos:scopeNote "Tato vlastnost BY MĚLA být použita, je-li typ média distribuce definován v registru IANA https://www.iana.org/assignments/media-types/. V ostatních případech MŮŽE být použita vlastnost dcterms:format s jinými hodnotami."@cs ;
  skos:scopeNote "This property SHOULD be used when the media type of the distribution is defined in the IANA media types registry https://www.iana.org/assignments/media-types/, otherwise dcterms:format MAY be used with different values."@en ;
  skos:scopeNote "Denne egenskab BØR anvendes hvis distributionens medietype optræder i 'IANA media types registry' https://www.iana.org/assignments/media-types/, ellers KAN egenskaben dcterms:format anvendes med et andet udfaldsrum."@da ;
.
dcat:next owl:inverseOf dcat:prev ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 3."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:scopeNote "This property MAY be used only in addition to its inverse, and it MUST NOT be used to replace it."@en ;
  skos:scopeNote "Esta propiedad inversa PUEDE usarse sólo en combinación con su inversa, y NO PUEDE utilizarse en su reemplazo."@es ;
  skos:scopeNote "Questa proprietà PUÒ essere usata solo insieme alla sua inversa, e NON DEVE essere usata per sostituirla."@it ;
.
dcat:nextVersion owl:inverseOf dcat:previousVersion ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 3."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:scopeNote "This property MAY be used only in addition to its inverse, and it MUST NOT be used to replace it."@en ;
  skos:scopeNote "Esta propiedad inversa PUEDE usarse sólo en combinación con su inversa, y NO PUEDE utilizarse en su reemplazo."@es ;
  skos:scopeNote "Questa proprietà PUÒ essere usata solo insieme alla sua inversa, e NON DEVE essere usata per sostituirla."@it ;
.
dcat:packageFormat
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "Balíčkový formát souboru, ve kterém je jeden či více souborů seskupeno dohromady, např. aby bylo možné stáhnout sadu souvisejících souborů naráz."@cs ;
  rdfs:comment "El formato del archivo en que se agrupan uno o más archivos de datos, e.g. para permitir que un conjunto de archivos relacionados se bajen juntos."@es ;
  rdfs:comment "Il formato di impacchettamento della distribuzione in cui uno o più file di dati sono raggruppati insieme, ad es. per abilitare un insieme di file correlati da scaricare insieme."@it ;
  rdfs:comment "The package format of the distribution in which one or more data files are grouped together, e.g. to enable a set of related files to be downloaded together."@en ;
  rdfs:comment "Format til pakning af data med henblik på distribution af en eller flere relaterede datafiler der samles til en enhed med henblik på samlet distribution. "@da ;
  rdfs:domain dcat:Distribution ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "formato de empaquetado"@es ;
  rdfs:label "formato di impacchettamento"@it ;
  rdfs:label "formát balíčku"@cs ;
  rdfs:label "packaging format"@en ;
  rdfs:label "pakkeformat"@da ;
  rdfs:range dcterms:MediaType ;
  rdfs:subPropertyOf dcterms:format ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 2."@da ;
  skos:definition "Balíčkový formát souboru, ve kterém je jeden či více souborů seskupeno dohromady, např. aby bylo možné stáhnout sadu souvisejících souborů naráz."@cs ;
  skos:definition "El formato del archivo en que se agrupan uno o más archivos de datos, e.g. para permitir que un conjunto de archivos relacionados se bajen juntos."@es ;
  skos:definition "Il formato di impacchettamento della distribuzione in cui uno o più file di dati sono raggruppati insieme, ad es. per abilitare un insieme di file correlati da scaricare insieme."@it ;
  skos:definition "The package format of the distribution in which one or more data files are grouped together, e.g. to enable a set of related files to be downloaded together."@en ;
  skos:scopeNote "Esta propiedad se debe usar cuando los archivos de la distribución están empaquetados, por ejemplo en un archivo TAR, Frictionless Data Package o Bagit. El formato DEBERÍA expresarse usando un 'media type', tales como los definidos en el registro IANA de 'media types' https://www.iana.org/assignments/media-types/, si está disponibles."@es ;
  skos:scopeNote "Questa proprietà deve essere utilizzata quando i file nella distribuzione sono impacchettati, ad esempio in un file TAR, Frictionless Data Package o Bagit. Il formato DOVREBBE essere espresso utilizzando un tipo di supporto come definito dal registro dei tipi di media IANA https://www.iana.org/assignments/media-types/, se disponibili."@it ;
  skos:scopeNote "Tato vlastnost se použije, když jsou soubory v distribuci zabaleny, např. v souboru TAR, v balíčku Frictionless Data Package nebo v souboru Bagit. Formát BY MĚL být vyjádřen pomocí typu média definovaného v registru IANA https://www.iana.org/assignments/media-types/, pokud existuje."@cs ;
  skos:scopeNote "This property to be used when the files in the distribution are packaged, e.g. in a TAR file, a Frictionless Data Package or a Bagit file. The format SHOULD be expressed using a media type as defined by IANA media types registry https://www.iana.org/assignments/media-types/, if available."@en ;
  skos:scopeNote "Denne egenskab kan anvendes hvis filerne i en distribution er pakket, fx i en TAR-fil, en Frictionless Data Package eller en Bagit-fil. Formatet BØR udtrykkes ved en medietype som defineret i 'IANA media types registry', hvis der optræder en relevant medietype dér: https://www.iana.org/assignments/media-types/."@da ;
.
dcat:prev
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "The previous resource (before the current one) in an ordered collection or series of resources."@en ;
  rdfs:comment "La risorsa precedente a quella attuale in una collezione ordinata o in una serie di risorse."@it ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  rdfs:label "previous"@en ;
  rdfs:label "previo"@es ;
  rdfs:label "precedente"@it ;
  rdfs:subPropertyOf xhv:prev ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nueva propiedad agregada in DCAT 3."@es ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 3."@da ;
  skos:definition "The previous resource (before the current one) in an ordered collection or series of resources."@en ;
  skos:definition "La risorsa precedente a quella attuale in una collezione ordinata o in una serie di risorse."@it ;
  skos:scopeNote "In DCAT this property is used for resources belonging to a dcat:DatasetSeries."@en ;
  skos:scopeNote "En DCAT esta propiedad se usa para recursos que pertenecen a una dcat:DatasetSeries."@es ;
  skos:scopeNote "In DCAT questa proprietà è usata per risorse che fanno parte di una dcat:DatasetSeries."@it ;
  skos:scopeNote "It is important to note that this property is different from dcat:previousVersion, as it does not denote a previous version of the same resource, but a distinct resource immediately preceding the current one in an ordered collection of resources."@en ;
  skos:scopeNote "È importante notare che questa proprietà è diversa da dcat:previousVersion, dato che non indica una versione precedente della stessa risorsa, ma una risorsa distinta che precede immediatamente quella attuale in una collezione ordinata di risorse."@it ;
.
dcat:previousVersion
  a rdf:Property ;
  a owl:ObjectProperty ;
  owl:equivalentProperty pav:previousVersion ;
  rdfs:comment "The previous version of a resource in a lineage [PAV]."@en ;
  rdfs:comment "La versione precedente di una risorsa."@it ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  rdfs:label "previous version"@en ;
  rdfs:label "versión anterior"@es ;
  rdfs:label "versione precedente"@it ;
  rdfs:subPropertyOf prov:wasRevisionOf ;
  skos:definition "The previous version of a resource in a lineage [PAV]."@en ;
  skos:definition "La versione precedente di una risorsa."@it ;
  skos:scopeNote "This property is meant to be used to specify a version chain, consisting of snapshots of a resource."@en ;
  skos:scopeNote "Questa proprietà è usata per specificare una catena di versioni, costituita da snapshot di una risorsa."@it ;
  skos:scopeNote "The notion of version used by this property is limited to versions resulting from revisions occurring to a resource as part of its life-cycle. One of the typical cases here is representing the history of the versions of a dataset that have been released over time."@en ;
  skos:scopeNote "La nozione di versione usata da questa proprietà è limitata a versioni risultanti da revisioni a cui una risorsa è soggetta nel suo ciclo di vita. Uno dei casi tipici è la rappresentazione della storia delle versioni di un dataset, che sono state pubblicate nel corso del tempo."@it ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nueva propiedad agregada in DCAT 3."@es ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 3."@da ;
.
dcat:qualifiedRelation
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "Enlace a una descripción de la relación con otro recurso."@es ;
  rdfs:comment "Link a una descrizione di una relazione con un'altra risorsa."@it ;
  rdfs:comment "Link to a description of a relationship with another resource."@en ;
  rdfs:comment "Odkaz na popis vztahu s jiným zdrojem."@cs ;
  rdfs:comment "Reference til en beskrivelse af en relation til en anden ressource."@da ;
  rdfs:domain dcat:Resource ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "kvalifikovaný vztah"@cs ;
  rdfs:label "qualified relation"@en ;
  rdfs:label "relación calificada"@es ;
  rdfs:label "relazione qualificata"@it ;
  rdfs:label "Kvalificeret relation"@da ;
  rdfs:range dcat:Relationship ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:changeNote "Propiedad nueva añadida en DCAT 2."@es ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 2."@da ;
  skos:definition "Enlace a una descripción de la relación con otro recurso."@es ;
  skos:definition "Link a una descrizione di una relazione con un'altra risorsa."@it ;
  skos:definition "Link to a description of a relationship with another resource."@en ;
  skos:definition "Odkaz na popis vztahu s jiným zdrojem."@cs ;
  skos:definition "Reference til en beskrivelse af en relation til en anden ressource."@da ;
  skos:editorialNote "Introdotta in DCAT per integrare le altre relazioni qualificate di PROV."@it ;
  skos:editorialNote "Introduced into DCAT to complement the other PROV qualified relations. "@en ;
  skos:editorialNote "Přidáno do DCAT k doplnění jiných kvalifikovaných vztahů ze slovníku PROV."@cs ;
  skos:editorialNote "Se incluyó en DCAT para complementar las relaciones calificadas disponibles en PROV."@es ;
  skos:editorialNote "Introduceret i DCAT med henblik på at supplere de øvrige kvalificerede relationer fra PROV. "@da ;
  skos:scopeNote "Použito pro odkazování na jiný zdroj, kde druh vztahu je znám, ale neodpovídá standardním vlastnostem ze slovníku Dublin Core (dcterms:hasPart, dcterms:isPartOf, dcterms:conformsTo, dcterms:isFormatOf, dcterms:hasFormat, dcterms:isVersionOf, dcterms:hasVersion, dcterms:replaces, dcterms:isReplacedBy, dcterms:references, dcterms:isReferencedBy, dcterms:requires, dcterms:isRequiredBy) či slovníku PROV-O (prov:wasDerivedFrom, prov:wasInfluencedBy, prov:wasQuotedFrom, prov:wasRevisionOf, prov:hadPrimarySource, prov:alternateOf, prov:specializationOf)."@cs ;
  skos:scopeNote "Se usa para asociar con otro recurso para el cuál la naturaleza de la relación es conocida pero no es ninguna de las propiedades que provee el estándar Dublin Core (dcterms:hasPart, dcterms:isPartOf, dcterms:conformsTo, dcterms:isFormatOf, dcterms:hasFormat, dcterms:isVersionOf, dcterms:hasVersion, dcterms:replaces, dcterms:isReplacedBy, dcterms:references, dcterms:isReferencedBy, dcterms:requires, dcterms:isRequiredBy) or PROV-O properties (prov:wasDerivedFrom, prov:wasInfluencedBy, prov:wasQuotedFrom, prov:wasRevisionOf, prov:hadPrimarySource, prov:alternateOf, prov:specializationOf)."@es ;
  skos:scopeNote "Used to link to another resource where the nature of the relationship is known but does not match one of the standard Dublin Core properties (dcterms:hasPart, dcterms:isPartOf, dcterms:conformsTo, dcterms:isFormatOf, dcterms:hasFormat, dcterms:isVersionOf, dcterms:hasVersion, dcterms:replaces, dcterms:isReplacedBy, dcterms:references, dcterms:isReferencedBy, dcterms:requires, dcterms:isRequiredBy) or PROV-O properties (prov:wasDerivedFrom, prov:wasInfluencedBy, prov:wasQuotedFrom, prov:wasRevisionOf, prov:hadPrimarySource, prov:alternateOf, prov:specializationOf)."@en ;
  skos:scopeNote "Viene utilizzato per associarsi a un'altra risorsa nei casi per i quali la natura della relazione è nota ma non è alcuna delle proprietà fornite dallo standard Dublin Core (dcterms:hasPart, dcterms:isPartOf, dcterms:conformsTo, dcterms:isFormatOf, dcterms:hasFormat , dcterms:isVersionOf, dcterms:hasVersion, dcterms:replaces, dcterms:isReplacedBy, dcterms:references, dcterms:isReferencedBy, dcterms:require, dcterms:isRequiredBy) o dalle proprietà fornite da PROV-O (prov:wasDerivedFrom, prov:wasInfluencedBy, prov:wasQuotedFrom , prov:wasRevisionOf, prov:hadPrimarySource, prov:alternateOf, prov:specializationOf)."@it ;
  skos:scopeNote "Anvendes til at referere til en anden ressource hvor relationens betydning er kendt men ikke matcher en af de standardiserede egenskaber fra Dublin Core (dcterms:hasPart, dcterms:isPartOf, dcterms:conformsTo, dcterms:isFormatOf, dcterms:hasFormat, dcterms:isVersionOf, dcterms:hasVersion, dcterms:replaces, dcterms:isReplacedBy, dcterms:references, dcterms:isReferencedBy, dcterms:requires, dcterms:isRequiredBy) eller PROV-O-egenskaber (prov:wasDerivedFrom, prov:wasInfluencedBy, prov:wasQuotedFrom, prov:wasRevisionOf, prov:hadPrimarySource, prov:alternateOf, prov:specializationOf)."@da ;
.
dcat:record
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A record describing the registration of a single dataset or data service that is part of the catalog."@en ;
  rdfs:comment "Describe la registración de un conjunto de datos o un servicio de datos en el catálogo."@es ;
  rdfs:comment "Propojuje katalog a jeho záznamy."@cs ;
  rdfs:comment "Relie un catalogue à ses registres."@fr ;
  rdfs:comment "Un record che descrive la registrazione di un singolo set di dati o di un servizio dati che fa parte del catalogo."@it ;
  rdfs:comment "Záznam popisující registraci jedné datové sady či datové služby jakožto součásti katalogu."@cs ;
  rdfs:comment "Συνδέει έναν κατάλογο με τις καταγραφές του."@el ;
  rdfs:comment "تربط الفهرس بسجل ضمنه"@ar ;
  rdfs:comment "カタログの一部であるカタログ・レコード。"@ja ;
  rdfs:comment "En post der beskriver registreringen af et enkelt datasæt eller en datatjeneste som er opført i kataloget."@da ;
  rdfs:domain dcat:Catalog ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "record"@en ;
  rdfs:label "record"@it ;
  rdfs:label "registre"@fr ;
  rdfs:label "registro"@es ;
  rdfs:label "záznam"@cs ;
  rdfs:label "καταγραφή"@el ;
  rdfs:label "سجل"@ar ;
  rdfs:label "カタログ・レコード"@ja ;
  rdfs:label "post"@da ;
  rdfs:range dcat:CatalogRecord ;
  skos:altLabel "har post"@da ;
  skos:definition "A record describing the registration of a single dataset or data service that is part of the catalog."@en ;
  skos:definition "Describe la registración de un conjunto de datos o un servicio de datos en el catálogo."@es ;
  skos:definition "Propojuje katalog a jeho záznamy."@cs ;
  skos:definition "Relie un catalogue à ses registres."@fr ;
  skos:definition "Un record che descrive la registrazione di un singolo set di dati o di un servizio dati che fa parte del catalogo."@it ;
  skos:definition "Záznam popisující registraci jedné datové sady či datové služby jakožto součásti katalogu."@cs ;
  skos:definition "Συνδέει έναν κατάλογο με τις καταγραφές του."@el ;
  skos:definition "تربط الفهرس بسجل ضمنه"@ar ;
  skos:definition "カタログの一部であるカタログ・レコード。"@ja ;
  skos:definition "En post der beskriver registreringen af et enkelt datasæt eller en datatjeneste som er opført i kataloget."@da ;
  skos:editorialNote "Status: English, Italian, Spanish and Czech Definitions modified by DCAT revision team, other translations pending."@en ;
.
dcat:resource
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A resource that is listed in the catalog."@en ;
  rdfs:comment "Una risorsa elencata nel catalogo."@it ;
  rdfs:domain dcat:Catalog ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  rdfs:label "resource"@en ;
  rdfs:label "risorsa"@it ;
  rdfs:range dcat:Resource ;
  rdfs:subPropertyOf dcterms:hasPart ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 3."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:definition "A resource that is listed in the catalog."@en ;
  skos:definition "Una risorsa elencata nel catalogo."@it ;
  skos:editorialNote "Status: English Definition text modified by DCAT 3 revision team, translations pending."@en ;
  skos:scopeNote "This is the most general predicate for membership of a catalog. Use of a more specific sub-property is recommended when available."@en ;
  skos:scopeNote "Questo è il predicate più generale per indicare l'appartenenza di una risorsa a un catalogo. Si raccomanda l'uso di una proprietà più specifica, quando disponibile."@it ;
  skos:scopeNote "See also:	Sub-properties of dcat:resource in particular dcat:dataset, dcat:catalog, dcat:service."@en ;
  skos:scopeNote "Vd. anche: Le sottoproprietà di dcat:resource, in particolare: dcat:dataset, dcat:catalog, dcat:service."@it ;
.
dcat:seriesMember owl:inverseOf dcat:inSeries ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  skos:scopeNote "This property MAY be used only in addition to its inverse, and it MUST NOT be used to replace it."@en ;
  skos:scopeNote "Esta propiedad inversa PUEDE usarse sólo en combinación con su inversa, y NO PUEDE utilizarse en su reemplazo."@es ;
  skos:scopeNote "Questa proprietà PUÒ essere usata solo insieme alla sua inversa, e NON DEVE essere usata per sostituirla."@it ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 3."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
.
dcat:servesDataset
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A collection of data that this DataService can distribute."@en ;
  rdfs:comment "Kolekce dat, kterou je tato Datová služba schopna poskytnout."@cs ;
  rdfs:comment "Una colección de datos que este Servicio de Datos puede distribuir."@es ;
  rdfs:comment "Una raccolta di dati che questo DataService può distribuire."@it ;
  rdfs:comment "En samling af data som denne datatjeneste kan distribuere."@da ;
  rdfs:domain dcat:DataService ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "poskytuje datovou sadu"@cs ;
  rdfs:label "provee conjunto de datos"@es ;
  rdfs:label "serve set di dati"@it ;
  rdfs:label "serves dataset"@en ;
  rdfs:label "datatjeneste for datasæt"@da ;
  rdfs:range dcat:Dataset ;
  skos:altLabel "distribuerer"@da ;
  skos:altLabel "udstiller"@da ;
  skos:altLabel "ekspederer"@da ;
  skos:changeNote "New property in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@es ;
  skos:changeNote "Nuova proprietà in DCAT 2."@it ;
  skos:definition "A collection of data that this DataService can distribute."@en ;
  skos:definition "Kolekce dat, kterou je tato Datová služba schopna poskytnout."@cs ;
  skos:definition "Una colección de datos que este Servicio de Datos puede distribuir."@es ;
  skos:definition "Una raccolta di dati che questo DataService può distribuire."@it ;
  skos:definition "En samling af data som denne datatjeneste kan distribuere."@da ;
.
dcat:service
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A service that is listed in the catalog."@en ;
  rdfs:comment "Umístění či přístupový bod registrovaný v katalogu."@cs ;
  rdfs:comment "Un sitio o 'endpoint' que está listado en el catálogo."@es ;
  rdfs:comment "Un sito o endpoint elencato nel catalogo."@it ;
  rdfs:comment "Et websted eller et endpoint som er opført i kataloget."@da ;
  rdfs:domain dcat:Catalog ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "service"@en ;
  rdfs:label "servicio"@es ;
  rdfs:label "servizio"@it ;
  rdfs:label "služba"@cs ;
  rdfs:label "datatjeneste"@da ;
  rdfs:range dcat:DataService ;
  rdfs:subPropertyOf dcat:resource ;
  skos:altLabel "har datatjeneste"@da ;
  skos:altLabel "has service"@en ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad añadida en DCAT 2."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:definition "A service that is listed in the catalog."@en ;
  skos:definition "Umístění či přístupový bod registrovaný v katalogu."@cs ;
  skos:definition "Un sitio o 'endpoint' que está listado en el catálogo."@es ;
  skos:definition "Un sito o endpoint elencato nel catalogo."@it ;
  skos:definition "Et websted eller et endpoint som er opført i kataloget."@da ;
  skos:editorialNote "Status: English Definition text modified by DCAT 3 revision team, translations pending."@en ;
.
dcat:spatialResolutionInMeters
  a rdf:Property ;
  a owl:DatatypeProperty ;
  rdfs:comment "minimum spatial separation resolvable in a dataset, measured in meters."@en-US ;
  rdfs:comment "minimum spatial separation resolvable in a dataset, measured in metres."@en-GB ;
  rdfs:comment "minimální prostorový rozestup rozeznatelný v datové sadě, měřeno v metrech."@cs ;
  rdfs:comment "mínima separacíon espacial disponible en un conjunto de datos, medida en metros."@es ;
  rdfs:comment "separazione spaziale minima risolvibile in un set di dati, misurata in metri."@it ;
  rdfs:comment "mindste geografiske afstand som kan erkendes i et datasæt, målt i meter."@da ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "prostorové rozlišení (metry)"@cs ;
  rdfs:label "resolución espacial (metros)"@es ;
  rdfs:label "risoluzione spaziale (metri)"@it ;
  rdfs:label "spatial resolution (meters)"@en-US ;
  rdfs:label "spatial resolution (metres)"@en-GB ;
  rdfs:label "geografisk opløsning (meter)"@da ;
  rdfs:range xsd:decimal ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad añadida en DCAT 2."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:changeNote "Ny genskab tilføjet i DCAT 2."@da ;
  skos:definition "minimum spatial separation resolvable in a dataset, measured in meters."@en-US ;
  skos:definition "minimum spatial separation resolvable in a dataset, measured in metres."@en-GB ;
  skos:definition "minimální prostorový rozestup rozeznatelný v datové sadě, měřeno v metrech."@cs ;
  skos:definition "mínima separacíon espacial disponible en un conjunto de datos, medida en metros."@es ;
  skos:definition "separazione spaziale minima risolvibile in un set di dati, misurata in metri."@it ;
  skos:definition "mindste geografiske afstand som kan resolveres i et datasæt, målt i meter."@da ;
  skos:editorialNote "Might appear in the description of a Dataset or a Distribution, so no domain is specified."@en ;
  skos:editorialNote "Může se vyskytnout v popisu Datové sady nebo Distribuce, takže nebyl specifikován definiční obor."@cs ;
  skos:editorialNote "Kan optræde i forbindelse med beskrivelse af datasættet eller datasætditributionen, så der er ikke angivet et domæne for egenskaben."@da ;
  skos:scopeNote "Alternative spatial resolutions might be provided as different dataset distributions."@en ;
  skos:scopeNote "Distintas distribuciones de un conjunto de datos pueden tener resoluciones espaciales diferentes."@es ;
  skos:scopeNote "If the dataset is an image or grid this should correspond to the spacing of items. For other kinds of spatial dataset, this property will usually indicate the smallest distance between items in the dataset."@en ;
  skos:scopeNote "Pokud je datová sada obraz či mřížka, měla by tato vlastnost odpovídat rozestupu položek. Pro ostatní druhy prostorových datových sad bude tato vlastnost obvykle indikovat nejmenší vzdálenost mezi položkami této datové sady."@cs ;
  skos:scopeNote "Risoluzioni spaziali alternative possono essere fornite come diverse distribuzioni di set di dati."@it ;
  skos:scopeNote "Různá prostorová rozlišení mohou být poskytována jako různé distribuce datové sady."@cs ;
  skos:scopeNote "Se il set di dati è un'immagine o una griglia, questo dovrebbe corrispondere alla spaziatura degli elementi. Per altri tipi di set di dati spaziali, questa proprietà di solito indica la distanza minima tra gli elementi nel set di dati."@it ;
  skos:scopeNote "Si el conjunto de datos es una imágen o grilla, esta propiedad corresponde al espaciado de los elementos. Para otro tipo de conjunto de datos espaciales, esta propieda usualmente indica la menor distancia entre los elementos de dichos datos."@es ;
  skos:scopeNote "Alternative geografiske opløsninger kan leveres som forskellige datasætdistributioner."@da ;
  skos:scopeNote "Hvis datasættet udgøres af et billede eller et grid, så bør dette svare til afstanden mellem elementerne. For andre typer af spatiale datasæt, vil denne egenskab typisk indikere den mindste afstand mellem elementerne i datasættet."@da ;
.
dcat:startDate
  a rdf:Property ;
  a owl:DatatypeProperty ;
  rdfs:domain dcterms:PeriodOfTime ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "datum začátku"@cs ;
  rdfs:label "start date"@en ;
  rdfs:label "data di inizio"@it ;
  rdfs:label "startdato"@da ;
  rdfs:range rdfs:Literal ;
  skos:altLabel "starttidspunkt"@da ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad agregada en DCAT 2."@es ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 2."@da ;
  skos:definition "El comienzo del período"@es ;
  skos:definition "The start of the period"@en ;
  skos:definition "L'inizio del periodo"@it ;
  skos:definition "Začátek doby trvání"@cs ;
  skos:definition "Start på perioden."@da ;
  skos:scopeNote "El rango de esta propiedad es intencionalmente genérico con el propósito de permitir distintos niveles de precisión temporal para especificar el comienzo de un período. Por ejemplo, puede expresarse como una fecha (xsd:date), una fecha y un tiempo (xsd:dateTime), o un año (xsd:gYear)."@es ;
  skos:scopeNote "Obor hodnot této vlastnosti je úmyslně obecný, aby umožnil různé úrovně časového rozlišení pro specifikaci začátku doby trvání. Ten může být kupříkladu vyjádřen datumem (xsd:date), datumem a časem (xsd:dateTime) či rokem (xsd:gYear)."@cs ;
  skos:scopeNote "The range of this property is intentionally generic, with the purpose of allowing different level of temporal precision for specifying the start of a period. E.g., it can be expressed with a date (xsd:date), a date and time (xsd:dateTime), or a year (xsd:gYear)."@en ;
  skos:scopeNote "Il range di questa proprietà è volutamente generico, con lo scopo di consentire diversi livelli di precisione temporale per specificare l'inizio di un periodo. Ad esempio, può essere espresso con una data (xsd:date), una data e un'ora (xsd:dateTime), o un anno (xsd:gYear)."@it ;
  skos:scopeNote "Rækkeviden for denne egenskab er bevidst generisk defineret med det formål at tillade forskellige niveauer af tidslig præcision ifm. angivelse af startdatoen for en periode. Den kan eksempelvis udtrykkes som en dato (xsd:date), en dato og et tidspunkt (xsd:dateTime), eller et årstal (xsd:gYear)."@da ;
.
dcat:temporalResolution
  a rdf:Property ;
  a owl:DatatypeProperty ;
  rdfs:comment "minimum time period resolvable in a dataset."@en ;
  rdfs:comment "minimální doba trvání rozlišitelná v datové sadě."@cs ;
  rdfs:comment "periodo di tempo minimo risolvibile in un set di dati."@it ;
  rdfs:comment "período de tiempo mínimo en el conjunto de datos."@es ;
  rdfs:comment "mindste tidsperiode der kan resolveres i datasættet."@da ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-2/> ;
  rdfs:label "resolución temporal"@es ;
  rdfs:label "risoluzione temporale"@it ;
  rdfs:label "temporal resolution"@en ;
  rdfs:label "časové rozlišení"@cs ;
  rdfs:label "tidslig opløsning"@da ;
  rdfs:range xsd:duration ;
  skos:changeNote "New property added in DCAT 2."@en ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 2."@cs ;
  skos:changeNote "Nueva propiedad añadida en DCAT 2."@es ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 2."@it ;
  skos:definition "minimum time period resolvable in a dataset."@en ;
  skos:definition "minimální doba trvání rozlišitelná v datové sadě."@cs ;
  skos:definition "periodo di tempo minimo risolvibile in un set di dati."@it ;
  skos:definition "período de tiempo mínimo en el conjunto de datos."@es ;
  skos:definition "mindste tidsperiode der kan resolveres i datasættet."@da ;
  skos:editorialNote "Might appear in the description of a Dataset or a Distribution, so no domain is specified."@en ;
  skos:editorialNote "Může se vyskytnout v popisu Datové sady nebo Distribuce, takže nebyl specifikován definiční obor."@cs ;
  skos:editorialNote "Kan optræde i forbindelse med beskrivelse af datasættet eller datasætditributionen, så der er ikke angivet et domæne for egenskaben."@da ;
  skos:scopeNote "Alternative temporal resolutions might be provided as different dataset distributions."@en ;
  skos:scopeNote "Distintas distribuciones del conjunto de datos pueden tener resoluciones temporales diferentes."@es ;
  skos:scopeNote "If the dataset is a time-series this should correspond to the spacing of items in the series. For other kinds of dataset, this property will usually indicate the smallest time difference between items in the dataset."@en ;
  skos:scopeNote "Pokud je datová sada časovou řadou, měla by tato vlastnost odpovídat rozestupu položek v řadě. Pro ostatní druhy datových sad bude tato vlastnost obvykle indikovat nejmenší časovou vzdálenost mezi položkami této datové sady."@cs ;
  skos:scopeNote "Risoluzioni temporali alternative potrebbero essere fornite come diverse distribuzioni di set di dati."@it ;
  skos:scopeNote "Různá časová rozlišení mohou být poskytována jako různé distribuce datové sady."@cs ;
  skos:scopeNote "Se il set di dati è una serie temporale, questo dovrebbe corrispondere alla spaziatura degli elementi della serie. Per altri tipi di set di dati, questa proprietà di solito indica la più piccola differenza di tempo tra gli elementi nel set di dati."@it ;
  skos:scopeNote "Si el conjunto de datos es una serie temporal, debe corresponder al espaciado de los elementos de la serie. Para otro tipo de conjuntos de datos, esta propiedad indicará usualmente la menor diferencia de tiempo entre elementos en el dataset."@es ;
  skos:scopeNote "Alternative tidslige opløsninger kan leveres som forskellige datasætdistributioner."@da ;
  skos:scopeNote "Hvis datasættet er en tidsserie, så bør denne egenskab svare til afstanden mellem elementerne i tidsserien. For andre typer af datasæt indikerer denne egenskab den mindste tidsforskel mellem elementer i datasættet."@da ;
.
dcat:theme
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "A main category of the resource. A resource can have multiple themes."@en ;
  rdfs:comment "Hlavní téma zdroje. Zdroj může mít více témat."@cs ;
  rdfs:comment "La categoria principale della risorsa. Una risorsa può avere più temi."@it ;
  rdfs:comment "La categoría principal del recurso. Un recurso puede tener varios temas."@es ;
  rdfs:comment "La catégorie principale de la ressource. Une ressource peut avoir plusieurs thèmes."@fr ;
  rdfs:comment "Η κύρια κατηγορία του συνόλου δεδομένων. Ένα σύνολο δεδομένων δύναται να έχει πολλαπλά θέματα."@el ;
  rdfs:comment "التصنيف الرئيسي لقائمة البيانات. قائمة البيانات يمكن أن تملك أكثر من تصنيف رئيسي واحد."@ar ;
  rdfs:comment "データセットの主要カテゴリー。データセットは複数のテーマを持つことができます。"@ja ;
  rdfs:comment "Et centralt emne for ressourcen. En ressource kan have flere centrale emner."@da ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "tema"@es ;
  rdfs:label "tema"@it ;
  rdfs:label "theme"@en ;
  rdfs:label "thème"@fr ;
  rdfs:label "téma"@cs ;
  rdfs:label "Θέμα"@el ;
  rdfs:label "التصنيف"@ar ;
  rdfs:label "テーマ/カテゴリー"@ja ;
  rdfs:label "emne"@da ;
  rdfs:subPropertyOf dcterms:subject ;
  skos:altLabel "tema"@da ;
  skos:definition "A main category of the resource. A resource can have multiple themes."@en ;
  skos:definition "Hlavní téma zdroje. Zdroj může mít více témat."@cs ;
  skos:definition "La categoria principale della risorsa. Una risorsa può avere più temi."@it ;
  skos:definition "La categoría principal del recurso. Un recurso puede tener varios temas."@es ;
  skos:definition "La catégorie principale de la ressource. Une ressource peut avoir plusieurs thèmes."@fr ;
  skos:definition "Η κύρια κατηγορία του συνόλου δεδομένων. Ένα σύνολο δεδομένων δύναται να έχει πολλαπλά θέματα."@el ;
  skos:definition "التصنيف الرئيسي لقائمة البيانات. قائمة البيانات يمكن أن تملك أكثر من تصنيف رئيسي واحد."@ar ;
  skos:definition "データセットの主要カテゴリー。データセットは複数のテーマを持つことができます。"@ja ;
  skos:definition "Et centralt emne for ressourcen. En ressource kan have flere centrale emner."@da ;
  skos:editorialNote "Status: English Definition text  modified by DCAT revision team, all except for Italian and Czech translations are pending. Scope note has changed and its translations should be updated"@en ;
  skos:scopeNote "El conjunto de skos:Concepts utilizados para categorizar los recursos están organizados en un skos:ConceptScheme que describe todas las categorías y sus relaciones en el catálogo."@es ;
  skos:scopeNote "Il set di concetti skos usati per categorizzare le risorse sono organizzati in skos:ConceptScheme che descrive tutte le categorie e le loro relazioni nel catalogo."@it ;
  skos:scopeNote "Sada instancí třídy skos:Concept použitá pro kategorizaci zdrojů je organizována do schématu konceptů skos:ConceptScheme, které popisuje všechny kategorie v katalogu a jejich vztahy."@cs ;
  skos:scopeNote "The set of themes used to categorize the resources are organized in a skos:ConceptScheme, skos:Collection, owl:Ontology or similar, describing all the categories and their relations in the catalog."@en ;
  skos:scopeNote "Un ensemble de skos:Concepts utilisés pour catégoriser les ressources sont organisés en un skos:ConceptScheme décrivant toutes les catégories et ses relations dans le catalogue."@fr ;
  skos:scopeNote "Το σετ των skos:Concepts που χρησιμοποιείται για να κατηγοριοποιήσει τα σύνολα δεδομένων είναι οργανωμένο εντός ενός skos:ConceptScheme που περιγράφει όλες τις κατηγορίες και τις σχέσεις αυτών στον κατάλογο."@el ;
  skos:scopeNote "データセットを分類するために用いられるskos:Conceptの集合は、カタログのすべてのカテゴリーとそれらの関係を記述しているskos:ConceptSchemeで組織化されます。"@ja ;
  skos:scopeNote "Samlingen af begreber (skos:Concept) der anvendes til at emneinddele ressourcer organiseres i et begrebssystem (skos:ConceptScheme) som beskriver alle emnerne og deres relationer i kataloget."@da ;
.
dcat:themeTaxonomy
  a rdf:Property ;
  a owl:ObjectProperty ;
  rdfs:comment "El sistema de organización del conocimiento utilizado para clasificar conjuntos de datos de catálogos."@es ;
  rdfs:comment "Il sistema di organizzazione della conoscenza (KOS) usato per classificare i dataset del catalogo."@it ;
  rdfs:comment "Le systhème d'ogranisation de connaissances utilisé pour classifier les jeux de données du catalogue."@fr ;
  rdfs:comment "Systém organizace znalostí (KOS) použitý pro klasifikaci datových sad v katalogu."@cs ;
  rdfs:comment "The knowledge organization system (KOS) used to classify catalog's datasets."@en ;
  rdfs:comment "Το σύστημα οργάνωσης γνώσης που χρησιμοποιείται για την κατηγοριοποίηση των συνόλων δεδομένων του καταλόγου."@el ;
  rdfs:comment "لائحة التصنيفات المستخدمه لتصنيف قوائم البيانات ضمن الفهرس"@ar ;
  rdfs:comment "カタログのデータセットを分類するために用いられる知識組織化体系（KOS；knowledge organization system）。"@ja ;
  rdfs:comment "Vidensorganiseringssystem (KOS) som anvendes til at klassificere datasæt i kataloget."@da ;
  rdfs:domain dcat:Catalog ;
  rdfs:isDefinedBy <http://www.w3.org/TR/vocab-dcat/> ;
  rdfs:label "tassonomia dei temi"@it ;
  rdfs:label "taxonomie de thèmes"@fr ;
  rdfs:label "taxonomie témat"@cs ;
  rdfs:label "taxonomía de temas"@es ;
  rdfs:label "theme taxonomy"@en ;
  rdfs:label "Ταξινομία θεματικών κατηγοριών."@el ;
  rdfs:label "قائمة التصنيفات"@ar ;
  rdfs:label "テーマ"@ja ;
  rdfs:label "emnetaksonomi"@da ;
  rdfs:range rdfs:Resource ;
  sdo:rangeIncludes owl:Ontology ;
  sdo:rangeIncludes skos:Collection ;
  sdo:rangeIncludes skos:ConceptScheme ;
  skos:altLabel "temataksonomi"@da ;
  skos:definition "El sistema de organización del conocimiento utilizado para clasificar conjuntos de datos de catálogos."@es ;
  skos:definition "Il sistema di organizzazione della conoscenza (KOS) usato per classificare i dataset del catalogo."@it ;
  skos:definition "Le systhème d'ogranisation de connaissances utilisé pour classifier les jeux de données du catalogue."@fr ;
  skos:definition "Systém organizace znalostí (KOS) použitý pro klasifikaci datových sad v katalogu."@cs ;
  skos:definition "The knowledge organization system (KOS) used to classify catalog's datasets."@en ;
  skos:definition "Το σύστημα οργάνωσης γνώσης που χρησιμοποιείται για την κατηγοριοποίηση των συνόλων δεδομένων του καταλόγου."@el ;
  skos:definition "لائحة التصنيفات المستخدمه لتصنيف قوائم البيانات ضمن الفهرس"@ar ;
  skos:definition "カタログのデータセットを分類するために用いられる知識組織化体系（KOS；knowledge organization system）。"@ja ;
  skos:definition "Vidensorganiseringssystem (KOS) som anvendes til at klassificere datasæt i kataloget."@da ;
  skos:scopeNote "It is recommended that the taxonomy is organized in a skos:ConceptScheme, skos:Collection, owl:Ontology or similar, which allows each member to be denoted by an IRI and published as linked-data."@en ;
  skos:scopeNote "Si raccomanda che la tassonomia sia organizzata in uno skos:ConceptScheme, skos:Collection, owl:Ontology o simili, che permette ad ogni membro di essere indicato da un IRI e pubblicato come linked-data."@it ;
  skos:scopeNote "Je doporučeno, aby byla taxonomie vyjádřena jako skos:ConceptScheme, skos:Collection, owl:Ontology nebo podobné, aby mohla být každá položka identifikována pomocí IRI a publikována jako propojená data."@cs ;
  skos:scopeNote "Se recomienda que la taxonomía se organice como un skos:ConceptScheme, skos:Collection, owl:Ontology o similar, los cuáles permiten que cada miembro se denote con una IRI y se publique como datos enlazados."@es ;
  skos:scopeNote "Det anbefales at taksonomien organiseres i et skos:ConceptScheme, skos:Collection, owl:Ontology eller lignende, som giver mulighed for at ethvert medlem af taksonomien kan forsynes med en IRI og udgives som linked-data."@da ;
.
dcat:version
  a rdf:Property ;
  a owl:DatatypeProperty ;
  owl:equivalentProperty pav:version ;
  rdfs:comment "The version indicator (name or identifier) of a resource."@en ;
  rdfs:comment "El indicador de versión (nombre o identificador) del recurso."@es ;
  rdfs:comment "L'indicatore di versione (un nome o un identificatore) di una risorsa."@it ;
  rdfs:isDefinedBy <https://www.w3.org/TR/vocab-dcat-3/> ;
  rdfs:label "version"@en ;
  rdfs:label "versión"@es ;
  rdfs:label "versione"@it ;
  skos:changeNote "New property added in DCAT 3."@en ;
  skos:changeNote "Nueva propiedad agregada in DCAT 3."@es ;
  skos:changeNote "Nová vlastnost přidaná ve verzi DCAT 3."@cs ;
  skos:changeNote "Nuova proprietà aggiunta in DCAT 3."@it ;
  skos:changeNote "Ny egenskab tilføjet i DCAT 3."@da ;
  skos:definition "The version indicator (name or identifier) of a resource."@en ;
  skos:definition "El indicador de versión (nombre o identificador) del recurso."@es ;
  skos:definition "L'indicatore di versione (un nome o un identificatore) di una risorsa"@it ;
  skos:scopeNote "DCAT does not prescribe how a version name / identifier should be specified, and refers for guidance to [DWBP]'s Best Practice 7: Provide a version indicator."@en ;
  skos:scopeNote "DCAT no prescribe cómo especificar el nombre or identificador de una versión, y como guía sugiere leer las práctica 7 en [DWBP] sobre cómo proveer un indicador de versión"@es ;
  skos:scopeNote "DCAT non prescrive come un nome o identificatore di versione dovrebbe essere specificato, e fa riferimento alle linee guida indicate in [DWBP] Best Practice 7: Provide a version indicator."@it ;
.
foaf:homepage
  a owl:ObjectProperty ;
  rdfs:comment "This axiom needed so that Protege loads DCAT 3 without errors."@en ;
  rdfs:comment "Este axioma se necesita de manera que Protege cargue DCAT3 sin problemas."@es ;
.
foaf:primaryTopic
  a owl:ObjectProperty ;
  rdfs:comment "This axiom needed so that Protege loads DCAT 3 without errors."@en;
  rdfs:comment "Este axioma se necesita de manera que Protege cargue DCAT 3 sin problemas."@es ;
.
`;

export const owl = `@prefix dc: <http://purl.org/dc/elements/1.1/> .
@prefix grddl: <http://www.w3.org/2003/g/data-view#> .
@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix xml: <http://www.w3.org/XML/1998/namespace> .
@prefix xsd: <http://www.w3.org/2001/XMLSchema#> .

<http://www.w3.org/2002/07/owl#> a owl:Ontology ;
     dc:title "The OWL 2 Schema vocabulary (OWL 2)" ;
     rdfs:comment """
  This ontology partially describes the built-in classes and
  properties that together form the basis of the RDF/XML syntax of OWL 2.
  The content of this ontology is based on Tables 6.1 and 6.2
  in Section 6.4 of the OWL 2 RDF-Based Semantics specification,
  available at http://www.w3.org/TR/owl2-rdf-based-semantics/.
  Please note that those tables do not include the different annotations
  (labels, comments and rdfs:isDefinedBy links) used in this file.
  Also note that the descriptions provided in this ontology do not
  provide a complete and correct formal description of either the syntax
  or the semantics of the introduced terms (please see the OWL 2
  recommendations for the complete and normative specifications).
  Furthermore, the information provided by this ontology may be
  misleading if not used with care. This ontology SHOULD NOT be imported
  into OWL ontologies. Importing this file into an OWL 2 DL ontology
  will cause it to become an OWL 2 Full ontology and may have other,
  unexpected, consequences.
   """ ;
     rdfs:isDefinedBy
          <http://www.w3.org/TR/owl2-mapping-to-rdf/>,
          <http://www.w3.org/TR/owl2-rdf-based-semantics/>,
          <http://www.w3.org/TR/owl2-syntax/> ;
     rdfs:seeAlso   <http://www.w3.org/TR/owl2-rdf-based-semantics/#table-axiomatic-classes>,
                    <http://www.w3.org/TR/owl2-rdf-based-semantics/#table-axiomatic-properties> ;
     owl:imports <http://www.w3.org/2000/01/rdf-schema> ;
     owl:versionIRI <http://www.w3.org/2002/07/owl> ;
     owl:versionInfo "$Date: 2009/11/15 10:54:12 $" ;
     grddl:namespaceTransformation <http://dev.w3.org/cvsweb/2009/owl-grddl/owx2rdf.xsl> . 


owl:AllDifferent a rdfs:Class ;
     rdfs:label "AllDifferent" ;
     rdfs:comment "The class of collections of pairwise different individuals." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdfs:Resource . 

owl:AllDisjointClasses a rdfs:Class ;
     rdfs:label "AllDisjointClasses" ;
     rdfs:comment "The class of collections of pairwise disjoint classes." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdfs:Resource . 

owl:AllDisjointProperties a rdfs:Class ;
     rdfs:label "AllDisjointProperties" ;
     rdfs:comment "The class of collections of pairwise disjoint properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdfs:Resource . 

owl:Annotation a rdfs:Class ;
     rdfs:label "Annotation" ;
     rdfs:comment "The class of annotated annotations for which the RDF serialization consists of an annotated subject, predicate and object." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdfs:Resource . 

owl:AnnotationProperty a rdfs:Class ;
     rdfs:label "AnnotationProperty" ;
     rdfs:comment "The class of annotation properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdf:Property .

owl:AsymmetricProperty a rdfs:Class ;
     rdfs:label "AsymmetricProperty" ;
     rdfs:comment "The class of asymmetric properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf owl:ObjectProperty . 

owl:Axiom a rdfs:Class ;
     rdfs:label "Axiom" ;
     rdfs:comment "The class of annotated axioms for which the RDF serialization consists of an annotated subject, predicate and object." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdfs:Resource . 

owl:Class a rdfs:Class ;
     rdfs:label "Class" ;
     rdfs:comment "The class of OWL classes." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdfs:Class . 

owl:DataRange a rdfs:Class ;
     rdfs:label "DataRange" ;
     rdfs:comment "The class of OWL data ranges, which are special kinds of datatypes. Note: The use of the IRI owl:DataRange has been deprecated as of OWL 2. The IRI rdfs:Datatype SHOULD be used instead." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdfs:Datatype . 

owl:DatatypeProperty a rdfs:Class ;
     rdfs:label "DatatypeProperty" ;
     rdfs:comment "The class of data properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdf:Property . 

owl:DeprecatedClass a rdfs:Class ;
     rdfs:label "DeprecatedClass" ;
     rdfs:comment "The class of deprecated classes." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdfs:Class . 

owl:DeprecatedProperty a rdfs:Class ;
     rdfs:label "DeprecatedProperty" ;
     rdfs:comment "The class of deprecated properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdf:Property . 

owl:FunctionalProperty a rdfs:Class ;
     rdfs:label "FunctionalProperty" ;
     rdfs:comment "The class of functional properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdf:Property . 

owl:InverseFunctionalProperty a rdfs:Class ;
     rdfs:label "InverseFunctionalProperty" ;
     rdfs:comment "The class of inverse-functional properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf owl:ObjectProperty . 

owl:IrreflexiveProperty a rdfs:Class ;
     rdfs:label "IrreflexiveProperty" ;
     rdfs:comment "The class of irreflexive properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf owl:ObjectProperty . 

owl:NamedIndividual a rdfs:Class ;
     rdfs:label "NamedIndividual" ;
     rdfs:comment "The class of named individuals." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf owl:Thing . 

owl:NegativePropertyAssertion a rdfs:Class ;
     rdfs:label "NegativePropertyAssertion" ;
     rdfs:comment "The class of negative property assertions." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdfs:Resource . 

owl:Nothing a owl:Class ;
     rdfs:label "Nothing" ;
     rdfs:comment "This is the empty class." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf owl:Thing . 

owl:ObjectProperty a rdfs:Class ;
     rdfs:label "ObjectProperty" ;
     rdfs:comment "The class of object properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdf:Property . 

owl:Ontology a rdfs:Class ;
     rdfs:label "Ontology" ;
     rdfs:comment "The class of ontologies." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdfs:Resource . 

owl:OntologyProperty a rdfs:Class ;
     rdfs:label "OntologyProperty" ;
     rdfs:comment "The class of ontology properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf rdf:Property . 

owl:ReflexiveProperty a rdfs:Class ;
     rdfs:label "ReflexiveProperty" ;
     rdfs:comment "The class of reflexive properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf owl:ObjectProperty . 

owl:Restriction a rdfs:Class ;
     rdfs:label "Restriction" ;
     rdfs:comment "The class of property restrictions." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf owl:Class . 

owl:SymmetricProperty a rdfs:Class ;
     rdfs:label "SymmetricProperty" ;
     rdfs:comment "The class of symmetric properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf owl:ObjectProperty . 

owl:TransitiveProperty a rdfs:Class ;
     rdfs:label "TransitiveProperty" ;
     rdfs:comment "The class of transitive properties." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:subClassOf owl:ObjectProperty . 

owl:Thing a owl:Class ;
     rdfs:label "Thing" ;
     rdfs:comment "The class of OWL individuals." ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> .
     
owl:allValuesFrom a rdf:Property ;
     rdfs:label "allValuesFrom" ;
     rdfs:comment "The property that determines the class that a universal property restriction refers to." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Class . 

owl:annotatedProperty a rdf:Property ;
     rdfs:label "annotatedProperty" ;
     rdfs:comment "The property that determines the predicate of an annotated axiom or annotated annotation." ;
     rdfs:domain rdfs:Resource ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Resource . 

owl:annotatedSource a rdf:Property ;
     rdfs:label "annotatedSource" ;
     rdfs:comment "The property that determines the subject of an annotated axiom or annotated annotation." ;
     rdfs:domain rdfs:Resource ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Resource . 

owl:annotatedTarget a rdf:Property ;
     rdfs:label "annotatedTarget" ;
     rdfs:comment "The property that determines the object of an annotated axiom or annotated annotation." ;
     rdfs:domain rdfs:Resource ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Resource . 

owl:assertionProperty a rdf:Property ;
     rdfs:label "assertionProperty" ;
     rdfs:comment "The property that determines the predicate of a negative property assertion." ;
     rdfs:domain owl:NegativePropertyAssertion ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:Property . 

owl:backwardCompatibleWith a owl:AnnotationProperty, owl:OntologyProperty ;
     rdfs:label "backwardCompatibleWith" ;
     rdfs:comment "The annotation property that indicates that a given ontology is backward compatible with another ontology." ;
     rdfs:domain owl:Ontology ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Ontology . 

owl:bottomDataProperty a owl:DatatypeProperty ;
     rdfs:label "bottomDataProperty" ;
     rdfs:comment "The data property that does not relate any individual to any data value." ;
     rdfs:domain owl:Thing ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Literal . 

owl:bottomObjectProperty a owl:ObjectProperty ;
     rdfs:label "bottomObjectProperty" ;
     rdfs:comment "The object property that does not relate any two individuals." ;
     rdfs:domain owl:Thing ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Thing . 

owl:cardinality a rdf:Property ;
     rdfs:label "cardinality" ;
     rdfs:comment "The property that determines the cardinality of an exact cardinality restriction." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range xsd:nonNegativeInteger . 

owl:complementOf a rdf:Property ;
     rdfs:label "complementOf" ;
     rdfs:comment "The property that determines that a given class is the complement of another class." ;
     rdfs:domain owl:Class ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Class . 

owl:datatypeComplementOf a rdf:Property ;
     rdfs:label "datatypeComplementOf" ;
     rdfs:comment "The property that determines that a given data range is the complement of another data range with respect to the data domain." ;
     rdfs:domain rdfs:Datatype ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Datatype . 

owl:deprecated a owl:AnnotationProperty ;
     rdfs:label "deprecated" ;
     rdfs:comment "The annotation property that indicates that a given entity has been deprecated." ;
     rdfs:domain rdfs:Resource ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Resource . 

owl:differentFrom a rdf:Property ;
     rdfs:label "differentFrom" ;
     rdfs:comment "The property that determines that two given individuals are different." ;
     rdfs:domain owl:Thing ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Thing . 

owl:disjointUnionOf a rdf:Property ;
     rdfs:label "disjointUnionOf" ;
     rdfs:comment "The property that determines that a given class is equivalent to the disjoint union of a collection of other classes." ;
     rdfs:domain owl:Class ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:List . 

owl:disjointWith a rdf:Property ;
     rdfs:label "disjointWith" ;
     rdfs:comment "The property that determines that two given classes are disjoint." ;
     rdfs:domain owl:Class ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Class . 

owl:distinctMembers a rdf:Property ;
     rdfs:label "distinctMembers" ;
     rdfs:comment "The property that determines the collection of pairwise different individuals in a owl:AllDifferent axiom." ;
     rdfs:domain owl:AllDifferent ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:List . 

owl:equivalentClass a rdf:Property ;
     rdfs:label "equivalentClass" ;
     rdfs:comment "The property that determines that two given classes are equivalent, and that is used to specify datatype definitions." ;
     rdfs:domain rdfs:Class ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Class . 

owl:equivalentProperty a rdf:Property ;
     rdfs:label "equivalentProperty" ;
     rdfs:comment "The property that determines that two given properties are equivalent." ;
     rdfs:domain rdf:Property ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:Property . 

owl:hasKey a rdf:Property ;
     rdfs:label "hasKey" ;
     rdfs:comment "The property that determines the collection of properties that jointly build a key." ;
     rdfs:domain owl:Class ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:List . 

owl:hasSelf a rdf:Property ;
     rdfs:label "hasSelf" ;
     rdfs:comment "The property that determines the property that a self restriction refers to." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Resource . 

owl:hasValue a rdf:Property ;
     rdfs:label "hasValue" ;
     rdfs:comment "The property that determines the individual that a has-value restriction refers to." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Resource . 

owl:imports a owl:OntologyProperty ;
     rdfs:label "imports" ;
     rdfs:comment "The property that is used for importing other ontologies into a given ontology." ;
     rdfs:domain owl:Ontology ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Ontology . 

owl:incompatibleWith a owl:AnnotationProperty, owl:OntologyProperty ;
     rdfs:label "incompatibleWith" ;
     rdfs:comment "The annotation property that indicates that a given ontology is incompatible with another ontology." ;
     rdfs:domain owl:Ontology ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Ontology . 

owl:intersectionOf a rdf:Property ;
     rdfs:label "intersectionOf" ;
     rdfs:comment "The property that determines the collection of classes or data ranges that build an intersection." ;
     rdfs:domain rdfs:Class ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:List . 

owl:inverseOf a rdf:Property ;
     rdfs:label "inverseOf" ;
     rdfs:comment "The property that determines that two given properties are inverse." ;
     rdfs:domain owl:ObjectProperty ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:ObjectProperty . 

owl:maxCardinality a rdf:Property ;
     rdfs:label "maxCardinality" ;
     rdfs:comment "The property that determines the cardinality of a maximum cardinality restriction." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range xsd:nonNegativeInteger . 

owl:maxQualifiedCardinality a rdf:Property ;
     rdfs:label "maxQualifiedCardinality" ;
     rdfs:comment "The property that determines the cardinality of a maximum qualified cardinality restriction." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range xsd:nonNegativeInteger . 

owl:members a rdf:Property ;
     rdfs:label "members" ;
     rdfs:comment "The property that determines the collection of members in either a owl:AllDifferent, owl:AllDisjointClasses or owl:AllDisjointProperties axiom." ;
     rdfs:domain rdfs:Resource ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:List . 

owl:minCardinality a rdf:Property ;
     rdfs:label "minCardinality" ;
     rdfs:comment "The property that determines the cardinality of a minimum cardinality restriction." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range xsd:nonNegativeInteger . 

owl:minQualifiedCardinality a rdf:Property ;
     rdfs:label "minQualifiedCardinality" ;
     rdfs:comment "The property that determines the cardinality of a minimum qualified cardinality restriction." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range xsd:nonNegativeInteger . 

owl:onClass a rdf:Property ;
     rdfs:label "onClass" ;
     rdfs:comment "The property that determines the class that a qualified object cardinality restriction refers to." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Class . 

owl:onDataRange a rdf:Property ;
     rdfs:label "onDataRange" ;
     rdfs:comment "The property that determines the data range that a qualified data cardinality restriction refers to." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Datatype . 

owl:onDatatype a rdf:Property ;
     rdfs:label "onDatatype" ;
     rdfs:comment "The property that determines the datatype that a datatype restriction refers to." ;
     rdfs:domain rdfs:Datatype ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Datatype . 

owl:oneOf a rdf:Property ;
     rdfs:label "oneOf" ;
     rdfs:comment "The property that determines the collection of individuals or data values that build an enumeration." ;
     rdfs:domain rdfs:Class ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:List . 

owl:onProperties a rdf:Property ;
     rdfs:label "onProperties" ;
     rdfs:comment "The property that determines the n-tuple of properties that a property restriction on an n-ary data range refers to." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:List .

owl:onProperty a rdf:Property ;
     rdfs:label "onProperty" ;
     rdfs:comment "The property that determines the property that a property restriction refers to." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:Property . 

owl:priorVersion a owl:AnnotationProperty, owl:OntologyProperty ;
     rdfs:label "priorVersion" ;
     rdfs:comment "The annotation property that indicates the predecessor ontology of a given ontology." ;
     rdfs:domain owl:Ontology ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Ontology . 

owl:propertyChainAxiom a rdf:Property ;
     rdfs:label "propertyChainAxiom" ;
     rdfs:comment "The property that determines the n-tuple of properties that build a sub property chain of a given property." ;
     rdfs:domain owl:ObjectProperty ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:List . 

owl:propertyDisjointWith a rdf:Property ;
     rdfs:label "propertyDisjointWith" ;
     rdfs:comment "The property that determines that two given properties are disjoint." ;
     rdfs:domain rdf:Property ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:Property . 

owl:qualifiedCardinality a rdf:Property ;
     rdfs:label "qualifiedCardinality" ;
     rdfs:comment "The property that determines the cardinality of an exact qualified cardinality restriction." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range xsd:nonNegativeInteger . 

owl:sameAs a rdf:Property ;
     rdfs:label "sameAs" ;
     rdfs:comment "The property that determines that two given individuals are equal." ;
     rdfs:domain owl:Thing ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Thing . 

owl:someValuesFrom a rdf:Property ;
     rdfs:label "someValuesFrom" ;
     rdfs:comment "The property that determines the class that an existential property restriction refers to." ;
     rdfs:domain owl:Restriction ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Class . 

owl:sourceIndividual a rdf:Property ;
     rdfs:label "sourceIndividual" ;
     rdfs:comment "The property that determines the subject of a negative property assertion." ;
     rdfs:domain owl:NegativePropertyAssertion ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Thing . 

owl:targetIndividual a rdf:Property ;
     rdfs:label "targetIndividual" ;
     rdfs:comment "The property that determines the object of a negative object property assertion." ;
     rdfs:domain owl:NegativePropertyAssertion ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Thing . 

owl:targetValue a rdf:Property ;
     rdfs:label "targetValue" ;
     rdfs:comment "The property that determines the value of a negative data property assertion." ;
     rdfs:domain owl:NegativePropertyAssertion ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Literal . 

owl:topDataProperty a owl:DatatypeProperty ;
     rdfs:label "topDataProperty" ;
     rdfs:comment "The data property that relates every individual to every data value." ;
     rdfs:domain owl:Thing ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Literal . 

owl:topObjectProperty a owl:ObjectProperty ;
     rdfs:label "topObjectProperty" ;
     rdfs:comment "The object property that relates every two individuals." ;
     rdfs:domain owl:Thing ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Thing . 

owl:unionOf a rdf:Property ;
     rdfs:label "unionOf" ;
     rdfs:comment "The property that determines the collection of classes or data ranges that build a union." ;
     rdfs:domain rdfs:Class ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:List . 

owl:versionInfo a owl:AnnotationProperty ;
     rdfs:label "versionInfo" ;
     rdfs:comment "The annotation property that provides version information for an ontology or another OWL construct." ;
     rdfs:domain rdfs:Resource ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdfs:Resource .
     
owl:versionIRI a owl:OntologyProperty ;
     rdfs:label "versionIRI" ;
     rdfs:comment "The property that identifies the version IRI of an ontology." ;
     rdfs:domain owl:Ontology ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range owl:Ontology . 

owl:withRestrictions a rdf:Property ;
     rdfs:label "withRestrictions" ;
     rdfs:comment "The property that determines the collection of facet-value pairs that define a datatype restriction." ;
     rdfs:domain rdfs:Datatype ;
     rdfs:isDefinedBy <http://www.w3.org/2002/07/owl#> ;
     rdfs:range rdf:List .
     `;

export const rdf = `@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix dc: <http://purl.org/dc/elements/1.1/> .

<http://www.w3.org/1999/02/22-rdf-syntax-ns#> a owl:Ontology ;
	dc:title "The RDF Concepts Vocabulary (RDF)" ;
	dc:date "2019-12-16" ;
	dc:description "This is the RDF Schema for the RDF vocabulary terms in the RDF Namespace, defined in RDF 1.1 Concepts." .

rdf:HTML a rdfs:Datatype ;
	rdfs:subClassOf rdfs:Literal ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:seeAlso <http://www.w3.org/TR/rdf11-concepts/#section-html> ;
	rdfs:label "HTML" ;
	rdfs:comment "The datatype of RDF literals storing fragments of HTML content" .

rdf:langString a rdfs:Datatype ;
	rdfs:subClassOf rdfs:Literal ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:seeAlso <http://www.w3.org/TR/rdf11-concepts/#section-Graph-Literal> ;
	rdfs:label "langString" ;
	rdfs:comment "The datatype of language-tagged string values" .

rdf:PlainLiteral a rdfs:Datatype ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:subClassOf rdfs:Literal ;
	rdfs:seeAlso <http://www.w3.org/TR/rdf-plain-literal/> ;
	rdfs:label "PlainLiteral" ;
	rdfs:comment "The class of plain (i.e. untyped) literal values, as used in RIF and OWL 2" .

rdf:type a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "type" ;
	rdfs:comment "The subject is an instance of a class." ;
	rdfs:range rdfs:Class ;
	rdfs:domain rdfs:Resource .

rdf:Property a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "Property" ;
	rdfs:comment "The class of RDF properties." ;
	rdfs:subClassOf rdfs:Resource .

rdf:Statement a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "Statement" ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:comment "The class of RDF statements." .

rdf:subject a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "subject" ;
	rdfs:comment "The subject of the subject RDF statement." ;
	rdfs:domain rdf:Statement ;
	rdfs:range rdfs:Resource .

rdf:predicate a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "predicate" ;
	rdfs:comment "The predicate of the subject RDF statement." ;
	rdfs:domain rdf:Statement ;
	rdfs:range rdfs:Resource .

rdf:object a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "object" ;
	rdfs:comment "The object of the subject RDF statement." ;
	rdfs:domain rdf:Statement ;
	rdfs:range rdfs:Resource .

rdf:Bag a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "Bag" ;
	rdfs:comment "The class of unordered containers." ;
	rdfs:subClassOf rdfs:Container .

rdf:Seq a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "Seq" ;
	rdfs:comment "The class of ordered containers." ;
	rdfs:subClassOf rdfs:Container .

rdf:Alt a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "Alt" ;
	rdfs:comment "The class of containers of alternatives." ;
	rdfs:subClassOf rdfs:Container .

rdf:value a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "value" ;
	rdfs:comment "Idiomatic property used for structured values." ;
	rdfs:domain rdfs:Resource ;
	rdfs:range rdfs:Resource .

rdf:List a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "List" ;
	rdfs:comment "The class of RDF Lists." ;
	rdfs:subClassOf rdfs:Resource .

rdf:nil a rdf:List ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "nil" ;
	rdfs:comment "The empty list, with no items in it. If the rest of a list is nil then the list has no more items in it." .

rdf:first a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "first" ;
	rdfs:comment "The first item in the subject RDF list." ;
	rdfs:domain rdf:List ;
	rdfs:range rdfs:Resource .

rdf:rest a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "rest" ;
	rdfs:comment "The rest of the subject RDF list after the first item." ;
	rdfs:domain rdf:List ;
	rdfs:range rdf:List .

rdf:XMLLiteral a rdfs:Datatype ;
	rdfs:subClassOf rdfs:Literal ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:label "XMLLiteral" ;
	rdfs:comment "The datatype of XML literal values." .

rdf:JSON a rdfs:Datatype ;
	rdfs:label "JSON" ;
	rdfs:comment "The datatype of RDF literals storing JSON content." ;
	rdfs:subClassOf rdfs:Literal ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:seeAlso <https://www.w3.org/TR/json-ld11/#the-rdf-json-datatype> .

rdf:CompoundLiteral a rdfs:Class ;
	rdfs:label "CompoundLiteral" ;
	rdfs:comment "A class representing a compound literal." ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:seeAlso <https://www.w3.org/TR/json-ld11/#the-rdf-compoundliteral-class-and-the-rdf-language-and-rdf-direction-properties> .

rdf:language a rdf:Property ;
	rdfs:label "language" ;
	rdfs:comment "The language component of a CompoundLiteral." ;
	rdfs:domain rdf:CompoundLiteral ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:seeAlso <https://www.w3.org/TR/json-ld11/#the-rdf-compoundliteral-class-and-the-rdf-language-and-rdf-direction-properties> .

rdf:direction a rdf:Property ;
	rdfs:label "direction" ;
	rdfs:comment "The base direction component of a CompoundLiteral." ;
	rdfs:domain rdf:CompoundLiteral ;
	rdfs:isDefinedBy <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ;
	rdfs:seeAlso <https://www.w3.org/TR/json-ld11/#the-rdf-compoundliteral-class-and-the-rdf-language-and-rdf-direction-properties> .
`;

export const rdfa = `@prefix dcterms: <http://purl.org/dc/terms/> .
@prefix foaf: <http://xmlns.com/foaf/0.1/> .
@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix rdfa: <http://www.w3.org/ns/rdfa#> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix xsd: <http://www.w3.org/2001/XMLSchema#> .

rdfa:PGClass a rdfs:Class,
        owl:Class;
    dcterms:description "is the top level class of the hierarchy" .

rdfa:Pattern a rdfs:Class,
        owl:Class;
    dcterms:description "Class to identify an (RDF) resource whose properties are to be copied to another resource" .

rdfa:PrefixOrTermMapping a rdfs:Class,
        owl:Class;
    dcterms:description "is the top level class for prefix or term mappings" .

rdfa: a owl:Ontology;
    dcterms:creator <http://www.ivan-herman.net/foaf#me>;
    dcterms:date "2013-01-18";
    dcterms:description "This document describes the RDFa Vocabulary for Term and Prefix Assignment. The Vocabulary is used to modify RDFa 1.1 processing behavior.";
    dcterms:publisher <http://www.w3.org/data#W3C>;
    dcterms:title "RDFa Vocabulary for Term and Prefix Assignment, and for Processor Graph Reporting";
    rdfs:isDefinedBy <http://www.w3.org/TR/rdfa-core/#s_initialcontexts>;
    owl:versionInfo "$Date: 2013-03-11 07:54:23 $" .

rdfa:DocumentError dcterms:description "error condition; to be used when the document fails to be fully processed as a result of non-conformant host language markup";
    rdfs:subClassOf rdfa:Error .

rdfa:Info dcterms:description "is the class for all informations";
    rdfs:subClassOf rdfa:PGClass .

rdfa:PrefixRedefinition dcterms:description "warning; to be used when a prefix, either from the initial context or inherited from an ancestor node, is redefined in an element";
    rdfs:subClassOf rdfa:Warning .

rdfa:UnresolvedCURIE dcterms:description "warning; to be used when a CURIE prefix fails to be resolved";
    rdfs:subClassOf rdfa:Warning .

rdfa:UnresolvedTerm dcterms:description "warning; to be used when a Term fails to be resolved";
    rdfs:subClassOf rdfa:Warning .

rdfa:VocabReferenceError dcterms:description "warning; to be used when the value of a @vocab attribute cannot be dereferenced, hence the vocabulary expansion cannot be completed";
    rdfs:subClassOf rdfa:Warning .

rdfa:context a rdf:Property,
        owl:ObjectProperty;
    dcterms:description "provides extra context for the error, eg, http response, an XPointer/XPath information, or simply the URI that created the error";
    rdfs:domain rdfa:PGClass .

rdfa:copy a rdf:Property,
        owl:ObjectProperty;
    dcterms:description "identifies the resource (i.e., pattern) whose properties and values should be copied to replace the current triple (retaining the subject of the triple)." .

rdfa:prefix a rdf:Property,
        owl:DatatypeProperty;
    dcterms:description "defines a prefix mapping for a URI; the value is supposed to be a NMTOKEN";
    rdfs:domain rdfa:PrefixMapping .

rdfa:term a rdf:Property,
        owl:DatatypeProperty;
    dcterms:description "defines a term mapping for a URI; the value is supposed to be a NMTOKEN";
    rdfs:domain rdfa:TermMapping .

rdfa:uri a rdf:Property,
        owl:DatatypeProperty;
    dcterms:description "defines the URI for either a prefix or a term mapping; the value is supposed to be an absolute URI";
    rdfs:domain rdfa:PrefixOrTermMapping .

rdfa:usesVocabulary a rdf:Property,
        owl:ObjectProperty;
    dcterms:description """provides a relationship between the host document and a vocabulary
	defined using the @vocab facility of RDFa1.1""" .

rdfa:vocabulary a rdf:Property,
        owl:DatatypeProperty;
    dcterms:description "defines an absolute URI to be used as a default vocabulary; the value is can be any string; for documentation purposes it is advised to use the string 'true' or 'True'." .

<http://www.ivan-herman.net/foaf#me> a foaf:Person;
    rdfs:seeAlso <http://www.ivan-herman.net/foaf>;
    foaf:mbox <mailto:ivan@w3.org>;
    foaf:name "Ivan Herman";
    foaf:title "Semantic Web Activity Lead";
    foaf:workplaceHomepage <http://www.w3.org> .

rdfa:Error dcterms:description "is the class for all error conditions";
    rdfs:subClassOf rdfa:PGClass .

rdfa:PrefixMapping dcterms:description "is the class for prefix mappings";
    rdfs:subClassOf rdfa:PrefixOrTermMapping .

rdfa:TermMapping dcterms:description "is the class for term mappings";
    rdfs:subClassOf rdfa:PrefixOrTermMapping .

rdfa:Warning dcterms:description "is the class for all warnings";
    rdfs:subClassOf rdfa:PGClass .


`;

export const rdfs = `@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix dc: <http://purl.org/dc/elements/1.1/> .

<http://www.w3.org/2000/01/rdf-schema#> a owl:Ontology ;
	dc:title "The RDF Schema vocabulary (RDFS)" .

rdfs:Resource a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "Resource" ;
	rdfs:comment "The class resource, everything." .

rdfs:Class a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "Class" ;
	rdfs:comment "The class of classes." ;
	rdfs:subClassOf rdfs:Resource .

rdfs:subClassOf a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "subClassOf" ;
	rdfs:comment "The subject is a subclass of a class." ;
	rdfs:range rdfs:Class ;
	rdfs:domain rdfs:Class .

rdfs:subPropertyOf a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "subPropertyOf" ;
	rdfs:comment "The subject is a subproperty of a property." ;
	rdfs:range rdf:Property ;
	rdfs:domain rdf:Property .

rdfs:comment a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "comment" ;
	rdfs:comment "A description of the subject resource." ;
	rdfs:domain rdfs:Resource ;
	rdfs:range rdfs:Literal .

rdfs:label a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "label" ;
	rdfs:comment "A human-readable name for the subject." ;
	rdfs:domain rdfs:Resource ;
	rdfs:range rdfs:Literal .

rdfs:domain a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "domain" ;
	rdfs:comment "A domain of the subject property." ;
	rdfs:range rdfs:Class ;
	rdfs:domain rdf:Property .

rdfs:range a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "range" ;
	rdfs:comment "A range of the subject property." ;
	rdfs:range rdfs:Class ;
	rdfs:domain rdf:Property .

rdfs:seeAlso a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "seeAlso" ;
	rdfs:comment "Further information about the subject resource." ;
	rdfs:range rdfs:Resource ;
	rdfs:domain rdfs:Resource .

rdfs:isDefinedBy a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:subPropertyOf rdfs:seeAlso ;
	rdfs:label "isDefinedBy" ;
	rdfs:comment "The defininition of the subject resource." ;
	rdfs:range rdfs:Resource ;
	rdfs:domain rdfs:Resource .

rdfs:Literal a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "Literal" ;
	rdfs:comment "The class of literal values, eg. textual strings and integers." ;
	rdfs:subClassOf rdfs:Resource .

rdfs:Container a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "Container" ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:comment "The class of RDF containers." .

rdfs:ContainerMembershipProperty a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "ContainerMembershipProperty" ;
	rdfs:comment """The class of container membership properties, rdf:_1, rdf:_2, ...,
                    all of which are sub-properties of 'member'.""" ;
	rdfs:subClassOf rdf:Property .

rdfs:member a rdf:Property ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "member" ;
	rdfs:comment "A member of the subject resource." ;
	rdfs:domain rdfs:Resource ;
	rdfs:range rdfs:Resource .

rdfs:Datatype a rdfs:Class ;
	rdfs:isDefinedBy <http://www.w3.org/2000/01/rdf-schema#> ;
	rdfs:label "Datatype" ;
	rdfs:comment "The class of RDF datatypes." ;
	rdfs:subClassOf rdfs:Class .

<http://www.w3.org/2000/01/rdf-schema#> rdfs:seeAlso <http://www.w3.org/2000/01/rdf-schema-more> .
`;

export const sh = `# W3C Shapes Constraint Language (SHACL) Vocabulary
# Version from 2017-07-20

@prefix owl:  <http://www.w3.org/2002/07/owl#> .
@prefix rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix xsd:  <http://www.w3.org/2001/XMLSchema#> .
@prefix sh:   <http://www.w3.org/ns/shacl#> .

sh:
	a owl:Ontology ;
	rdfs:label "W3C Shapes Constraint Language (SHACL) Vocabulary"@en ;
	rdfs:comment "This vocabulary defines terms used in SHACL, the W3C Shapes Constraint Language."@en ;
	sh:declare [
		sh:prefix "sh" ;
		sh:namespace "http://www.w3.org/ns/shacl#" ;
	] ;
	sh:suggestedShapesGraph <http://www.w3.org/ns/shacl-shacl#> .


# Shapes vocabulary -----------------------------------------------------------

sh:Shape
	a rdfs:Class ;
	rdfs:label "Shape"@en ;
	rdfs:comment "A shape is a collection of constraints that may be targeted for certain nodes."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:NodeShape
	a rdfs:Class ;
	rdfs:label "Node Shape"@en ;
	rdfs:comment "A node shape is a shape that specifies constraint that need to be met with respect to focus nodes."@en ;
	rdfs:subClassOf sh:Shape ;
	rdfs:isDefinedBy sh: .

sh:PropertyShape
	a rdfs:Class ;
	rdfs:label "Property Shape"@en ;
	rdfs:comment "A property shape is a shape that specifies constraints on the values of a focus node for a given property or path."@en ;
	rdfs:subClassOf sh:Shape ;
	rdfs:isDefinedBy sh: .

sh:deactivated
	a rdf:Property ;
	rdfs:label "deactivated"@en ;
	rdfs:comment "If set to true then all nodes conform to this."@en ;
	# rdfs:domain sh:Shape or sh:SPARQLConstraint
	rdfs:range xsd:boolean ;
	rdfs:isDefinedBy sh: .

sh:targetClass 
	a rdf:Property ;
	rdfs:label "target class"@en ;
	rdfs:comment "Links a shape to a class, indicating that all instances of the class must conform to the shape."@en ;
	rdfs:domain sh:Shape ;
	rdfs:range rdfs:Class ;
	rdfs:isDefinedBy sh: .

sh:targetNode 
	a rdf:Property ;
	rdfs:label "target node"@en ;
	rdfs:comment "Links a shape to individual nodes, indicating that these nodes must conform to the shape."@en ;
	rdfs:domain sh:Shape ;
	rdfs:isDefinedBy sh: .

sh:targetObjectsOf
	a rdf:Property ;
	rdfs:label "target objects of"@en ;
	rdfs:comment "Links a shape to a property, indicating that all all objects of triples that have the given property as their predicate must conform to the shape."@en ;
	rdfs:domain sh:Shape ;
	rdfs:range rdf:Property ;
	rdfs:isDefinedBy sh: .

sh:targetSubjectsOf
	a rdf:Property ;
	rdfs:label "target subjects of"@en ;
	rdfs:comment "Links a shape to a property, indicating that all subjects of triples that have the given property as their predicate must conform to the shape."@en ;
	rdfs:domain sh:Shape ;
	rdfs:range rdf:Property ;
	rdfs:isDefinedBy sh: .

sh:message
	a rdf:Property ;
	# domain: sh:Shape or sh:SPARQLConstraint or sh:SPARQLSelectValidator or sh:SPARQLAskValidator
	# range: xsd:string or rdf:langString
	rdfs:label "message"@en ;
	rdfs:comment "A human-readable message (possibly with placeholders for variables) explaining the cause of the result."@en ;
	rdfs:isDefinedBy sh: .

sh:severity
	a rdf:Property ;
	rdfs:label "severity"@en ;
	rdfs:comment "Defines the severity that validation results produced by a shape must have. Defaults to sh:Violation."@en ;
	rdfs:domain sh:Shape ;
	rdfs:range sh:Severity ;
	rdfs:isDefinedBy sh: .


# Node kind vocabulary --------------------------------------------------------

sh:NodeKind
	a rdfs:Class ;
	rdfs:label "Node Kind"@en ;
	rdfs:comment "The class of all node kinds, including sh:BlankNode, sh:IRI, sh:Literal or the combinations of these: sh:BlankNodeOrIRI, sh:BlankNodeOrLiteral, sh:IRIOrLiteral."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:BlankNode
	a sh:NodeKind ;
	rdfs:label "Blank Node"@en ;
	rdfs:comment "The node kind of all blank nodes."@en ;
	rdfs:isDefinedBy sh: .

sh:BlankNodeOrIRI
	a sh:NodeKind ;
	rdfs:label "Blank Node or IRI"@en ;
	rdfs:comment "The node kind of all blank nodes or IRIs."@en ;
	rdfs:isDefinedBy sh: .

sh:BlankNodeOrLiteral
	a sh:NodeKind ;
	rdfs:label "Blank Node or Literal"@en ;
	rdfs:comment "The node kind of all blank nodes or literals."@en ;
	rdfs:isDefinedBy sh: .

sh:IRI
	a sh:NodeKind ;
	rdfs:label "IRI"@en ;
	rdfs:comment "The node kind of all IRIs."@en ;
	rdfs:isDefinedBy sh: .

sh:IRIOrLiteral
	a sh:NodeKind ;
	rdfs:label "IRI or Literal"@en ;
	rdfs:comment "The node kind of all IRIs or literals."@en ;
	rdfs:isDefinedBy sh: .

sh:Literal
	a sh:NodeKind ;
	rdfs:label "Literal"@en ;
	rdfs:comment "The node kind of all literals."@en ;
	rdfs:isDefinedBy sh: .


# Results vocabulary ----------------------------------------------------------

sh:ValidationReport
	a rdfs:Class ;
	rdfs:label "Validation Report"@en ;
	rdfs:comment "The class of SHACL validation reports."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:conforms
	a rdf:Property ;
	rdfs:label "conforms"@en ;
	rdfs:comment "True if the validation did not produce any validation results, and false otherwise."@en ;
	rdfs:domain sh:ValidationReport ;
	rdfs:range xsd:boolean ;
	rdfs:isDefinedBy sh: .

sh:result
	a rdf:Property ;
	rdfs:label "result"@en ;
	rdfs:comment "The validation results contained in a validation report."@en ;
	rdfs:domain sh:ValidationReport ;
	rdfs:range sh:ValidationResult ;
	rdfs:isDefinedBy sh: .

sh:shapesGraphWellFormed
	a rdf:Property ;
	rdfs:label "shapes graph well-formed"@en ;
	rdfs:comment "If true then the validation engine was certain that the shapes graph has passed all SHACL syntax requirements during the validation process."@en ;
	rdfs:domain sh:ValidationReport ;
	rdfs:range xsd:boolean ;
	rdfs:isDefinedBy sh: .

sh:AbstractResult
	a rdfs:Class ;
	rdfs:label "Abstract Result"@en ;
	rdfs:comment "The base class of validation results, typically not instantiated directly."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:ValidationResult
	a rdfs:Class ;
	rdfs:label "Validation Result"@en ;
	rdfs:comment "The class of validation results."@en ;
	rdfs:subClassOf sh:AbstractResult ;
	rdfs:isDefinedBy sh: .

sh:Severity
	a rdfs:Class ;
	rdfs:label "Severity"@en ;
	rdfs:comment "The class of validation result severity levels, including violation and warning levels."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:Info
	a sh:Severity ;
	rdfs:label "Info"@en ;
	rdfs:comment "The severity for an informational validation result."@en ;
	rdfs:isDefinedBy sh: .

sh:Violation
	a sh:Severity ;
	rdfs:label "Violation"@en ;
	rdfs:comment "The severity for a violation validation result."@en ;
	rdfs:isDefinedBy sh: .

sh:Warning
	a sh:Severity ;
	rdfs:label "Warning"@en ;
	rdfs:comment "The severity for a warning validation result."@en ;
	rdfs:isDefinedBy sh: .

sh:detail
	a rdf:Property ;
	rdfs:label "detail"@en ;
	rdfs:comment "Links a result with other results that provide more details, for example to describe violations against nested shapes."@en ;
	rdfs:domain sh:AbstractResult ;
	rdfs:range sh:AbstractResult ;
	rdfs:isDefinedBy sh: .

sh:focusNode
	a rdf:Property ;
	rdfs:label "focus node"@en ;
	rdfs:comment "The focus node that was validated when the result was produced."@en ;
	rdfs:domain sh:AbstractResult ;
	rdfs:isDefinedBy sh: .

sh:resultMessage
	a rdf:Property ;
	rdfs:label "result message"@en ;
	rdfs:comment "Human-readable messages explaining the cause of the result."@en ;
	rdfs:domain sh:AbstractResult ;
	# range: xsd:string or rdf:langString
	rdfs:isDefinedBy sh: .

sh:resultPath
	a rdf:Property ;
	rdfs:label "result path"@en ;
	rdfs:comment "The path of a validation result, based on the path of the validated property shape."@en ;
	rdfs:domain sh:AbstractResult ;
	rdfs:range rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:resultSeverity
	a rdf:Property ;
	rdfs:label "result severity"@en ;
	rdfs:comment "The severity of the result, e.g. warning."@en ;
	rdfs:domain sh:AbstractResult ;
	rdfs:range sh:Severity ;
	rdfs:isDefinedBy sh: .

sh:sourceConstraint
	a rdf:Property ;
	rdfs:label "source constraint"@en ;
	rdfs:comment "The constraint that was validated when the result was produced."@en ;
	rdfs:domain sh:AbstractResult ;
	rdfs:isDefinedBy sh: .

sh:sourceShape
	a rdf:Property ;
	rdfs:label "source shape"@en ;
	rdfs:comment "The shape that is was validated when the result was produced."@en ;
	rdfs:domain sh:AbstractResult ;
	rdfs:range sh:Shape ;
	rdfs:isDefinedBy sh: .

sh:sourceConstraintComponent
	a rdf:Property ;
	rdfs:label "source Constraint Component"@en ;
	rdfs:comment "The constraint component that is the source of the result."@en ;
	rdfs:domain sh:AbstractResult ;
	rdfs:range sh:ConstraintComponent ;
	rdfs:isDefinedBy sh: .

sh:value
	a rdf:Property ;
	rdfs:label "value"@en ;
	rdfs:comment "An RDF node that has caused the result."@en ;
	rdfs:domain sh:AbstractResult ;
	rdfs:isDefinedBy sh: .

	
# Graph properties ------------------------------------------------------------

sh:shapesGraph
	a rdf:Property ;
	rdfs:label "shapes graph"@en ;
	rdfs:comment "Shapes graphs that should be used when validating this data graph."@en ;
	rdfs:domain owl:Ontology ;
	rdfs:range owl:Ontology ;
	rdfs:isDefinedBy sh: .

sh:suggestedShapesGraph
	a rdf:Property ;
	rdfs:label "suggested shapes graph"@en ;
	rdfs:comment "Suggested shapes graphs for this ontology. The values of this property may be used in the absence of specific sh:shapesGraph statements."@en ;
	rdfs:domain owl:Ontology ;
	rdfs:range owl:Ontology ;
	rdfs:isDefinedBy sh: .

sh:entailment
	a rdf:Property ;
	rdfs:label "entailment"@en ;
	rdfs:comment "An entailment regime that indicates what kind of inferencing is required by a shapes graph."@en ;
	rdfs:domain owl:Ontology ;
	rdfs:range rdfs:Resource ;
	rdfs:isDefinedBy sh: .


# Path vocabulary -------------------------------------------------------------

sh:path
	a rdf:Property ;
	rdfs:label "path"@en ;
	rdfs:comment "Specifies the property path of a property shape."@en ;
	rdfs:domain sh:PropertyShape ;
	rdfs:range rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:inversePath
	a rdf:Property ;
	rdfs:label "inverse path"@en ;
	rdfs:comment "The (single) value of this property represents an inverse path (object to subject)."@en ;
	rdfs:range rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:alternativePath
	a rdf:Property ;
	rdfs:label "alternative path"@en ;
	rdfs:comment "The (single) value of this property must be a list of path elements, representing the elements of alternative paths."@en ;
	rdfs:range rdf:List ;
	rdfs:isDefinedBy sh: .

sh:zeroOrMorePath
	a rdf:Property ;
	rdfs:label "zero or more path"@en ;
	rdfs:comment "The (single) value of this property represents a path that is matched zero or more times."@en ;
	rdfs:range rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:oneOrMorePath
	a rdf:Property ;
	rdfs:label "one or more path"@en ;
	rdfs:comment "The (single) value of this property represents a path that is matched one or more times."@en ;
	rdfs:range rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:zeroOrOnePath
	a rdf:Property ;
	rdfs:label "zero or one path"@en ;
	rdfs:comment "The (single) value of this property represents a path that is matched zero or one times."@en ;
	rdfs:range rdfs:Resource ;
	rdfs:isDefinedBy sh: .


# Parameters metamodel --------------------------------------------------------

sh:Parameterizable
	a rdfs:Class ;
	rdfs:label "Parameterizable"@en ;
	rdfs:comment "Superclass of components that can take parameters, especially functions and constraint components."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:parameter
	a rdf:Property ;
	rdfs:label "parameter"@en ;
	rdfs:comment "The parameters of a function or constraint component."@en ;
	rdfs:domain sh:Parameterizable ;
	rdfs:range sh:Parameter ;
	rdfs:isDefinedBy sh: .

sh:labelTemplate
	a rdf:Property ;
	rdfs:label "label template"@en ;
	rdfs:comment "Outlines how human-readable labels of instances of the associated Parameterizable shall be produced. The values can contain {?paramName} as placeholders for the actual values of the given parameter."@en ;
	rdfs:domain sh:Parameterizable ;
	# range: xsd:string or rdf:langString
	rdfs:isDefinedBy sh: .

sh:Parameter
	a rdfs:Class ;
	rdfs:label "Parameter"@en ;
	rdfs:comment "The class of parameter declarations, consisting of a path predicate and (possibly) information about allowed value type, cardinality and other characteristics."@en ;
	rdfs:subClassOf sh:PropertyShape ;
	rdfs:isDefinedBy sh: .

sh:optional
	a rdf:Property ;
	rdfs:label "optional"@en ;
	rdfs:comment "Indicates whether a parameter is optional."@en ;
	rdfs:domain sh:Parameter ;
	rdfs:range xsd:boolean ;
	rdfs:isDefinedBy sh: .


# Constraint components metamodel ---------------------------------------------

sh:ConstraintComponent
	a rdfs:Class ;
	rdfs:label "Constraint Component"@en ;
	rdfs:comment "The class of constraint components."@en ;
	rdfs:subClassOf sh:Parameterizable ;
	rdfs:isDefinedBy sh: .

sh:validator
	a rdf:Property ;
	rdfs:label "validator"@en ;
	rdfs:comment "The validator(s) used to evaluate constraints of either node or property shapes."@en ;
	rdfs:domain sh:ConstraintComponent ;
	rdfs:range sh:Validator ;
	rdfs:isDefinedBy sh: .

sh:nodeValidator
	a rdf:Property ;
	rdfs:label "shape validator"@en ;
	rdfs:comment "The validator(s) used to evaluate a constraint in the context of a node shape."@en ;
	rdfs:domain sh:ConstraintComponent ;
	rdfs:range sh:Validator ;
	rdfs:isDefinedBy sh: .

sh:propertyValidator
	a rdf:Property ;
	rdfs:label "property validator"@en ;
	rdfs:comment "The validator(s) used to evaluate a constraint in the context of a property shape."@en ;
	rdfs:domain sh:ConstraintComponent ;
	rdfs:range sh:Validator ;
	rdfs:isDefinedBy sh: .

sh:Validator
	a rdfs:Class ;
	rdfs:label "Validator"@en ;
	rdfs:comment "The class of validators, which provide instructions on how to process a constraint definition. This class serves as base class for the SPARQL-based validators and other possible implementations."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:SPARQLAskValidator
	a rdfs:Class ;
	rdfs:label "SPARQL ASK Validator"@en ;
	rdfs:comment "The class of validators based on SPARQL ASK queries. The queries are evaluated for each value node and are supposed to return true if the given node conforms."@en ;
	rdfs:subClassOf sh:Validator ;
	rdfs:subClassOf sh:SPARQLAskExecutable ;
	rdfs:isDefinedBy sh: .

sh:SPARQLSelectValidator
	a rdfs:Class ;
	rdfs:label "SPARQL SELECT Validator"@en ;
	rdfs:comment "The class of validators based on SPARQL SELECT queries. The queries are evaluated for each focus node and are supposed to produce bindings for all focus nodes that do not conform."@en ;
	rdfs:subClassOf sh:Validator ;
	rdfs:subClassOf sh:SPARQLSelectExecutable ;
	rdfs:isDefinedBy sh: .


# Library of Core Constraint Components and their properties ------------------

sh:AndConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "And Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to test whether a value node conforms to all members of a provided list of shapes."@en ;
	sh:parameter sh:AndConstraintComponent-and ;
	rdfs:isDefinedBy sh: .

sh:AndConstraintComponent-and
	a sh:Parameter ;
	sh:path sh:and ;
	rdfs:isDefinedBy sh: .

sh:and
	a rdf:Property ;
	rdfs:label "and"@en ;
	rdfs:comment "RDF list of shapes to validate the value nodes against."@en ;
	rdfs:range rdf:List ;
	rdfs:isDefinedBy sh: .


sh:ClassConstraintComponent 
	a sh:ConstraintComponent ;
	rdfs:label "Class Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that each value node is an instance of a given type."@en ;
	sh:parameter sh:ClassConstraintComponent-class ;
	rdfs:isDefinedBy sh: .

sh:ClassConstraintComponent-class
	a sh:Parameter ;
	sh:path sh:class ;
	sh:nodeKind sh:IRI ;
	rdfs:isDefinedBy sh: .

sh:class
	a rdf:Property ;
	rdfs:label "class"@en ;
	rdfs:comment "The type that all value nodes must have."@en ;
	rdfs:range rdfs:Class ;
	rdfs:isDefinedBy sh: .


sh:ClosedConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Closed Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to indicate that focus nodes must only have values for those properties that have been explicitly enumerated via sh:property/sh:path."@en ;
	sh:parameter sh:ClosedConstraintComponent-closed ;
	sh:parameter sh:ClosedConstraintComponent-ignoredProperties ;
	rdfs:isDefinedBy sh: .

sh:ClosedConstraintComponent-closed
	a sh:Parameter ; 
	sh:path sh:closed ;
	sh:datatype xsd:boolean ;
	rdfs:isDefinedBy sh: .

sh:ClosedConstraintComponent-ignoredProperties
	a sh:Parameter ;
	sh:path sh:ignoredProperties ;
	sh:optional true ;
	rdfs:isDefinedBy sh: .

sh:closed
	a rdf:Property ;
	rdfs:label "closed"@en ;
	rdfs:comment "If set to true then the shape is closed."@en ;
	rdfs:range xsd:boolean ;
	rdfs:isDefinedBy sh: .

sh:ignoredProperties
	a rdf:Property ;
	rdfs:label "ignored properties"@en ;
	rdfs:comment "An optional RDF list of properties that are also permitted in addition to those explicitly enumerated via sh:property/sh:path."@en ;
	rdfs:range rdf:List ;    # members: rdf:Property
	rdfs:isDefinedBy sh: .


sh:DatatypeConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Datatype Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the datatype of all value nodes."@en ;
	sh:parameter sh:DatatypeConstraintComponent-datatype ;
	rdfs:isDefinedBy sh: .

sh:DatatypeConstraintComponent-datatype
	a sh:Parameter ;
	sh:path sh:datatype ;
	sh:nodeKind sh:IRI ;
	sh:maxCount 1 ;
	rdfs:isDefinedBy sh: .

sh:datatype
	a rdf:Property ;
	rdfs:label "datatype"@en ;
	rdfs:comment "Specifies an RDF datatype that all value nodes must have."@en ;
	rdfs:range rdfs:Datatype ;
	rdfs:isDefinedBy sh: .


sh:DisjointConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Disjoint Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that the set of value nodes is disjoint with the the set of nodes that have the focus node as subject and the value of a given property as predicate."@en ;
	sh:parameter sh:DisjointConstraintComponent-disjoint ;
	rdfs:isDefinedBy sh: .

sh:DisjointConstraintComponent-disjoint
	a sh:Parameter ;
	sh:path sh:disjoint ;
	sh:nodeKind sh:IRI ;
	rdfs:isDefinedBy sh: .

sh:disjoint
	a rdf:Property ;
	rdfs:label "disjoint"@en ;
	rdfs:comment "Specifies a property where the set of values must be disjoint with the value nodes."@en ;
	rdfs:range rdf:Property ;
	rdfs:isDefinedBy sh: .


sh:EqualsConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Equals Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that the set of value nodes is equal to the set of nodes that have the focus node as subject and the value of a given property as predicate."@en ;
	sh:parameter sh:EqualsConstraintComponent-equals ;
	rdfs:isDefinedBy sh: .

sh:EqualsConstraintComponent-equals
	a sh:Parameter ;
	sh:path sh:equals ;
	sh:nodeKind sh:IRI ;
	rdfs:isDefinedBy sh: .

sh:equals
	a rdf:Property ;
	rdfs:label "equals"@en ;
	rdfs:comment "Specifies a property that must have the same values as the value nodes."@en ;
	rdfs:range rdf:Property ;
	rdfs:isDefinedBy sh: .


sh:HasValueConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Has-value Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that one of the value nodes is a given RDF node."@en ;
	sh:parameter sh:HasValueConstraintComponent-hasValue ;
	rdfs:isDefinedBy sh: .

sh:HasValueConstraintComponent-hasValue
	a sh:Parameter ;
	sh:path sh:hasValue ;
	rdfs:isDefinedBy sh: .

sh:hasValue
	a rdf:Property ;
	rdfs:label "has value"@en ;
	rdfs:comment "Specifies a value that must be among the value nodes."@en ;
	rdfs:isDefinedBy sh: .


sh:InConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "In Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to exclusively enumerate the permitted value nodes."@en ;
	sh:parameter sh:InConstraintComponent-in ;
	rdfs:isDefinedBy sh: .

sh:InConstraintComponent-in
	a sh:Parameter ;
	sh:path sh:in ;
	sh:maxCount 1 ;
	rdfs:isDefinedBy sh: .

sh:in
	a rdf:Property ;
	rdfs:label "in"@en ;
	rdfs:comment "Specifies a list of allowed values so that each value node must be among the members of the given list."@en ;
	rdfs:range rdf:List ;
	rdfs:isDefinedBy sh: .


sh:LanguageInConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Language-in Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to enumerate language tags that all value nodes must have."@en ;
	sh:parameter sh:LanguageInConstraintComponent-languageIn ;
	rdfs:isDefinedBy sh: .

sh:LanguageInConstraintComponent-languageIn
	a sh:Parameter ;
	sh:path sh:languageIn ;
	sh:maxCount 1 ;
	rdfs:isDefinedBy sh: .

sh:languageIn
	a rdf:Property ;
	rdfs:label "language in"@en ;
	rdfs:comment "Specifies a list of language tags that all value nodes must have."@en ;
	rdfs:range rdf:List ;   # members: xsd:string
	rdfs:isDefinedBy sh: .


sh:LessThanConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Less-than Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that each value node is smaller than all the nodes that have the focus node as subject and the value of a given property as predicate."@en ;
	sh:parameter sh:LessThanConstraintComponent-lessThan ;
	rdfs:isDefinedBy sh: .

sh:LessThanConstraintComponent-lessThan
	a sh:Parameter ;
	sh:path sh:lessThan ;
	sh:nodeKind sh:IRI ;
	rdfs:isDefinedBy sh: .

sh:lessThan
	a rdf:Property ;
	rdfs:label "less than"@en ;
	rdfs:comment "Specifies a property that must have smaller values than the value nodes."@en ;
	rdfs:range rdf:Property ;
	rdfs:isDefinedBy sh: .


sh:LessThanOrEqualsConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Less-than-or-equals Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that every value node is smaller than all the nodes that have the focus node as subject and the value of a given property as predicate."@en ;
	sh:parameter sh:LessThanOrEqualsConstraintComponent-lessThanOrEquals ;
	rdfs:isDefinedBy sh: .

sh:LessThanOrEqualsConstraintComponent-lessThanOrEquals
	a sh:Parameter ;
	sh:path sh:lessThanOrEquals ;
	sh:nodeKind sh:IRI ;
	rdfs:isDefinedBy sh: .

sh:lessThanOrEquals
	a rdf:Property ;
	rdfs:label "less than or equals"@en ;
	rdfs:comment "Specifies a property that must have smaller or equal values than the value nodes."@en ;
	rdfs:range rdf:Property ;
	rdfs:isDefinedBy sh: .


sh:MaxCountConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Max-count Constraint ConstraintComponentomponent"@en ;
	rdfs:comment "A constraint component that can be used to restrict the maximum number of value nodes."@en ;
	sh:parameter sh:MaxCountConstraintComponent-maxCount ;
	rdfs:isDefinedBy sh: .

sh:MaxCountConstraintComponent-maxCount
	a sh:Parameter ;
	sh:path sh:maxCount ;
	sh:datatype xsd:integer ;
	sh:maxCount 1 ;
	rdfs:isDefinedBy sh: .

sh:maxCount
	a rdf:Property ;
	rdfs:label "max count"@en ;
	rdfs:comment "Specifies the maximum number of values in the set of value nodes."@en ;
	rdfs:range xsd:integer ;
	rdfs:isDefinedBy sh: .


sh:MaxExclusiveConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Max-exclusive Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the range of value nodes with a maximum exclusive value."@en ;
	sh:parameter sh:MaxExclusiveConstraintComponent-maxExclusive ;
	rdfs:isDefinedBy sh: .

sh:MaxExclusiveConstraintComponent-maxExclusive
	a sh:Parameter ;
	sh:path sh:maxExclusive ;
	sh:maxCount 1 ;
	sh:nodeKind sh:Literal ;
	rdfs:isDefinedBy sh: .

sh:maxExclusive
	a rdf:Property ;
	rdfs:label "max exclusive"@en ;
	rdfs:comment "Specifies the maximum exclusive value of each value node."@en ;
	rdfs:isDefinedBy sh: .


sh:MaxInclusiveConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Max-inclusive Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the range of value nodes with a maximum inclusive value."@en ;
	sh:parameter sh:MaxInclusiveConstraintComponent-maxInclusive ;
	rdfs:isDefinedBy sh: .

sh:MaxInclusiveConstraintComponent-maxInclusive
	a sh:Parameter ;
	sh:path sh:maxInclusive ;
	sh:maxCount 1 ;
	sh:nodeKind sh:Literal ;
	rdfs:isDefinedBy sh: .

sh:maxInclusive
	a rdf:Property ;
	rdfs:label "max inclusive"@en ;
	rdfs:comment "Specifies the maximum inclusive value of each value node."@en ;
	rdfs:isDefinedBy sh: .


sh:MaxLengthConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Max-length Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the maximum string length of value nodes."@en ;
	sh:parameter sh:MaxLengthConstraintComponent-maxLength ;
	rdfs:isDefinedBy sh: .

sh:MaxLengthConstraintComponent-maxLength
	a sh:Parameter ;
	sh:path sh:maxLength ;
	sh:datatype xsd:integer ;
	sh:maxCount 1 ;
	rdfs:isDefinedBy sh: .

sh:maxLength
	a rdf:Property ;
	rdfs:label "max length"@en ;
	rdfs:comment "Specifies the maximum string length of each value node."@en ;
	rdfs:range xsd:integer ;
	rdfs:isDefinedBy sh: .


sh:MinCountConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Min-count Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the minimum number of value nodes."@en ;
	sh:parameter sh:MinCountConstraintComponent-minCount ;
	rdfs:isDefinedBy sh: .

sh:MinCountConstraintComponent-minCount
	a sh:Parameter ;
	sh:path sh:minCount ;
	sh:datatype xsd:integer ;
	sh:maxCount 1 ;
	rdfs:isDefinedBy sh: .

sh:minCount
	a rdf:Property ;
	rdfs:label "min count"@en ;
	rdfs:comment "Specifies the minimum number of values in the set of value nodes."@en ;
	rdfs:range xsd:integer ;
	rdfs:isDefinedBy sh: .


sh:MinExclusiveConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Min-exclusive Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the range of value nodes with a minimum exclusive value."@en ;
	sh:parameter sh:MinExclusiveConstraintComponent-minExclusive ;
	rdfs:isDefinedBy sh: .

sh:MinExclusiveConstraintComponent-minExclusive
	a sh:Parameter ;
	sh:path sh:minExclusive ;
	sh:maxCount 1 ;
	sh:nodeKind sh:Literal ;
	rdfs:isDefinedBy sh: .

sh:minExclusive
	a rdf:Property ;
	rdfs:label "min exclusive"@en ;
	rdfs:comment "Specifies the minimum exclusive value of each value node."@en ;
	rdfs:isDefinedBy sh: .


sh:MinInclusiveConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Min-inclusive Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the range of value nodes with a minimum inclusive value."@en ;
	sh:parameter sh:MinInclusiveConstraintComponent-minInclusive ;
	rdfs:isDefinedBy sh: .

sh:MinInclusiveConstraintComponent-minInclusive
	a sh:Parameter ;
	sh:path sh:minInclusive ;
	sh:maxCount 1 ;
	sh:nodeKind sh:Literal ;
	rdfs:isDefinedBy sh: .

sh:minInclusive
	a rdf:Property ;
	rdfs:label "min inclusive"@en ;
	rdfs:comment "Specifies the minimum inclusive value of each value node."@en ;
	rdfs:isDefinedBy sh: .


sh:MinLengthConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Min-length Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the minimum string length of value nodes."@en ;
	sh:parameter sh:MinLengthConstraintComponent-minLength ;
	rdfs:isDefinedBy sh: .

sh:MinLengthConstraintComponent-minLength
	a sh:Parameter ;
	sh:path sh:minLength ;
	sh:datatype xsd:integer ;
	sh:maxCount 1 ;
	rdfs:isDefinedBy sh: .

sh:minLength
	a rdf:Property ;
	rdfs:label "min length"@en ;
	rdfs:comment "Specifies the minimum string length of each value node."@en ;
	rdfs:range xsd:integer ;
	rdfs:isDefinedBy sh: .


sh:NodeConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Node Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that all value nodes conform to the given node shape."@en ;
	sh:parameter sh:NodeConstraintComponent-node ;
	rdfs:isDefinedBy sh: .

sh:NodeConstraintComponent-node
	a sh:Parameter ;
	sh:path sh:node ;
	rdfs:isDefinedBy sh: .

sh:node
	a rdf:Property ;
	rdfs:label "node"@en ;
	rdfs:comment "Specifies the node shape that all value nodes must conform to."@en ;
	rdfs:range sh:NodeShape ;
	rdfs:isDefinedBy sh: .


sh:NodeKindConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Node-kind Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the RDF node kind of each value node."@en ;
	sh:parameter sh:NodeKindConstraintComponent-nodeKind ;
	rdfs:isDefinedBy sh: .

sh:NodeKindConstraintComponent-nodeKind
	a sh:Parameter ;
	sh:path sh:nodeKind ;
	sh:in ( sh:BlankNode sh:IRI sh:Literal sh:BlankNodeOrIRI sh:BlankNodeOrLiteral sh:IRIOrLiteral ) ;
	sh:maxCount 1 ;
	rdfs:isDefinedBy sh: .

sh:nodeKind
	a rdf:Property ;
	rdfs:label "node kind"@en ;
	rdfs:comment "Specifies the node kind (e.g. IRI or literal) each value node."@en ;
	rdfs:range sh:NodeKind ;
	rdfs:isDefinedBy sh: .


sh:NotConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Not Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that value nodes do not conform to a given shape."@en ;
	sh:parameter sh:NotConstraintComponent-not ;
	rdfs:isDefinedBy sh: .

sh:NotConstraintComponent-not
	a sh:Parameter ;
	sh:path sh:not ;
	rdfs:isDefinedBy sh: .

sh:not
	a rdf:Property ;
	rdfs:label "not"@en ;
	rdfs:comment "Specifies a shape that the value nodes must not conform to."@en ;
	rdfs:range sh:Shape ;
	rdfs:isDefinedBy sh: .


sh:OrConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Or Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the value nodes so that they conform to at least one out of several provided shapes."@en ;
	sh:parameter sh:OrConstraintComponent-or ;
	rdfs:isDefinedBy sh: .

sh:OrConstraintComponent-or
	a sh:Parameter ;
	sh:path sh:or ;
	rdfs:isDefinedBy sh: .

sh:or
	a rdf:Property ;
	rdfs:label "or"@en ;
	rdfs:comment "Specifies a list of shapes so that the value nodes must conform to at least one of the shapes."@en ;
	rdfs:range rdf:List ;    # members: sh:Shape ;
	rdfs:isDefinedBy sh: .


sh:PatternConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Pattern Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that every value node matches a given regular expression."@en ;
	sh:parameter sh:PatternConstraintComponent-pattern ;
	sh:parameter sh:PatternConstraintComponent-flags ;
	rdfs:isDefinedBy sh: .

sh:PatternConstraintComponent-pattern
	a sh:Parameter ;
	sh:path sh:pattern ;
	sh:datatype xsd:string ;
	rdfs:isDefinedBy sh: .

sh:PatternConstraintComponent-flags
	a sh:Parameter ;
	sh:path sh:flags ;
	sh:datatype xsd:string ;
	sh:optional true ;
	rdfs:isDefinedBy sh: .

sh:flags
	a rdf:Property ;
	rdfs:label "flags"@en ;
	rdfs:comment "An optional flag to be used with regular expression pattern matching."@en ;
	rdfs:range xsd:string ;
	rdfs:isDefinedBy sh: .

sh:pattern
	a rdf:Property ;
	rdfs:label "pattern"@en ;
	rdfs:comment "Specifies a regular expression pattern that the string representations of the value nodes must match."@en ;
	rdfs:range xsd:string ;
	rdfs:isDefinedBy sh: .


sh:PropertyConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Property Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that all value nodes conform to the given property shape."@en ;
	sh:parameter sh:PropertyConstraintComponent-property ;
	rdfs:isDefinedBy sh: .

sh:PropertyConstraintComponent-property
	a sh:Parameter ;
	sh:path sh:property ;
	rdfs:isDefinedBy sh: .

sh:property
	a rdf:Property ;
	rdfs:label "property"@en ;
	rdfs:comment "Links a shape to its property shapes."@en ;
	rdfs:domain sh:Shape ;
	rdfs:range sh:PropertyShape ;
	rdfs:isDefinedBy sh: .


sh:QualifiedMaxCountConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Qualified-max-count Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that a specified maximum number of value nodes conforms to a given shape."@en ;
	sh:parameter sh:QualifiedMaxCountConstraintComponent-qualifiedMaxCount ;
	sh:parameter sh:QualifiedMaxCountConstraintComponent-qualifiedValueShape ;
	sh:parameter sh:QualifiedMaxCountConstraintComponent-qualifiedValueShapesDisjoint ;
	rdfs:isDefinedBy sh: .

sh:QualifiedMaxCountConstraintComponent-qualifiedMaxCount
	a sh:Parameter ;
	sh:path sh:qualifiedMaxCount ;
	sh:datatype xsd:integer ;
	rdfs:isDefinedBy sh: .

sh:QualifiedMaxCountConstraintComponent-qualifiedValueShape
	a sh:Parameter ;
	sh:path sh:qualifiedValueShape ;
	rdfs:isDefinedBy sh: .

sh:QualifiedMaxCountConstraintComponent-qualifiedValueShapesDisjoint
	a sh:Parameter ;
	sh:path sh:qualifiedValueShapesDisjoint ;
	sh:datatype xsd:boolean ;
	sh:optional true ;
	rdfs:isDefinedBy sh: .


sh:QualifiedMinCountConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Qualified-min-count Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that a specified minimum number of value nodes conforms to a given shape."@en ;
	sh:parameter sh:QualifiedMinCountConstraintComponent-qualifiedMinCount ;
	sh:parameter sh:QualifiedMinCountConstraintComponent-qualifiedValueShape ;
	sh:parameter sh:QualifiedMinCountConstraintComponent-qualifiedValueShapesDisjoint ;
	rdfs:isDefinedBy sh: .

sh:QualifiedMinCountConstraintComponent-qualifiedMinCount
	a sh:Parameter ;
	sh:path sh:qualifiedMinCount ;
	sh:datatype xsd:integer ;
	rdfs:isDefinedBy sh: .

sh:QualifiedMinCountConstraintComponent-qualifiedValueShape
	a sh:Parameter ;
	sh:path sh:qualifiedValueShape ;
	rdfs:isDefinedBy sh: .

sh:QualifiedMinCountConstraintComponent-qualifiedValueShapesDisjoint
	a sh:Parameter ;
	sh:path sh:qualifiedValueShapesDisjoint ;
	sh:datatype xsd:boolean ;
	sh:optional true ;
	rdfs:isDefinedBy sh: .

sh:qualifiedMaxCount
	a rdf:Property ;
	rdfs:label "qualified max count"@en ;
	rdfs:comment "The maximum number of value nodes that can conform to the shape."@en ;
	rdfs:range xsd:integer ;
	rdfs:isDefinedBy sh: .

sh:qualifiedMinCount
	a rdf:Property ;
	rdfs:label "qualified min count"@en ;
	rdfs:comment "The minimum number of value nodes that must conform to the shape."@en ;
	rdfs:range xsd:integer ;
	rdfs:isDefinedBy sh: .

sh:qualifiedValueShape
	a rdf:Property ;
	rdfs:label "qualified value shape"@en ;
	rdfs:comment "The shape that a specified number of values must conform to."@en ;
	rdfs:range sh:Shape ;
	rdfs:isDefinedBy sh: .
	
sh:qualifiedValueShapesDisjoint
	a rdf:Property ;
	rdfs:label "qualified value shapes disjoint"@en ;
	rdfs:comment "Can be used to mark the qualified value shape to be disjoint with its sibling shapes."@en ;
	rdfs:range xsd:boolean ;
	rdfs:isDefinedBy sh: .


sh:UniqueLangConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Unique-languages Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to specify that no pair of value nodes may use the same language tag."@en ;
	sh:parameter sh:UniqueLangConstraintComponent-uniqueLang ;
	rdfs:isDefinedBy sh: .

sh:UniqueLangConstraintComponent-uniqueLang
	a sh:Parameter ;
	sh:path sh:uniqueLang ;
	sh:datatype xsd:boolean ;
	sh:maxCount 1 ;
	rdfs:isDefinedBy sh: .

sh:uniqueLang
	a rdf:Property ;
	rdfs:label "unique languages"@en ;
	rdfs:comment "Specifies whether all node values must have a unique (or no) language tag."@en ;
	rdfs:range xsd:boolean ;
	rdfs:isDefinedBy sh: .


sh:XoneConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Exactly one Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to restrict the value nodes so that they conform to exactly one out of several provided shapes."@en ;
	sh:parameter sh:XoneConstraintComponent-xone ;
	rdfs:isDefinedBy sh: .

sh:XoneConstraintComponent-xone
	a sh:Parameter ;
	sh:path sh:xone ;
	rdfs:isDefinedBy sh: .

sh:xone
	a rdf:Property ;
	rdfs:label "exactly one"@en ;
	rdfs:comment "Specifies a list of shapes so that the value nodes must conform to exactly one of the shapes."@en ;
	rdfs:range rdf:List ;    # members: sh:Shape ;
	rdfs:isDefinedBy sh: .


# General SPARQL execution support --------------------------------------------

sh:SPARQLExecutable
	a rdfs:Class ;
	rdfs:label "SPARQL Executable"@en ;
	rdfs:comment "The class of resources that encapsulate a SPARQL query."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:SPARQLAskExecutable
	a rdfs:Class ;
	rdfs:label "SPARQL ASK Executable"@en ;
	rdfs:comment "The class of SPARQL executables that are based on an ASK query."@en ;
	rdfs:subClassOf sh:SPARQLExecutable ;
	rdfs:isDefinedBy sh: .

sh:ask
	a rdf:Property ;
	rdfs:label "ask"@en ;
	rdfs:comment "The SPARQL ASK query to execute."@en ;
	rdfs:domain sh:SPARQLAskExecutable ;
	rdfs:range xsd:string ;
	rdfs:isDefinedBy sh: .

sh:SPARQLConstructExecutable
	a rdfs:Class ;
	rdfs:label "SPARQL CONSTRUCT Executable"@en ;
	rdfs:comment "The class of SPARQL executables that are based on a CONSTRUCT query."@en ;
	rdfs:subClassOf sh:SPARQLExecutable ;
	rdfs:isDefinedBy sh: .

sh:construct
	a rdf:Property ;
	rdfs:label "construct"@en ;
	rdfs:comment "The SPARQL CONSTRUCT query to execute."@en ;
	rdfs:domain sh:SPARQLConstructExecutable ;
	rdfs:range xsd:string ;
	rdfs:isDefinedBy sh: .

sh:SPARQLSelectExecutable
	a rdfs:Class ;
	rdfs:label "SPARQL SELECT Executable"@en ;
	rdfs:comment "The class of SPARQL executables based on a SELECT query."@en ;
	rdfs:subClassOf sh:SPARQLExecutable ;
	rdfs:isDefinedBy sh: .

sh:select
	a rdf:Property ;
	rdfs:label "select"@en ;
	rdfs:comment "The SPARQL SELECT query to execute."@en ;
	rdfs:range xsd:string ;
	rdfs:domain sh:SPARQLSelectExecutable ;
	rdfs:isDefinedBy sh: .

sh:SPARQLUpdateExecutable
	a rdfs:Class ;
	rdfs:label "SPARQL UPDATE Executable"@en ;
	rdfs:comment "The class of SPARQL executables based on a SPARQL UPDATE."@en ;
	rdfs:subClassOf sh:SPARQLExecutable ;
	rdfs:isDefinedBy sh: .

sh:update
	a rdf:Property ;
	rdfs:label "update"@en ;
	rdfs:comment "The SPARQL UPDATE to execute."@en ;
	rdfs:domain sh:SPARQLUpdateExecutable ;
	rdfs:range xsd:string ;
	rdfs:isDefinedBy sh: .

sh:prefixes
	a rdf:Property ;
	rdfs:label "prefixes"@en ;
	rdfs:comment "The prefixes that shall be applied before parsing the associated SPARQL query."@en ;
	rdfs:domain sh:SPARQLExecutable ;
	rdfs:range owl:Ontology ;
	rdfs:isDefinedBy sh: .

sh:PrefixDeclaration
	a rdfs:Class ;
	rdfs:label "Prefix Declaration"@en ;
	rdfs:comment "The class of prefix declarations, consisting of pairs of a prefix with a namespace."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:declare
	a rdf:Property ;
	rdfs:label "declare"@en ;
	rdfs:comment "Links a resource with its namespace prefix declarations."@en ;
	rdfs:domain owl:Ontology ;
	rdfs:range sh:PrefixDeclaration ;
	rdfs:isDefinedBy sh: .

sh:prefix
	a rdf:Property ;
	rdfs:label "prefix"@en ;
	rdfs:comment "The prefix of a prefix declaration."@en ;
	rdfs:domain sh:PrefixDeclaration ;
	rdfs:range xsd:string ;
	rdfs:isDefinedBy sh: .

sh:namespace
	a rdf:Property ;
	rdfs:label "namespace"@en ;
	rdfs:comment "The namespace associated with a prefix in a prefix declaration."@en ;
	rdfs:domain sh:PrefixDeclaration ;
	rdfs:range xsd:anyURI ;
	rdfs:isDefinedBy sh: .
	

# SPARQL-based Constraints support --------------------------------------------

sh:SPARQLConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "SPARQL Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to define constraints based on SPARQL queries."@en ;
	sh:parameter sh:SPARQLConstraintComponent-sparql ;
	rdfs:isDefinedBy sh: .

sh:SPARQLConstraintComponent-sparql
	a sh:Parameter ;
	sh:path sh:sparql ;
	rdfs:isDefinedBy sh: .

sh:sparql
	a rdf:Property ;
	rdfs:label "constraint (in SPARQL)"@en ;
	rdfs:comment "Links a shape with SPARQL constraints."@en ;
	rdfs:domain sh:Shape ;
	rdfs:range sh:SPARQLConstraint ;
	rdfs:isDefinedBy sh: .

sh:SPARQLConstraint
	a rdfs:Class ;
	rdfs:label "SPARQL Constraint"@en ;
	rdfs:comment "The class of constraints based on SPARQL SELECT queries."@en ;
	rdfs:subClassOf sh:SPARQLSelectExecutable ;
	rdfs:isDefinedBy sh: .


# Non-validating constraint properties ----------------------------------------

sh:defaultValue
	a rdf:Property ;
	rdfs:label "default value"@en ;
	rdfs:comment "A default value for a property, for example for user interface tools to pre-populate input fields."@en ;
	rdfs:domain sh:PropertyShape ;
	rdfs:isDefinedBy sh: .

sh:description
	a rdf:Property ;
	rdfs:label "description"@en ;
	rdfs:comment "Human-readable descriptions for the property in the context of the surrounding shape."@en ;
	rdfs:domain sh:PropertyShape ;
	# range: xsd:string or rdf:langString
	rdfs:isDefinedBy sh: .

sh:group
	a rdf:Property ;
	rdfs:label "group"@en ;
	rdfs:comment "Can be used to link to a property group to indicate that a property shape belongs to a group of related property shapes."@en ;
	rdfs:domain sh:PropertyShape ;
	rdfs:range sh:PropertyGroup ;
	rdfs:isDefinedBy sh: .

sh:name
	a rdf:Property ;
	rdfs:label "name"@en ;
	rdfs:comment "Human-readable labels for the property in the context of the surrounding shape."@en ;
	rdfs:domain sh:PropertyShape ;
	# range: xsd:string or rdf:langString
	rdfs:isDefinedBy sh: .

sh:order
	a rdf:Property ;
	rdfs:label "order"@en ;
	rdfs:comment "Specifies the relative order of this compared to its siblings. For example use 0 for the first, 1 for the second."@en ;
	# range: xsd:decimal or xsd:integer ;
	rdfs:isDefinedBy sh: .

sh:PropertyGroup
	a rdfs:Class ;
	rdfs:label "Property Group"@en ;
	rdfs:comment "Instances of this class represent groups of property shapes that belong together."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .


# -----------------------------------------------------------------------------
# SHACL ADVANCED FEATURES -----------------------------------------------------
# -----------------------------------------------------------------------------
	

# Advanced Target vocabulary --------------------------------------------------

sh:target
	a rdf:Property ;
	rdfs:label "target"@en ;
	rdfs:comment "Links a shape to a target specified by an extension language, for example instances of sh:SPARQLTarget."@en ;
	rdfs:domain sh:Shape ;
	rdfs:range sh:Target ;
	rdfs:isDefinedBy sh: .

sh:Target
	a rdfs:Class ;
	rdfs:label "Target"@en ;
	rdfs:comment "The base class of targets such as those based on SPARQL queries."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:TargetType
	a rdfs:Class ;
	rdfs:label "Target Type"@en ;
	rdfs:comment "The (meta) class for parameterizable targets.	Instances of this are instantiated as values of the sh:target property."@en ;
	rdfs:subClassOf rdfs:Class ;
	rdfs:subClassOf sh:Parameterizable ;
	rdfs:isDefinedBy sh: .

sh:SPARQLTarget
	a rdfs:Class ;
	rdfs:label "SPARQL Target"@en ;
	rdfs:comment "The class of targets that are based on SPARQL queries."@en ;
	rdfs:subClassOf sh:Target ;
	rdfs:subClassOf sh:SPARQLAskExecutable ;
	rdfs:subClassOf sh:SPARQLSelectExecutable ;
	rdfs:isDefinedBy sh: .

sh:SPARQLTargetType
	a rdfs:Class ;
	rdfs:label "SPARQL Target Type"@en ;
	rdfs:comment "The (meta) class for parameterizable targets that are based on SPARQL queries."@en ;
	rdfs:subClassOf sh:TargetType ;
	rdfs:subClassOf sh:SPARQLAskExecutable ;
	rdfs:subClassOf sh:SPARQLSelectExecutable ;
	rdfs:isDefinedBy sh: .


# Functions Vocabulary --------------------------------------------------------

sh:Function
	a rdfs:Class ;
	rdfs:label "Function"@en ;
	rdfs:comment "The class of SHACL functions."@en ;
	rdfs:subClassOf sh:Parameterizable ;
	rdfs:isDefinedBy sh: .

sh:returnType
	a rdf:Property ;
	rdfs:label "return type"@en ;
	rdfs:comment "The expected type of values returned by the associated function."@en ;
	rdfs:domain sh:Function ;
	rdfs:range rdfs:Class ;
	rdfs:isDefinedBy sh: .

sh:SPARQLFunction
	a rdfs:Class ;
	rdfs:label "SPARQL Function"@en ;
	rdfs:comment "A function backed by a SPARQL query - either ASK or SELECT."@en ;
	rdfs:subClassOf sh:Function ;
	rdfs:subClassOf sh:SPARQLAskExecutable ;
	rdfs:subClassOf sh:SPARQLSelectExecutable ;
	rdfs:isDefinedBy sh: .


# Result Annotations ----------------------------------------------------------

sh:resultAnnotation
	a rdf:Property ;
	rdfs:label "result annotation"@en ;
	rdfs:comment "Links a SPARQL validator with zero or more sh:ResultAnnotation instances, defining how to derive additional result properties based on the variables of the SELECT query."@en ;
	rdfs:domain sh:SPARQLSelectValidator ;
	rdfs:range sh:ResultAnnotation ;
	rdfs:isDefinedBy sh: .

sh:ResultAnnotation
	a rdfs:Class ;
	rdfs:label "Result Annotation"@en ;
	rdfs:comment "A class of result annotations, which define the rules to derive the values of a given annotation property as extra values for a validation result."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:annotationProperty
	a rdf:Property ;
	rdfs:label "annotation property"@en ;
	rdfs:comment "The annotation property that shall be set."@en ;
	rdfs:domain sh:ResultAnnotation ;
	rdfs:range rdf:Property ;
	rdfs:isDefinedBy sh: .

sh:annotationValue
	a rdf:Property ;
	rdfs:label "annotation value"@en ;
	rdfs:comment "The (default) values of the annotation property."@en ;
	rdfs:domain sh:ResultAnnotation ;
	rdfs:isDefinedBy sh: .

sh:annotationVarName
	a rdf:Property ;
	rdfs:label "annotation variable name"@en ;
	rdfs:comment "The name of the SPARQL variable from the SELECT clause that shall be used for the values."@en ;
	rdfs:domain sh:ResultAnnotation ;
	rdfs:range xsd:string ;
	rdfs:isDefinedBy sh: .

	
# Node Expressions ------------------------------------------------------------

sh:this
	a rdfs:Resource ;
	rdfs:label "this"@en ;
	rdfs:comment "A node expression that represents the current focus node."@en ;
	rdfs:isDefinedBy sh: .

sh:filterShape
	a rdf:Property ;
	rdfs:label "filter shape"@en ;
	rdfs:comment "The shape that all input nodes of the expression need to conform to."@en ;
	rdfs:range sh:Shape ;
	rdfs:isDefinedBy sh: .

sh:nodes
	a rdf:Property ;
	rdfs:label "nodes"@en ;
	rdfs:comment "The node expression producing the input nodes of a filter shape expression."@en ;
	rdfs:isDefinedBy sh: .

sh:intersection
	a rdf:Property ;
	rdfs:label "intersection"@en ;
	rdfs:comment "A list of node expressions that shall be intersected."@en ;
	rdfs:isDefinedBy sh: .

sh:union
	a rdf:Property ;
	rdfs:label "union"@en ;
	rdfs:comment "A list of node expressions that shall be used together."@en ;
	rdfs:isDefinedBy sh: .


# Expression Constraints ------------------------------------------------------

sh:ExpressionConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "Expression Constraint Component"@en ;
	rdfs:comment "A constraint component that can be used to verify that a given node expression produces true for all value nodes."@en ;
	sh:parameter sh:ExpressionConstraintComponent-expression ;
	rdfs:isDefinedBy sh: .

sh:ExpressionConstraintComponent-expression
	a sh:Parameter ;
	sh:path sh:expression ;
	rdfs:isDefinedBy sh: .

sh:expression
	a rdf:Property ;
	rdfs:label "expression"@en ;
	rdfs:comment "The node expression that must return true for the value nodes."@en ;
	rdfs:isDefinedBy sh: .


# Rules -----------------------------------------------------------------------

sh:Rule
	a rdfs:Class ;
	rdfs:label "Rule"@en ;
	rdfs:comment "The class of SHACL rules. Never instantiated directly."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:rule
	a rdf:Property ;
	rdfs:label "rule"@en ;
	rdfs:comment "The rules linked to a shape."@en ;
	rdfs:domain sh:Shape ;
	rdfs:range sh:Rule ;
	rdfs:isDefinedBy sh:  .

sh:condition
	a rdf:Property ;
	rdfs:label "condition"@en ;
	rdfs:comment "The shapes that the focus nodes need to conform to before a rule is executed on them."@en ;
	rdfs:domain sh:Rule ;
	rdfs:range sh:Shape ;
	rdfs:isDefinedBy sh: .

sh:TripleRule
	a rdfs:Class ;
	rdfs:label "Triple Rule"@en ;
	rdfs:comment "A rule based on triple (subject, predicate, object) pattern."@en ;
	rdfs:subClassOf sh:Rule ;
	rdfs:isDefinedBy sh: .

sh:subject
	a rdf:Property ;
	rdfs:label "subject"@en ;
	rdfs:comment "An expression producing the resources that shall be inferred as subjects."@en ;
	rdfs:domain sh:TripleRule ;
	rdfs:isDefinedBy sh: .

sh:predicate
	a rdf:Property ;
	rdfs:label "predicate"@en ;
	rdfs:comment "An expression producing the properties that shall be inferred as predicates."@en ;
	rdfs:domain sh:TripleRule ;
	rdfs:isDefinedBy sh: .

sh:object
	a rdf:Property ;
	rdfs:label "object"@en ;
	rdfs:comment "An expression producing the nodes that shall be inferred as objects."@en ;
	rdfs:domain sh:TripleRule ;
	rdfs:isDefinedBy sh: .

sh:SPARQLRule
	a rdfs:Class ;
	rdfs:label "SPARQL CONSTRUCT Rule"@en ;
	rdfs:comment "The class of SHACL rules based on SPARQL CONSTRUCT queries."@en ;
	rdfs:subClassOf sh:Rule ;
	rdfs:subClassOf sh:SPARQLConstructExecutable ;
	rdfs:isDefinedBy sh: .


# SHACL-JS --------------------------------------------------------------------

sh:JSExecutable
	a rdfs:Class ;
	rdfs:label "JavaScript Executable"@en ;
	rdfs:comment "Abstract base class of resources that declare an executable JavaScript."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:JSTarget
	a rdfs:Class ;
	rdfs:label "JavaScript Target"@en ;
	rdfs:comment "The class of targets that are based on JavaScript functions."@en ;
	rdfs:subClassOf sh:Target ;
	rdfs:subClassOf sh:JSExecutable ;
	rdfs:isDefinedBy sh: .

sh:JSTargetType
	a rdfs:Class ;
	rdfs:label "JavaScript Target Type"@en ;
	rdfs:comment "The (meta) class for parameterizable targets that are based on JavaScript functions."@en ;
	rdfs:subClassOf sh:TargetType ;
	rdfs:subClassOf sh:JSExecutable ;
	rdfs:isDefinedBy sh: .

sh:JSConstraint
	a rdfs:Class ;
	rdfs:label "JavaScript Constraint"@en ;
	rdfs:comment "The class of constraints backed by a JavaScript function."@en ;
	rdfs:subClassOf sh:JSExecutable ;
	rdfs:isDefinedBy sh: .
	
sh:JSConstraintComponent
	a sh:ConstraintComponent ;
	rdfs:label "JavaScript Constraint Component"@en ;
	rdfs:comment "A constraint component with the parameter sh:js linking to a sh:JSConstraint containing a sh:script."@en ;
  	sh:parameter sh:JSConstraint-js ;
	rdfs:isDefinedBy sh: .
 
sh:JSConstraint-js
	a sh:Parameter ;
	sh:path sh:js ;
	rdfs:isDefinedBy sh: .
	
sh:js
	a rdf:Property ;
	rdfs:label "JavaScript constraint"@en ;
	rdfs:comment "Constraints expressed in JavaScript." ;
  	rdfs:range sh:JSConstraint ;
	rdfs:isDefinedBy sh: .

sh:jsFunctionName
	a rdf:Property ;
	rdfs:label "JavaScript function name"@en ;
	rdfs:comment "The name of the JavaScript function to execute."@en ;
	rdfs:domain sh:JSExecutable ;
	rdfs:range xsd:string ;
	rdfs:isDefinedBy sh: .

sh:jsLibrary
	a rdf:Property ;
	rdfs:label "JavaScript library"@en ;
  	rdfs:comment "Declares which JavaScript libraries are needed to execute this."@en ;
	rdfs:range sh:JSLibrary ;
	rdfs:isDefinedBy sh: .

sh:jsLibraryURL
	a rdf:Property ;
	rdfs:label "JavaScript library URL"@en ;
	rdfs:comment "Declares the URLs of a JavaScript library. This should be the absolute URL of a JavaScript file. Implementations may redirect those to local files."@en ;
	rdfs:domain sh:JSLibrary ;
	rdfs:range xsd:anyURI ;
	rdfs:isDefinedBy sh: .
	
sh:JSFunction
	a rdfs:Class ;
  	rdfs:label "JavaScript Function"@en ;
	rdfs:comment "The class of SHACL functions that execute a JavaScript function when called."@en ;
	rdfs:subClassOf sh:Function ;
	rdfs:subClassOf sh:JSExecutable ;
	rdfs:isDefinedBy sh: .

sh:JSLibrary
	a rdfs:Class ;
	rdfs:label "JavaScript Library"@en ;
	rdfs:comment "Represents a JavaScript library, typically identified by one or more URLs of files to include."@en ;
	rdfs:subClassOf rdfs:Resource ;
	rdfs:isDefinedBy sh: .

sh:JSRule
	a rdfs:Class ;
	rdfs:label "JavaScript Rule"@en ;
	rdfs:comment "The class of SHACL rules expressed using JavaScript."@en ;
	rdfs:subClassOf sh:JSExecutable ;
	rdfs:subClassOf sh:Rule ;
	rdfs:isDefinedBy sh: .

sh:JSValidator
	a rdfs:Class ;
  	rdfs:label "JavaScript Validator"@en ;
	rdfs:comment "A SHACL validator based on JavaScript. This can be used to declare SHACL constraint components that perform JavaScript-based validation when used."@en ;
  	rdfs:subClassOf sh:JSExecutable ;
  	rdfs:subClassOf sh:Validator ;
  	rdfs:isDefinedBy sh: .
`;

export const skos_xl = `@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix dct: <http://purl.org/dc/terms/> .
@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix skos: <http://www.w3.org/2004/02/skos/core#> .

<http://www.w3.org/2008/05/skos-xl> a owl:Ontology ;
	dct:creator "Alistair Miles" , "Sean Bechhofer" ;
	rdfs:seeAlso <http://www.w3.org/2008/05/skos> ;
	owl:imports <http://www.w3.org/2004/02/skos/core> ;
	dct:title "SKOS XL Vocabulary"@en ;
	dct:contributor "Participants in W3C's Semantic Web Deployment Working Group." ;
	dct:description "An RDF vocabulary extending SKOS and allowing the description and linking of lexical entities."@en .

<http://www.w3.org/2008/05/skos-xl#Label> rdfs:label "Label"@en ;
	rdfs:isDefinedBy <http://www.w3.org/2008/05/skos-xl> ;
	skos:definition "A special class of lexical entities."@en ;
	a owl:Class ;
	owl:disjointWith skos:Concept , skos:Collection , skos:ConceptScheme ;
	rdfs:subClassOf _:node17168m7qhx2 .

_:node17168m7qhx2 a owl:Restriction ;
	owl:onProperty <http://www.w3.org/2008/05/skos-xl#literalForm> ;
	owl:cardinality "1"^^<http://www.w3.org/2001/XMLSchema#nonNegativeInteger> .

<http://www.w3.org/2008/05/skos-xl#literalForm> rdfs:label "literal form"@en ;
	rdfs:isDefinedBy <http://www.w3.org/2008/05/skos-xl> ;
	skos:definition "The property skosxl:literalForm is used to give the literal form of an skosxl:Label."@en ;
	rdfs:comment "If two instances of the class skosxl:Label have the same literal form, they are not necessarily the same resource."@en ;
	a owl:DatatypeProperty ;
	rdfs:domain <http://www.w3.org/2008/05/skos-xl#Label> ;
	rdfs:comment "The range of skosxl:literalForm is the class of RDF plain literals."@en ;
	a rdf:Property .

<http://www.w3.org/2008/05/skos-xl#prefLabel> rdfs:label "preferred label"@en ;
	rdfs:isDefinedBy <http://www.w3.org/2008/05/skos-xl> ;
	skos:definition "The property skosxl:prefLabel is used to associate an skosxl:Label with a skos:Concept. The property is analogous to skos:prefLabel."@en ;
	rdfs:seeAlso skos:prefLabel ;
	a owl:ObjectProperty ;
	rdfs:range <http://www.w3.org/2008/05/skos-xl#Label> ;
	rdfs:comment "If C skosxl:prefLabel L and L skosxl:literalForm V, then X skos:prefLabel V."@en ;
	a rdf:Property .

<http://www.w3.org/2008/05/skos-xl#altLabel> rdfs:label "alternative label"@en ;
	rdfs:isDefinedBy <http://www.w3.org/2008/05/skos-xl> ;
	skos:definition "The property skosxl:altLabel is used to associate an skosxl:Label with a skos:Concept. The property is analogous to skos:altLabel."@en ;
	rdfs:seeAlso skos:altLabel ;
	a owl:ObjectProperty ;
	rdfs:range <http://www.w3.org/2008/05/skos-xl#Label> ;
	rdfs:comment "If C skosxl:altLabel L and L skosxl:literalForm V, then X skos:altLabel V."@en ;
	a rdf:Property .

<http://www.w3.org/2008/05/skos-xl#hiddenLabel> rdfs:label "hidden label"@en ;
	rdfs:isDefinedBy <http://www.w3.org/2008/05/skos-xl> ;
	skos:definition "The property skosxl:hiddenLabel is used to associate an skosxl:Label with a skos:Concept. The property is analogous to skos:hiddenLabel."@en ;
	rdfs:seeAlso skos:hiddenLabel ;
	a owl:ObjectProperty ;
	rdfs:range <http://www.w3.org/2008/05/skos-xl#Label> ;
	rdfs:comment "If C skosxl:hiddenLabel L and L skosxl:literalForm V, then C skos:hiddenLabel V."@en ;
	a rdf:Property .

<http://www.w3.org/2008/05/skos-xl#labelRelation> rdfs:label "label relation"@en ;
	rdfs:isDefinedBy <http://www.w3.org/2008/05/skos-xl> ;
	skos:definition "The property skosxl:labelRelation is used for representing binary ('direct') relations between instances of the class skosxl:Label."@en ;
	skos:scopeNote "skosxl:labelRelation is not intended to be used directly, but rather as the basis for a design pattern which can be refined for more specific labeling scenarios."@en ;
	a owl:ObjectProperty ;
	rdfs:domain <http://www.w3.org/2008/05/skos-xl#Label> ;
	rdfs:range <http://www.w3.org/2008/05/skos-xl#Label> ;
	a owl:SymmetricProperty , rdf:Property .
`;

export const skos = `@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix dc: <http://purl.org/dc/terms/> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix skos: <http://www.w3.org/2004/02/skos/core#> .
@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .

<http://www.w3.org/2004/02/skos/core>
  a owl:Ontology ;
  dc:title "SKOS Vocabulary"@en ;
  dc:contributor "Dave Beckett", "Nikki Rogers", "Participants in W3C's Semantic Web Deployment Working Group." ;
  dc:description "An RDF vocabulary for describing the basic structure and content of concept schemes such as thesauri, classification schemes, subject heading lists, taxonomies, 'folksonomies', other types of controlled vocabulary, and also concept schemes embedded in glossaries and terminologies."@en ;
  dc:creator "Alistair Miles", "Sean Bechhofer" ;
  rdfs:seeAlso <http://www.w3.org/TR/skos-reference/> .

skos:Concept
  rdfs:label "Concept"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "An idea or notion; a unit of thought."@en ;
  a owl:Class .

skos:ConceptScheme
  rdfs:label "Concept Scheme"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "A set of concepts, optionally including statements about semantic relationships between those concepts."@en ;
  skos:scopeNote "A concept scheme may be defined to include concepts from different sources."@en ;
  skos:example "Thesauri, classification schemes, subject heading lists, taxonomies, 'folksonomies', and other types of controlled vocabulary are all examples of concept schemes. Concept schemes are also embedded in glossaries and terminologies."@en ;
  a owl:Class ;
  owl:disjointWith skos:Concept .

skos:Collection
  rdfs:label "Collection"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "A meaningful collection of concepts."@en ;
  skos:scopeNote "Labelled collections can be used where you would like a set of concepts to be displayed under a 'node label' in the hierarchy."@en ;
  a owl:Class ;
  owl:disjointWith skos:Concept, skos:ConceptScheme .

skos:OrderedCollection
  rdfs:label "Ordered Collection"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "An ordered collection of concepts, where both the grouping and the ordering are meaningful."@en ;
  skos:scopeNote "Ordered collections can be used where you would like a set of concepts to be displayed in a specific order, and optionally under a 'node label'."@en ;
  a owl:Class ;
  rdfs:subClassOf skos:Collection .

skos:inScheme
  rdfs:label "is in scheme"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "Relates a resource (for example a concept) to a concept scheme in which it is included."@en ;
  skos:scopeNote "A concept may be a member of more than one concept scheme."@en ;
  a owl:ObjectProperty, rdf:Property ;
  rdfs:range skos:ConceptScheme .

skos:hasTopConcept
  rdfs:label "has top concept"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "Relates, by convention, a concept scheme to a concept which is topmost in the broader/narrower concept hierarchies for that scheme, providing an entry point to these hierarchies."@en ;
  a owl:ObjectProperty, rdf:Property ;
  rdfs:domain skos:ConceptScheme ;
  rdfs:range skos:Concept ;
  owl:inverseOf skos:topConceptOf .

skos:topConceptOf
  rdfs:label "is top concept in scheme"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "Relates a concept to the concept scheme that it is a top level concept of."@en ;
  a owl:ObjectProperty, rdf:Property ;
  rdfs:subPropertyOf skos:inScheme ;
  owl:inverseOf skos:hasTopConcept ;
  rdfs:domain skos:Concept ;
  rdfs:range skos:ConceptScheme .

skos:prefLabel
  rdfs:label "preferred label"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "The preferred lexical label for a resource, in a given language."@en ;
  a owl:AnnotationProperty, rdf:Property ;
  rdfs:subPropertyOf rdfs:label ;
  rdfs:comment "A resource has no more than one value of skos:prefLabel per language tag, and no more than one value of skos:prefLabel without language tag."@en, "The range of skos:prefLabel is the class of RDF plain literals."@en, """skos:prefLabel, skos:altLabel and skos:hiddenLabel are pairwise
      disjoint properties."""@en .

skos:altLabel
  rdfs:label "alternative label"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "An alternative lexical label for a resource."@en ;
  skos:example "Acronyms, abbreviations, spelling variants, and irregular plural/singular forms may be included among the alternative labels for a concept. Mis-spelled terms are normally included as hidden labels (see skos:hiddenLabel)."@en ;
  a owl:AnnotationProperty, rdf:Property ;
  rdfs:subPropertyOf rdfs:label ;
  rdfs:comment "The range of skos:altLabel is the class of RDF plain literals."@en, "skos:prefLabel, skos:altLabel and skos:hiddenLabel are pairwise disjoint properties."@en .

skos:hiddenLabel
  rdfs:label "hidden label"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "A lexical label for a resource that should be hidden when generating visual displays of the resource, but should still be accessible to free text search operations."@en ;
  a owl:AnnotationProperty, rdf:Property ;
  rdfs:subPropertyOf rdfs:label ;
  rdfs:comment "The range of skos:hiddenLabel is the class of RDF plain literals."@en, "skos:prefLabel, skos:altLabel and skos:hiddenLabel are pairwise disjoint properties."@en .

skos:notation
  rdfs:label "notation"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "A notation, also known as classification code, is a string of characters such as 'T58.5' or '303.4833' used to uniquely identify a concept within the scope of a given concept scheme."@en ;
  skos:scopeNote "By convention, skos:notation is used with a typed literal in the object position of the triple."@en ;
  a owl:DatatypeProperty, rdf:Property .

skos:note
  rdfs:label "note"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "A general note, for any purpose."@en ;
  skos:scopeNote "This property may be used directly, or as a super-property for more specific note types."@en ;
  a owl:AnnotationProperty, rdf:Property .

skos:changeNote
  rdfs:label "change note"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "A note about a modification to a concept."@en ;
  a owl:AnnotationProperty, rdf:Property ;
  rdfs:subPropertyOf skos:note .

skos:definition
  rdfs:label "definition"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "A statement or formal explanation of the meaning of a concept."@en ;
  a owl:AnnotationProperty, rdf:Property ;
  rdfs:subPropertyOf skos:note .

skos:editorialNote
  rdfs:label "editorial note"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "A note for an editor, translator or maintainer of the vocabulary."@en ;
  a owl:AnnotationProperty, rdf:Property ;
  rdfs:subPropertyOf skos:note .

skos:example
  rdfs:label "example"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "An example of the use of a concept."@en ;
  a owl:AnnotationProperty, rdf:Property ;
  rdfs:subPropertyOf skos:note .

skos:historyNote
  rdfs:label "history note"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "A note about the past state/use/meaning of a concept."@en ;
  a owl:AnnotationProperty, rdf:Property ;
  rdfs:subPropertyOf skos:note .

skos:scopeNote
  rdfs:label "scope note"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "A note that helps to clarify the meaning and/or the use of a concept."@en ;
  a owl:AnnotationProperty, rdf:Property ;
  rdfs:subPropertyOf skos:note .

skos:semanticRelation
  rdfs:label "is in semantic relation with"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "Links a concept to a concept related by meaning."@en ;
  skos:scopeNote "This property should not be used directly, but as a super-property for all properties denoting a relationship of meaning between concepts."@en ;
  a owl:ObjectProperty, rdf:Property ;
  rdfs:domain skos:Concept ;
  rdfs:range skos:Concept .

skos:broader
  rdfs:label "has broader"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "Relates a concept to a concept that is more general in meaning."@en ;
  rdfs:comment "Broader concepts are typically rendered as parents in a concept hierarchy (tree)."@en ;
  skos:scopeNote "By convention, skos:broader is only used to assert an immediate (i.e. direct) hierarchical link between two conceptual resources."@en ;
  a owl:ObjectProperty, rdf:Property ;
  rdfs:subPropertyOf skos:broaderTransitive ;
  owl:inverseOf skos:narrower .

skos:narrower
  rdfs:label "has narrower"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "Relates a concept to a concept that is more specific in meaning."@en ;
  skos:scopeNote "By convention, skos:broader is only used to assert an immediate (i.e. direct) hierarchical link between two conceptual resources."@en ;
  rdfs:comment "Narrower concepts are typically rendered as children in a concept hierarchy (tree)."@en ;
  a owl:ObjectProperty, rdf:Property ;
  rdfs:subPropertyOf skos:narrowerTransitive ;
  owl:inverseOf skos:broader .

skos:related
  rdfs:label "has related"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "Relates a concept to a concept with which there is an associative semantic relationship."@en ;
  a owl:ObjectProperty, owl:SymmetricProperty, rdf:Property ;
  rdfs:subPropertyOf skos:semanticRelation ;
  rdfs:comment "skos:related is disjoint with skos:broaderTransitive"@en .

skos:broaderTransitive
  rdfs:label "has broader transitive"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "skos:broaderTransitive is a transitive superproperty of skos:broader." ;
  skos:scopeNote "By convention, skos:broaderTransitive is not used to make assertions. Rather, the properties can be used to draw inferences about the transitive closure of the hierarchical relation, which is useful e.g. when implementing a simple query expansion algorithm in a search application."@en ;
  a owl:ObjectProperty, owl:TransitiveProperty, rdf:Property ;
  rdfs:subPropertyOf skos:semanticRelation ;
  owl:inverseOf skos:narrowerTransitive .

skos:narrowerTransitive
  rdfs:label "has narrower transitive"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "skos:narrowerTransitive is a transitive superproperty of skos:narrower." ;
  skos:scopeNote "By convention, skos:narrowerTransitive is not used to make assertions. Rather, the properties can be used to draw inferences about the transitive closure of the hierarchical relation, which is useful e.g. when implementing a simple query expansion algorithm in a search application."@en ;
  a owl:ObjectProperty, owl:TransitiveProperty, rdf:Property ;
  rdfs:subPropertyOf skos:semanticRelation ;
  owl:inverseOf skos:broaderTransitive .

skos:member
  rdfs:label "has member"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "Relates a collection to one of its members."@en ;
  a owl:ObjectProperty, rdf:Property ;
  rdfs:domain skos:Collection ;
  rdfs:range [
    a owl:Class ;
    owl:unionOf (
     skos:Concept
     skos:Collection
   )
  ] .

skos:memberList
  rdfs:label "has member list"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "Relates an ordered collection to the RDF list containing its members."@en ;
  a owl:ObjectProperty, owl:FunctionalProperty, rdf:Property ;
  rdfs:domain skos:OrderedCollection ;
  rdfs:range rdf:List ;
  rdfs:comment """For any resource, every item in the list given as the value of the
      skos:memberList property is also a value of the skos:member property."""@en .

skos:mappingRelation
  rdfs:label "is in mapping relation with"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "Relates two concepts coming, by convention, from different schemes, and that have comparable meanings"@en ;
  rdfs:comment "These concept mapping relations mirror semantic relations, and the data model defined below is similar (with the exception of skos:exactMatch) to the data model defined for semantic relations. A distinct vocabulary is provided for concept mapping relations, to provide a convenient way to differentiate links within a concept scheme from links between concept schemes. However, this pattern of usage is not a formal requirement of the SKOS data model, and relies on informal definitions of best practice."@en ;
  a owl:ObjectProperty, rdf:Property ;
  rdfs:subPropertyOf skos:semanticRelation .

skos:broadMatch
  rdfs:label "has broader match"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "skos:broadMatch is used to state a hierarchical mapping link between two conceptual resources in different concept schemes."@en ;
  a owl:ObjectProperty, rdf:Property ;
  rdfs:subPropertyOf skos:mappingRelation, skos:broader ;
  owl:inverseOf skos:narrowMatch .

skos:narrowMatch
  rdfs:label "has narrower match"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "skos:narrowMatch is used to state a hierarchical mapping link between two conceptual resources in different concept schemes."@en ;
  a owl:ObjectProperty, rdf:Property ;
  rdfs:subPropertyOf skos:mappingRelation, skos:narrower ;
  owl:inverseOf skos:broadMatch .

skos:relatedMatch
  rdfs:label "has related match"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "skos:relatedMatch is used to state an associative mapping link between two conceptual resources in different concept schemes."@en ;
  a owl:ObjectProperty, owl:SymmetricProperty, rdf:Property ;
  rdfs:subPropertyOf skos:mappingRelation, skos:related .

skos:exactMatch
  rdfs:label "has exact match"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "skos:exactMatch is used to link two concepts, indicating a high degree of confidence that the concepts can be used interchangeably across a wide range of information retrieval applications. skos:exactMatch is a transitive property, and is a sub-property of skos:closeMatch."@en ;
  a owl:ObjectProperty, owl:SymmetricProperty, owl:TransitiveProperty, rdf:Property ;
  rdfs:subPropertyOf skos:closeMatch ;
  rdfs:comment "skos:exactMatch is disjoint with each of the properties skos:broadMatch and skos:relatedMatch."@en .

skos:closeMatch
  rdfs:label "has close match"@en ;
  rdfs:isDefinedBy <http://www.w3.org/2004/02/skos/core> ;
  skos:definition "skos:closeMatch is used to link two concepts that are sufficiently similar that they can be used interchangeably in some information retrieval applications. In order to avoid the possibility of 'compound errors' when combining mappings across more than two concept schemes, skos:closeMatch is not declared to be a transitive property."@en ;
  a owl:ObjectProperty, owl:SymmetricProperty, rdf:Property ;
  rdfs:subPropertyOf skos:mappingRelation .`;

export const sparql = `@prefix sparql: <https://w3id.org/sparql-syntax#> .
@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix xsd: <http://www.w3.org/2001/XMLSchema#> .
@prefix dct: <http://purl.org/dc/terms/> .

#
# SPARQL Syntax Vocabulary
#
# A vocabulary for representing the syntax of SPARQL 1.2 queries and updates
# as RDF, modeled on the grammar of the SPARQL 1.2 Query Language
# (https://www.w3.org/TR/sparql12-query/#sparqlGrammar) and SPARQL 1.2 Update.
#
# Modeling decisions:
# - IRIs and literals occurring in a query appear as themselves (native RDF
#   terms); prefixed names and relative IRIs are resolved against the prologue.
#   Prefix and base declarations are not reified.
# - Variables are blank nodes typed sparql:Variable with sparql:varName; one node is
#   shared per distinct variable name per query.
# - Blank nodes written in query syntax are nodes typed sparql:BlankNode (with
#   sparql:label when labeled), distinct from the structural blank nodes that
#   make up the representation itself.
# - Ordered constructs (pattern elements, projections, templates, arguments,
#   path elements, VALUES rows, update operation sequences) use rdf:List.
#   Unordered repeatable clauses (FROM, USING) use repeated properties.
# - Syntactic sugar is desugared the way the SPARQL 1.2 spec does: collections
#   and blank node property lists expand to triple patterns; reified triples
#   and annotation blocks expand to rdf:reifies triple patterns. Triple terms
#   are represented structurally as sparql:TripleTerm nodes because their
#   components may be variables.
#

<https://w3id.org/sparql-syntax> a owl:Ontology ;
    dct:title "SPARQL Syntax Vocabulary"@en ;
    rdfs:comment "A vocabulary for representing the syntax of SPARQL 1.2 queries and updates as RDF."@en ;
    rdfs:seeAlso <https://www.w3.org/TR/sparql12-query/> , <https://www.w3.org/TR/sparql12-update/> ;
    owl:versionInfo "1.0.0" .

# ==========================================
# Query forms
# ==========================================

sparql:Query a rdfs:Class ;
    rdfs:label "Query"@en ;
    rdfs:comment "Abstract superclass of the four SPARQL query forms."@en .

sparql:SelectQuery a rdfs:Class ;
    rdfs:subClassOf sparql:Query ;
    rdfs:label "SELECT query"@en ;
    rdfs:comment "A SELECT query. SPARQL 1.2 grammar production [9]."@en .

sparql:ConstructQuery a rdfs:Class ;
    rdfs:subClassOf sparql:Query ;
    rdfs:label "CONSTRUCT query"@en ;
    rdfs:comment "A CONSTRUCT query. SPARQL 1.2 grammar production [12]."@en .

sparql:DescribeQuery a rdfs:Class ;
    rdfs:subClassOf sparql:Query ;
    rdfs:label "DESCRIBE query"@en ;
    rdfs:comment "A DESCRIBE query. SPARQL 1.2 grammar production [13]."@en .

sparql:AskQuery a rdfs:Class ;
    rdfs:subClassOf sparql:Query ;
    rdfs:label "ASK query"@en ;
    rdfs:comment "An ASK query. SPARQL 1.2 grammar production [14]."@en .

sparql:SubSelect a rdfs:Class ;
    rdfs:label "Sub-select"@en ;
    rdfs:comment "A sub-select appearing as a group graph pattern element. SPARQL 1.2 grammar production [10]."@en .

# ==========================================
# Update operations
# ==========================================

sparql:Update a rdfs:Class ;
    rdfs:label "Update request"@en ;
    rdfs:comment "The root node of a SPARQL update request; holds the ordered sequence of update operations. SPARQL 1.2 Update grammar production [31]."@en .

sparql:Load a rdfs:Class ;
    rdfs:label "LOAD"@en ;
    rdfs:comment "A LOAD operation. SPARQL 1.2 Update grammar production [33]."@en .

sparql:Clear a rdfs:Class ;
    rdfs:label "CLEAR"@en ;
    rdfs:comment "A CLEAR operation. SPARQL 1.2 Update grammar production [34]."@en .

sparql:Drop a rdfs:Class ;
    rdfs:label "DROP"@en ;
    rdfs:comment "A DROP operation. SPARQL 1.2 Update grammar production [35]."@en .

sparql:Create a rdfs:Class ;
    rdfs:label "CREATE"@en ;
    rdfs:comment "A CREATE operation. SPARQL 1.2 Update grammar production [36]."@en .

sparql:Add a rdfs:Class ;
    rdfs:label "ADD"@en ;
    rdfs:comment "An ADD operation. SPARQL 1.2 Update grammar production [37]."@en .

sparql:Move a rdfs:Class ;
    rdfs:label "MOVE"@en ;
    rdfs:comment "A MOVE operation. SPARQL 1.2 Update grammar production [38]."@en .

sparql:Copy a rdfs:Class ;
    rdfs:label "COPY"@en ;
    rdfs:comment "A COPY operation. SPARQL 1.2 Update grammar production [39]."@en .

sparql:InsertData a rdfs:Class ;
    rdfs:label "INSERT DATA"@en ;
    rdfs:comment "An INSERT DATA operation. SPARQL 1.2 Update grammar production [40]."@en .

sparql:DeleteData a rdfs:Class ;
    rdfs:label "DELETE DATA"@en ;
    rdfs:comment "A DELETE DATA operation. SPARQL 1.2 Update grammar production [41]."@en .

sparql:DeleteWhere a rdfs:Class ;
    rdfs:label "DELETE WHERE"@en ;
    rdfs:comment "A DELETE WHERE operation. SPARQL 1.2 Update grammar production [42]."@en .

sparql:Modify a rdfs:Class ;
    rdfs:label "DELETE/INSERT"@en ;
    rdfs:comment "A DELETE/INSERT operation with a WHERE clause. SPARQL 1.2 Update grammar production [43]."@en .

# ==========================================
# Terms
# ==========================================

sparql:Variable a rdfs:Class ;
    rdfs:label "Variable"@en ;
    rdfs:comment "A SPARQL variable (?name or $name). One node is shared per distinct variable name within a query."@en .

sparql:BlankNode a rdfs:Class ;
    rdfs:label "Blank node"@en ;
    rdfs:comment "A blank node written in query syntax (_:label, [], [...] or a collection cell), as opposed to the structural blank nodes of the representation itself."@en .

sparql:TripleTerm a rdfs:Class ;
    rdfs:label "Triple term"@en ;
    rdfs:comment "An RDF 1.2 triple term <<( s p o )>>. Represented structurally because its components may be variables. SPARQL 1.2 grammar production [113]."@en .

# ==========================================
# Graph pattern elements
# ==========================================

sparql:TriplePattern a rdfs:Class ;
    rdfs:label "Triple pattern"@en ;
    rdfs:comment "A single subject-predicate-object pattern or template triple."@en .

sparql:Group a rdfs:Class ;
    rdfs:label "Group"@en ;
    rdfs:comment "An explicit nested group graph pattern { ... }, including the branches of a UNION. SPARQL 1.2 grammar production [55]."@en .

sparql:Optional a rdfs:Class ;
    rdfs:label "OPTIONAL"@en ;
    rdfs:comment "An OPTIONAL graph pattern. SPARQL 1.2 grammar production [60]."@en .

sparql:Union a rdfs:Class ;
    rdfs:label "UNION"@en ;
    rdfs:comment "A UNION of two or more group graph patterns. SPARQL 1.2 grammar production [70]."@en .

sparql:Minus a rdfs:Class ;
    rdfs:label "MINUS"@en ;
    rdfs:comment "A MINUS graph pattern. SPARQL 1.2 grammar production [69]."@en .

sparql:Graph a rdfs:Class ;
    rdfs:label "GRAPH"@en ;
    rdfs:comment "A GRAPH graph pattern, also used for GRAPH blocks inside update quad templates. SPARQL 1.2 grammar production [61]."@en .

sparql:Service a rdfs:Class ;
    rdfs:label "SERVICE"@en ;
    rdfs:comment "A SERVICE graph pattern. SPARQL 1.2 grammar production [62]."@en .

sparql:Filter a rdfs:Class ;
    rdfs:label "FILTER"@en ;
    rdfs:comment "A FILTER constraint. SPARQL 1.2 grammar production [71]."@en .

sparql:Bind a rdfs:Class ;
    rdfs:label "BIND"@en ;
    rdfs:comment "A BIND assignment. SPARQL 1.2 grammar production [63]."@en .

sparql:Values a rdfs:Class ;
    rdfs:label "VALUES"@en ;
    rdfs:comment "An inline data block (VALUES), either inside a group graph pattern or trailing a query. SPARQL 1.2 grammar productions [64]-[67]."@en .

sparql:Exists a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "EXISTS"@en ;
    rdfs:comment "An EXISTS expression with an embedded graph pattern. SPARQL 1.2 grammar production [135]."@en .

sparql:NotExists a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "NOT EXISTS"@en ;
    rdfs:comment "A NOT EXISTS expression with an embedded graph pattern. SPARQL 1.2 grammar production [136]."@en .

# ==========================================
# Property paths
# ==========================================

sparql:SeqPath a rdfs:Class ;
    rdfs:label "Sequence path"@en ;
    rdfs:comment "A property path sequence (elt1 / elt2). SPARQL 1.2 grammar production [93]."@en .

sparql:AltPath a rdfs:Class ;
    rdfs:label "Alternative path"@en ;
    rdfs:comment "A property path alternative (elt1 | elt2). SPARQL 1.2 grammar production [92]."@en .

sparql:InversePath a rdfs:Class ;
    rdfs:label "Inverse path"@en ;
    rdfs:comment "An inverse property path (^elt). SPARQL 1.2 grammar production [95]."@en .

sparql:ZeroOrMorePath a rdfs:Class ;
    rdfs:label "Zero-or-more path"@en ;
    rdfs:comment "A property path with the * modifier. SPARQL 1.2 grammar production [96]."@en .

sparql:OneOrMorePath a rdfs:Class ;
    rdfs:label "One-or-more path"@en ;
    rdfs:comment "A property path with the + modifier. SPARQL 1.2 grammar production [96]."@en .

sparql:ZeroOrOnePath a rdfs:Class ;
    rdfs:label "Zero-or-one path"@en ;
    rdfs:comment "A property path with the ? modifier. SPARQL 1.2 grammar production [96]."@en .

sparql:NegatedPath a rdfs:Class ;
    rdfs:label "Negated property set"@en ;
    rdfs:comment "A negated property set (!iri or !(iri1 | ^iri2 | ...)). SPARQL 1.2 grammar production [98]."@en .

# ==========================================
# Expressions
# ==========================================

sparql:Expression a rdfs:Class ;
    rdfs:label "Expression"@en ;
    rdfs:comment "Abstract superclass of all compound SPARQL expressions. Atomic expressions (variables, IRIs, literals) appear directly as terms."@en .

sparql:Or a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Logical or"@en ;
    rdfs:comment "A logical || expression."@en .

sparql:And a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Logical and"@en ;
    rdfs:comment "A logical && expression."@en .

sparql:Eq a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Equal"@en ;
    rdfs:comment "An = comparison."@en .

sparql:Neq a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Not equal"@en ;
    rdfs:comment "A != comparison."@en .

sparql:Lt a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Less than"@en ;
    rdfs:comment "A < comparison."@en .

sparql:Gt a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Greater than"@en ;
    rdfs:comment "A > comparison."@en .

sparql:Leq a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Less than or equal"@en ;
    rdfs:comment "A <= comparison."@en .

sparql:Geq a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Greater than or equal"@en ;
    rdfs:comment "A >= comparison."@en .

sparql:In a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "IN"@en ;
    rdfs:comment "An IN expression; sparql:arg1 holds the tested expression, sparql:args the list of candidates."@en .

sparql:NotIn a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "NOT IN"@en ;
    rdfs:comment "A NOT IN expression; sparql:arg1 holds the tested expression, sparql:args the list of candidates."@en .

sparql:Addition a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Addition"@en ;
    rdfs:comment "An arithmetic + expression."@en .

sparql:Subtraction a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Subtraction"@en ;
    rdfs:comment "An arithmetic - expression."@en .

sparql:Multiplication a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Multiplication"@en ;
    rdfs:comment "An arithmetic * expression."@en .

sparql:Division a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Division"@en ;
    rdfs:comment "An arithmetic / expression."@en .

sparql:UnaryNot a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Unary not"@en ;
    rdfs:comment "A unary ! expression."@en .

sparql:UnaryPlus a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Unary plus"@en ;
    rdfs:comment "A unary + expression."@en .

sparql:UnaryMinus a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Unary minus"@en ;
    rdfs:comment "A unary - expression."@en .

sparql:FunctionCall a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Function call"@en ;
    rdfs:comment "A call of a custom function identified by IRI. SPARQL 1.2 grammar production [73]."@en .

sparql:BuiltInCall a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Built-in call"@en ;
    rdfs:comment "A call of a SPARQL built-in function; sparql:function points to the built-in function individual. SPARQL 1.2 grammar production [131]."@en .

sparql:BuiltInFunction a rdfs:Class ;
    rdfs:label "Built-in function"@en ;
    rdfs:comment "The class of SPARQL built-in function individuals."@en .

# ==========================================
# Aggregates
# ==========================================

sparql:Aggregate a rdfs:Class ;
    rdfs:subClassOf sparql:Expression ;
    rdfs:label "Aggregate"@en ;
    rdfs:comment "Abstract superclass of the SPARQL aggregates. SPARQL 1.2 grammar production [137]."@en .

sparql:Count a rdfs:Class ;
    rdfs:subClassOf sparql:Aggregate ;
    rdfs:label "COUNT"@en .

sparql:Sum a rdfs:Class ;
    rdfs:subClassOf sparql:Aggregate ;
    rdfs:label "SUM"@en .

sparql:Min a rdfs:Class ;
    rdfs:subClassOf sparql:Aggregate ;
    rdfs:label "MIN"@en .

sparql:Max a rdfs:Class ;
    rdfs:subClassOf sparql:Aggregate ;
    rdfs:label "MAX"@en .

sparql:Avg a rdfs:Class ;
    rdfs:subClassOf sparql:Aggregate ;
    rdfs:label "AVG"@en .

sparql:Sample a rdfs:Class ;
    rdfs:subClassOf sparql:Aggregate ;
    rdfs:label "SAMPLE"@en .

sparql:GroupConcat a rdfs:Class ;
    rdfs:subClassOf sparql:Aggregate ;
    rdfs:label "GROUP_CONCAT"@en .

# ==========================================
# Miscellaneous structure
# ==========================================

sparql:Alias a rdfs:Class ;
    rdfs:label "Alias"@en ;
    rdfs:comment "An (expression AS ?variable) alias in a SELECT clause or GROUP BY condition."@en .

sparql:Asc a rdfs:Class ;
    rdfs:label "Ascending"@en ;
    rdfs:comment "An explicit ASC(...) order condition."@en .

sparql:Desc a rdfs:Class ;
    rdfs:label "Descending"@en ;
    rdfs:comment "A DESC(...) order condition."@en .

# ==========================================
# Named individuals
# ==========================================

sparql:undef a rdfs:Resource ;
    rdfs:label "UNDEF"@en ;
    rdfs:comment "The UNDEF marker in a VALUES binding row."@en .

sparql:DefaultGraph a rdfs:Resource ;
    rdfs:label "DEFAULT"@en ;
    rdfs:comment "The default graph as target of an update operation (DEFAULT keyword)."@en .

sparql:NamedGraphs a rdfs:Resource ;
    rdfs:label "NAMED"@en ;
    rdfs:comment "All named graphs as target of CLEAR or DROP (NAMED keyword)."@en .

sparql:AllGraphs a rdfs:Resource ;
    rdfs:label "ALL"@en ;
    rdfs:comment "All graphs as target of CLEAR or DROP (ALL keyword)."@en .

# ==========================================
# Properties
# ==========================================

sparql:version a rdf:Property ;
    rdfs:label "version"@en ;
    rdfs:comment "The version string of a VERSION declaration. SPARQL 1.2 grammar production [7]."@en ;
    rdfs:range xsd:string .

sparql:where a rdf:Property ;
    rdfs:label "where"@en ;
    rdfs:comment "The WHERE clause of a query, sub-select, DELETE/INSERT or DELETE WHERE operation: an rdf:List of graph pattern elements."@en ;
    rdfs:range rdf:List .

sparql:projection a rdf:Property ;
    rdfs:label "projection"@en ;
    rdfs:comment "The projection of a SELECT query: an rdf:List of sparql:Variable or sparql:Alias nodes."@en ;
    rdfs:range rdf:List .

sparql:star a rdf:Property ;
    rdfs:label "star"@en ;
    rdfs:comment "True if the query uses SELECT * or DESCRIBE *."@en ;
    rdfs:range xsd:boolean .

sparql:distinct a rdf:Property ;
    rdfs:label "distinct"@en ;
    rdfs:comment "True if the SELECT clause, aggregate or argument list carries the DISTINCT modifier."@en ;
    rdfs:range xsd:boolean .

sparql:reduced a rdf:Property ;
    rdfs:label "reduced"@en ;
    rdfs:comment "True if the SELECT clause carries the REDUCED modifier."@en ;
    rdfs:domain sparql:SelectQuery ;
    rdfs:range xsd:boolean .

sparql:template a rdf:Property ;
    rdfs:label "template"@en ;
    rdfs:comment "The template of a CONSTRUCT query: an rdf:List of sparql:TriplePattern nodes."@en ;
    rdfs:domain sparql:ConstructQuery ;
    rdfs:range rdf:List .

sparql:describeTargets a rdf:Property ;
    rdfs:label "describe targets"@en ;
    rdfs:comment "The targets of a DESCRIBE query: an rdf:List of sparql:Variable nodes or IRIs."@en ;
    rdfs:domain sparql:DescribeQuery ;
    rdfs:range rdf:List .

sparql:from a rdf:Property ;
    rdfs:label "from"@en ;
    rdfs:comment "A FROM dataset clause IRI (repeated for multiple clauses)."@en .

sparql:fromNamed a rdf:Property ;
    rdfs:label "from named"@en ;
    rdfs:comment "A FROM NAMED dataset clause IRI (repeated for multiple clauses)."@en .

sparql:subject a rdf:Property ;
    rdfs:label "subject"@en ;
    rdfs:comment "The subject of a triple pattern or triple term."@en .

sparql:predicate a rdf:Property ;
    rdfs:label "predicate"@en ;
    rdfs:comment "The predicate of a triple pattern or triple term: an IRI, sparql:Variable, or property path node."@en .

sparql:object a rdf:Property ;
    rdfs:label "object"@en ;
    rdfs:comment "The object of a triple pattern or triple term."@en .

sparql:elements a rdf:Property ;
    rdfs:label "elements"@en ;
    rdfs:comment "The ordered elements of a group, OPTIONAL, MINUS, GRAPH, SERVICE, EXISTS, NOT EXISTS or UNION: an rdf:List."@en ;
    rdfs:range rdf:List .

sparql:graph a rdf:Property ;
    rdfs:label "graph"@en ;
    rdfs:comment "The graph name (variable or IRI) of a GRAPH pattern or graph block, or the IRI of a CREATE or GRAPH reference."@en .

sparql:endpoint a rdf:Property ;
    rdfs:label "endpoint"@en ;
    rdfs:comment "The endpoint (variable or IRI) of a SERVICE pattern."@en ;
    rdfs:domain sparql:Service .

sparql:silent a rdf:Property ;
    rdfs:label "silent"@en ;
    rdfs:comment "True if the operation or SERVICE pattern carries the SILENT modifier."@en ;
    rdfs:range xsd:boolean .

sparql:expression a rdf:Property ;
    rdfs:label "expression"@en ;
    rdfs:comment "The expression of a FILTER, BIND, alias, order condition or aggregate."@en .

sparql:variable a rdf:Property ;
    rdfs:label "variable"@en ;
    rdfs:comment "The target variable of a BIND or alias."@en ;
    rdfs:range sparql:Variable .

sparql:varName a rdf:Property ;
    rdfs:label "variable name"@en ;
    rdfs:comment "The name of a variable, without the ? or $ sigil."@en ;
    rdfs:domain sparql:Variable ;
    rdfs:range xsd:string .

sparql:label a rdf:Property ;
    rdfs:label "label"@en ;
    rdfs:comment "The label of a syntactic blank node, without the _: prefix. Absent for anonymous blank nodes."@en ;
    rdfs:domain sparql:BlankNode ;
    rdfs:range xsd:string .

sparql:arg a rdf:Property ;
    rdfs:label "argument"@en ;
    rdfs:comment "The operand of a unary operator expression."@en .

sparql:arg1 a rdf:Property ;
    rdfs:label "first argument"@en ;
    rdfs:comment "The left operand of a binary operator expression."@en .

sparql:arg2 a rdf:Property ;
    rdfs:label "second argument"@en ;
    rdfs:comment "The right operand of a binary operator expression."@en .

sparql:args a rdf:Property ;
    rdfs:label "arguments"@en ;
    rdfs:comment "The ordered arguments of a function call, built-in call, or IN/NOT IN expression: an rdf:List."@en ;
    rdfs:range rdf:List .

sparql:function a rdf:Property ;
    rdfs:label "function"@en ;
    rdfs:comment "The function of a call: an IRI for custom functions, a sparql:BuiltInFunction individual for built-ins."@en .

sparql:groupBy a rdf:Property ;
    rdfs:label "group by"@en ;
    rdfs:comment "The GROUP BY conditions: an rdf:List of variables, expressions or sparql:Alias nodes."@en ;
    rdfs:range rdf:List .

sparql:having a rdf:Property ;
    rdfs:label "having"@en ;
    rdfs:comment "The HAVING conditions: an rdf:List of expressions."@en ;
    rdfs:range rdf:List .

sparql:orderBy a rdf:Property ;
    rdfs:label "order by"@en ;
    rdfs:comment "The ORDER BY conditions: an rdf:List of variables, expressions, or sparql:Asc/sparql:Desc nodes."@en ;
    rdfs:range rdf:List .

sparql:limit a rdf:Property ;
    rdfs:label "limit"@en ;
    rdfs:comment "The LIMIT of a query."@en ;
    rdfs:range xsd:integer .

sparql:offset a rdf:Property ;
    rdfs:label "offset"@en ;
    rdfs:comment "The OFFSET of a query."@en ;
    rdfs:range xsd:integer .

sparql:values a rdf:Property ;
    rdfs:label "values"@en ;
    rdfs:comment "The trailing VALUES clause of a query or sub-select."@en ;
    rdfs:range sparql:Values .

sparql:variables a rdf:Property ;
    rdfs:label "variables"@en ;
    rdfs:comment "The variables of a VALUES block: an rdf:List of sparql:Variable nodes."@en ;
    rdfs:domain sparql:Values ;
    rdfs:range rdf:List .

sparql:bindings a rdf:Property ;
    rdfs:label "bindings"@en ;
    rdfs:comment "The binding rows of a VALUES block: an rdf:List of rows, each row an rdf:List of terms or sparql:undef."@en ;
    rdfs:domain sparql:Values ;
    rdfs:range rdf:List .

sparql:pathElements a rdf:Property ;
    rdfs:label "path elements"@en ;
    rdfs:comment "The ordered sub-paths of a sequence, alternative or negated property path: an rdf:List."@en ;
    rdfs:range rdf:List .

sparql:path a rdf:Property ;
    rdfs:label "path"@en ;
    rdfs:comment "The sub-path of an inverse or modified property path."@en .

sparql:countStar a rdf:Property ;
    rdfs:label "count star"@en ;
    rdfs:comment "True for COUNT(*)."@en ;
    rdfs:domain sparql:Count ;
    rdfs:range xsd:boolean .

sparql:separator a rdf:Property ;
    rdfs:label "separator"@en ;
    rdfs:comment "The SEPARATOR of a GROUP_CONCAT aggregate."@en ;
    rdfs:domain sparql:GroupConcat ;
    rdfs:range xsd:string .

sparql:operations a rdf:Property ;
    rdfs:label "operations"@en ;
    rdfs:comment "The ordered update operations of an update request: an rdf:List."@en ;
    rdfs:domain sparql:Update ;
    rdfs:range rdf:List .

sparql:source a rdf:Property ;
    rdfs:label "source"@en ;
    rdfs:comment "The source document IRI of a LOAD operation."@en ;
    rdfs:domain sparql:Load .

sparql:into a rdf:Property ;
    rdfs:label "into"@en ;
    rdfs:comment "The target graph IRI of a LOAD ... INTO GRAPH operation."@en ;
    rdfs:domain sparql:Load .

sparql:graphTarget a rdf:Property ;
    rdfs:label "graph target"@en ;
    rdfs:comment "The target of a CLEAR or DROP operation: a graph IRI, sparql:DefaultGraph, sparql:NamedGraphs or sparql:AllGraphs."@en .

sparql:fromGraph a rdf:Property ;
    rdfs:label "from graph"@en ;
    rdfs:comment "The source graph of an ADD, MOVE or COPY operation: a graph IRI or sparql:DefaultGraph."@en .

sparql:toGraph a rdf:Property ;
    rdfs:label "to graph"@en ;
    rdfs:comment "The target graph of an ADD, MOVE or COPY operation: a graph IRI or sparql:DefaultGraph."@en .

sparql:data a rdf:Property ;
    rdfs:label "data"@en ;
    rdfs:comment "The quad data of an INSERT DATA or DELETE DATA operation: an rdf:List of sparql:TriplePattern and sparql:Graph nodes."@en ;
    rdfs:range rdf:List .

sparql:deleteTemplate a rdf:Property ;
    rdfs:label "delete template"@en ;
    rdfs:comment "The DELETE template of a DELETE/INSERT operation: an rdf:List of sparql:TriplePattern and sparql:Graph nodes."@en ;
    rdfs:domain sparql:Modify ;
    rdfs:range rdf:List .

sparql:insertTemplate a rdf:Property ;
    rdfs:label "insert template"@en ;
    rdfs:comment "The INSERT template of a DELETE/INSERT operation: an rdf:List of sparql:TriplePattern and sparql:Graph nodes."@en ;
    rdfs:domain sparql:Modify ;
    rdfs:range rdf:List .

sparql:withGraph a rdf:Property ;
    rdfs:label "with graph"@en ;
    rdfs:comment "The WITH graph IRI of a DELETE/INSERT operation."@en ;
    rdfs:domain sparql:Modify .

sparql:using a rdf:Property ;
    rdfs:label "using"@en ;
    rdfs:comment "A USING clause IRI of a DELETE/INSERT operation (repeated for multiple clauses)."@en ;
    rdfs:domain sparql:Modify .

sparql:usingNamed a rdf:Property ;
    rdfs:label "using named"@en ;
    rdfs:comment "A USING NAMED clause IRI of a DELETE/INSERT operation (repeated for multiple clauses)."@en ;
    rdfs:domain sparql:Modify .

# ==========================================
# Built-in function individuals
# ==========================================

sparql:STR a sparql:BuiltInFunction ; rdfs:label "STR" .
sparql:LANG a sparql:BuiltInFunction ; rdfs:label "LANG" .
sparql:LANGMATCHES a sparql:BuiltInFunction ; rdfs:label "LANGMATCHES" .
sparql:LANGDIR a sparql:BuiltInFunction ; rdfs:label "LANGDIR" .
sparql:DATATYPE a sparql:BuiltInFunction ; rdfs:label "DATATYPE" .
sparql:IRI a sparql:BuiltInFunction ; rdfs:label "IRI" .
sparql:URI a sparql:BuiltInFunction ; rdfs:label "URI" .
sparql:BNODE a sparql:BuiltInFunction ; rdfs:label "BNODE" .
sparql:BOUND a sparql:BuiltInFunction ; rdfs:label "BOUND" .
sparql:STRLEN a sparql:BuiltInFunction ; rdfs:label "STRLEN" .
sparql:UCASE a sparql:BuiltInFunction ; rdfs:label "UCASE" .
sparql:LCASE a sparql:BuiltInFunction ; rdfs:label "LCASE" .
sparql:ENCODE_FOR_URI a sparql:BuiltInFunction ; rdfs:label "ENCODE_FOR_URI" .
sparql:CONTAINS a sparql:BuiltInFunction ; rdfs:label "CONTAINS" .
sparql:STRSTARTS a sparql:BuiltInFunction ; rdfs:label "STRSTARTS" .
sparql:CONCAT a sparql:BuiltInFunction ; rdfs:label "CONCAT" .
sparql:STRENDS a sparql:BuiltInFunction ; rdfs:label "STRENDS" .
sparql:STRBEFORE a sparql:BuiltInFunction ; rdfs:label "STRBEFORE" .
sparql:STRAFTER a sparql:BuiltInFunction ; rdfs:label "STRAFTER" .
sparql:STRLANG a sparql:BuiltInFunction ; rdfs:label "STRLANG" .
sparql:STRLANGDIR a sparql:BuiltInFunction ; rdfs:label "STRLANGDIR" .
sparql:STRDT a sparql:BuiltInFunction ; rdfs:label "STRDT" .
sparql:ABS a sparql:BuiltInFunction ; rdfs:label "ABS" .
sparql:CEIL a sparql:BuiltInFunction ; rdfs:label "CEIL" .
sparql:FLOOR a sparql:BuiltInFunction ; rdfs:label "FLOOR" .
sparql:ROUND a sparql:BuiltInFunction ; rdfs:label "ROUND" .
sparql:RAND a sparql:BuiltInFunction ; rdfs:label "RAND" .
sparql:YEAR a sparql:BuiltInFunction ; rdfs:label "YEAR" .
sparql:MONTH a sparql:BuiltInFunction ; rdfs:label "MONTH" .
sparql:DAY a sparql:BuiltInFunction ; rdfs:label "DAY" .
sparql:HOURS a sparql:BuiltInFunction ; rdfs:label "HOURS" .
sparql:MINUTES a sparql:BuiltInFunction ; rdfs:label "MINUTES" .
sparql:SECONDS a sparql:BuiltInFunction ; rdfs:label "SECONDS" .
sparql:TIMEZONE a sparql:BuiltInFunction ; rdfs:label "TIMEZONE" .
sparql:TZ a sparql:BuiltInFunction ; rdfs:label "TZ" .
sparql:NOW a sparql:BuiltInFunction ; rdfs:label "NOW" .
sparql:MD5 a sparql:BuiltInFunction ; rdfs:label "MD5" .
sparql:SHA1 a sparql:BuiltInFunction ; rdfs:label "SHA1" .
sparql:SHA256 a sparql:BuiltInFunction ; rdfs:label "SHA256" .
sparql:SHA384 a sparql:BuiltInFunction ; rdfs:label "SHA384" .
sparql:SHA512 a sparql:BuiltInFunction ; rdfs:label "SHA512" .
sparql:sameTerm a sparql:BuiltInFunction ; rdfs:label "sameTerm" .
sparql:isIRI a sparql:BuiltInFunction ; rdfs:label "isIRI" .
sparql:isURI a sparql:BuiltInFunction ; rdfs:label "isURI" .
sparql:isBLANK a sparql:BuiltInFunction ; rdfs:label "isBLANK" .
sparql:isLITERAL a sparql:BuiltInFunction ; rdfs:label "isLITERAL" .
sparql:isNUMERIC a sparql:BuiltInFunction ; rdfs:label "isNUMERIC" .
sparql:COALESCE a sparql:BuiltInFunction ; rdfs:label "COALESCE" .
sparql:IF a sparql:BuiltInFunction ; rdfs:label "IF" .
sparql:UUID a sparql:BuiltInFunction ; rdfs:label "UUID" .
sparql:STRUUID a sparql:BuiltInFunction ; rdfs:label "STRUUID" .
sparql:isTRIPLE a sparql:BuiltInFunction ; rdfs:label "isTRIPLE" .
sparql:TRIPLE a sparql:BuiltInFunction ; rdfs:label "TRIPLE" .
sparql:SUBJECT a sparql:BuiltInFunction ; rdfs:label "SUBJECT" .
sparql:PREDICATE a sparql:BuiltInFunction ; rdfs:label "PREDICATE" .
sparql:OBJECT a sparql:BuiltInFunction ; rdfs:label "OBJECT" .
sparql:hasLANG a sparql:BuiltInFunction ; rdfs:label "hasLANG" .
sparql:hasLANGDIR a sparql:BuiltInFunction ; rdfs:label "hasLANGDIR" .
sparql:REGEX a sparql:BuiltInFunction ; rdfs:label "REGEX" .
sparql:SUBSTR a sparql:BuiltInFunction ; rdfs:label "SUBSTR" .
sparql:REPLACE a sparql:BuiltInFunction ; rdfs:label "REPLACE" .
`;

export const xsd = `@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix xsd: <http://www.w3.org/2001/XMLSchema#> .
@prefix vann: <http://purl.org/vocab/vann/> .

xsd: a owl:Ontology ;
    rdfs:label "W3C XML Schema Definition Language (XSD) 1.1 Part 2: Datatypes" ;
    rdfs:seeAlso <https://www.w3.org/TR/xmlschema11-2/#built-in-primitive-datatypes> .

xsd:anyURI a rdfs:Datatype ;
    rdfs:comment "anyURI represents an Internationalized Resource Identifier Reference (IRI).  An anyURI value can be absolute or relative, and may have an optional fragment identifier (i.e., it may be an IRI Reference).  This type should be used when the value fulfills the role of an IRI, as defined in [RFC 3987] or its successor(s) in the IETF Standards Track." .

xsd:base64Binary a rdfs:Datatype ;
    rdfs:comment "base64Binary represents arbitrary Base64-encoded binary data.  For base64Binary data the entire binary stream is encoded using the Base64 Encoding defined in [RFC 3548], which is derived from the encoding described in [RFC 2045]." .

xsd:boolean a rdfs:Datatype ;
    rdfs:comment "boolean represents the values of two-valued logic." .

xsd:byte a rdfs:Datatype ;
    rdfs:comment "byte is ·derived· from short by setting the value of ·maxInclusive· to be 127 and ·minInclusive· to be -128. The ·base type· of byte is short." .

xsd:date a rdfs:Datatype ;
    rdfs:comment "date represents top-open intervals of exactly one day in length on the timelines of dateTime, beginning on the beginning moment of each day, up to but not including the beginning moment of the next day).  For non-timezoned values, the top-open intervals disjointly cover the non-timezoned timeline, one per day.  For timezoned values, the intervals begin at every minute and therefore overlap." .

xsd:dateTime a rdfs:Datatype ;
    rdfs:comment "dateTime represents instants of time, optionally marked with a particular time zone offset.  Values representing the same instant but having different time zone offsets are equal but not identical." .

xsd:decimal a rdfs:Datatype ;
    rdfs:comment "decimal represents a subset of the real numbers, which can be represented by decimal numerals. The ·value space· of decimal is the set of numbers that can be obtained by dividing an integer by a non-negative power of ten, i.e., expressible as i / 10n where i and n are integers and n ≥ 0. Precision is not reflected in this value space; the number 2.0 is not distinct from the number 2.00. The order relation on decimal is the order relation on real numbers, restricted to this subset." .

xsd:double a rdfs:Datatype ;
    rdfs:comment "The double datatype is patterned after the IEEE double-precision 64-bit floating point datatype [IEEE 754-2008].  Each floating point datatype has a value space that is a subset of the rational numbers.  Floating point numbers are often used to approximate arbitrary real numbers." .

xsd:duration a rdfs:Datatype ;
    rdfs:comment "duration is a datatype that represents durations of time.  The concept of duration being captured is drawn from those of [ISO 8601], specifically durations without fixed endpoints." .

xsd:float a rdfs:Datatype ;
    rdfs:comment "The float datatype is patterned after the IEEE single-precision 32-bit floating point datatype [IEEE 754-2008].  Its value space is a subset of the rational numbers.  Floating point numbers are often used to approximate arbitrary real numbers." .

xsd:int a rdfs:Datatype ;
    rdfs:comment "int is ·derived· from long by setting the value of ·maxInclusive· to be 2147483647 and ·minInclusive· to be -2147483648.  The ·base type· of int is long." .

xsd:integer a rdfs:Datatype ;
    rdfs:comment "integer is ·derived· from decimal by fixing the value of ·fractionDigits· to be 0 and disallowing the trailing decimal point.  This results in the standard mathematical concept of the integer numbers.  The ·value space· of integer is the infinite set {...,-2,-1,0,1,2,...}.  The ·base type· of integer is decimal." .

xsd:long a rdfs:Datatype ;
    rdfs:comment "long is ·derived· from integer by setting the value of ·maxInclusive· to be 9223372036854775807 and ·minInclusive· to be -9223372036854775808. The ·base type· of long is integer." .

xsd:negativeInteger a rdfs:Datatype ;
    rdfs:comment "negativeInteger is ·derived· from nonPositiveInteger by setting the value of ·maxInclusive· to be -1.  This results in the standard mathematical concept of the negative integers.  The ·value space· of negativeInteger is the infinite set {...,-2,-1}.  The ·base type· of negativeInteger is nonPositiveInteger." .

xsd:nonNegativeInteger a rdfs:Datatype .

xsd:nonPositiveInteger a rdfs:Datatype ;
    rdfs:comment "nonPositiveInteger is ·derived· from integer by setting the value of ·maxInclusive· to be 0.  This results in the standard mathematical concept of the non-positive integers. The ·value space· of nonPositiveInteger is the infinite set {...,-2,-1,0}.  The ·base type· of nonPositiveInteger is integer." .

xsd:positiveInteger a rdfs:Datatype ;
    rdfs:comment "nonNegativeInteger is ·derived· from integer by setting the value of ·minInclusive· to be 0.  This results in the standard mathematical concept of the non-negative integers. The ·value space· of nonNegativeInteger is the infinite set {0,1,2,...}.  The ·base type· of nonNegativeInteger is integer." .

xsd:short a rdfs:Datatype ;
    rdfs:comment "short is ·derived· from int by setting the value of ·maxInclusive· to be 32767 and ·minInclusive· to be -32768.  The ·base type· of short is int." .

xsd:string a rdfs:Datatype ;
    rdfs:comment "The string datatype represents character strings in XML." .

xsd:time a rdfs:Datatype ;
    rdfs:comment "time represents instants of time that recur at the same point in each calendar day, or that occur in some arbitrary calendar day." .

xsd:unsignedInt a rdfs:Datatype ;
    rdfs:comment "unsignedInt is ·derived· from unsignedLong by setting the value of ·maxInclusive· to be 4294967295.  The ·base type· of unsignedInt is unsignedLong." .

xsd:unsignedShort a rdfs:Datatype ;
    rdfs:comment "unsignedShort is ·derived· from unsignedInt by setting the value of ·maxInclusive· to be 65535.  The ·base type· of unsignedShort is unsignedInt." .

xsd:unsingedLong a rdfs:Datatype ;
    rdfs:comment "unsignedLong is ·derived· from nonNegativeInteger by setting the value of ·maxInclusive· to be 18446744073709551615.  The ·base type· of unsignedLong is nonNegativeInteger." .

xsd:usignedByte a rdfs:Datatype ;
    rdfs:comment "unsignedByte is ·derived· from unsignedShort by setting the value of ·maxInclusive· to be 255.  The ·base type· of unsignedByte is unsignedShort." .`;

